!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t ())
    : 'function' == typeof define && define.amd
        ? define ([], t)
        : 'object' == typeof exports
            ? (exports.h5_sense_player = t ())
            : (e.h5_sense_player = t ());
}) (self, function () {
  return (() => {
    var e = {
      757: (e, t, r) => {
        e.exports = r (666);
      },
      436: (e, t, r) => {
        const {MinHeap: n} = r (573),
          {MaxHeap: i} = r (945),
          {CustomHeap: a} = r (295);
        t.H2 = n;
      },
      295: (e, t, r) => {
        /**
   * @license MIT
   * @copyright 2020 Eyas Ranjous <eyas.ranjous@gmail.com>
   */
        const {Heap: n} = r (613);
        class i extends n {
          constructor (e, t, r) {
            if ('function' != typeof e)
              throw new Error ('CustomHeap expects a comparator function');
            super (t, r), (this._comparator = e);
          }
          _compare (e, t) {
            return this._comparator (e, t) <= 0;
          }
          _compareChildrenBefore (e, t, r) {
            return this._comparator (this._nodes[r], this._nodes[t]) <= 0 &&
              r < e
              ? r
              : t;
          }
          clone () {
            return new i (this._comparator, this._nodes.slice (), this._leaf);
          }
          static heapify (e, t) {
            if (!Array.isArray (e))
              throw new Error ('.heapify expects an array');
            if ('function' != typeof t)
              throw new Error ('.heapify expects a comparator function');
            return new i (t, e).fix ();
          }
          static isHeapified (e, t) {
            if (!Array.isArray (e))
              throw new Error ('.heapify expects an array');
            if ('function' != typeof t)
              throw new Error ('.isHeapified expects a comparator function');
            return new i (t, e).isValid ();
          }
        }
        t.CustomHeap = i;
      },
      613: (e, t) => {
        t.Heap =
          /**
   * @license MIT
   * @copyright 2020 Eyas Ranjous <eyas.ranjous@gmail.com>
   *
   * @class
   * @abstract
   */
          class {
            constructor (e, t) {
              (this._nodes = Array.isArray (e) ? e : []), (this._leaf =
                t || null);
            }
            _hasLeftChild (e) {
              return 2 * e + 1 < this.size ();
            }
            _hasRightChild (e) {
              return 2 * e + 2 < this.size ();
            }
            _getKey (e) {
              return 'object' == typeof e ? e.key : e;
            }
            _swap (e, t) {
              const r = this._nodes[e];
              (this._nodes[e] = this._nodes[t]), (this._nodes[t] = r);
            }
            _compare (e, t) {
              return this._compareKeys (this._getKey (e), this._getKey (t));
            }
            _shouldSwap (e, t) {
              return (
                !(e < 0 || e >= this.size ()) &&
                (!(t < 0 || t >= this.size ()) &&
                  !this._compare (this._nodes[e], this._nodes[t]))
              );
            }
            heapifyUp (e) {
              let t = e, r = Math.floor ((t - 1) / 2);
              for (; this._shouldSwap (r, t); )
                this._swap (r, t), (t = r), (r = Math.floor ((t - 1) / 2));
            }
            _compareChildrenOf (e) {
              if (!this._hasLeftChild (e) && !this._hasRightChild (e))
                return -1;
              const t = 2 * e + 1, r = 2 * e + 2;
              if (!this._hasLeftChild (e)) return r;
              if (!this._hasRightChild (e)) return t;
              return this._compare (this._nodes[t], this._nodes[r]) ? t : r;
            }
            _heapifyDown (e) {
              let t = e, r = this._compareChildrenOf (t);
              for (; this._shouldSwap (t, r); )
                this._swap (t, r), (t = r), (r = this._compareChildrenOf (t));
            }
            extractRoot () {
              if (this.isEmpty ()) return null;
              const e = this.root ();
              return (this._nodes[0] = this._nodes[
                this.size () - 1
              ]), this._nodes.pop (), this._heapifyDown (0), e === this._leaf &&
                (this._leaf = this.root ()), e;
            }
            _heapifyDownUntil (e) {
              let t, r = 0, n = 1, i = 2;
              for (; n < e; )
                (t = this._compareChildrenBefore (e, n, i)), this._shouldSwap (
                  r,
                  t
                ) && this._swap (r, t), (r = t), (n = 2 * r + 1), (i =
                  2 * r + 2);
            }
            _clone (e) {
              return new e (this._nodes.slice (), this._leaf);
            }
            sort () {
              for (let e = this.size () - 1; e > 0; e -= 1)
                this._swap (0, e), this._heapifyDownUntil (e);
              return this._nodes;
            }
            insert (e, t) {
              const r = void 0 !== t ? {key: e, value: t} : e;
              return this._nodes.push (r), this.heapifyUp (
                this.size () - 1
              ), (null !== this._leaf && this._compare (r, this._leaf)) ||
                (this._leaf = r), this;
            }
            fix () {
              for (let e = 0; e < this.size (); e += 1)
                this.heapifyUp (e);
              return this;
            }
            isValid () {
              const e = t => {
                let r = !0, n = !0;
                if (this._hasLeftChild (t)) {
                  const n = 2 * t + 1;
                  if (
                    ((r = this._compare (this._nodes[t], this._nodes[n])), !r)
                  )
                    return !1;
                  r = e (n);
                }
                if (this._hasRightChild (t)) {
                  const r = 2 * t + 2;
                  if (
                    ((n = this._compare (this._nodes[t], this._nodes[r])), !n)
                  )
                    return !1;
                  n = e (r);
                }
                return r && n;
              };
              return e (0);
            }
            root () {
              return this.isEmpty () ? null : this._nodes[0];
            }
            leaf () {
              return this._leaf;
            }
            size () {
              return this._nodes.length;
            }
            isEmpty () {
              return 0 === this.size ();
            }
            clear () {
              (this._nodes = []), (this._leaf = null);
            }
            static _heapify (e, t) {
              if (!Array.isArray (e))
                throw new Error ('.heapify expects an array');
              return new t (e).fix ();
            }
            static _isHeapified (e, t) {
              return new t (e).isValid ();
            }
          };
      },
      945: (e, t, r) => {
        /**
   * @license MIT
   * @copyright 2020 Eyas Ranjous <eyas.ranjous@gmail.com>
   */
        const {Heap: n} = r (613);
        class i extends n {
          _compareKeys (e, t) {
            return e > t;
          }
          _compareChildrenBefore (e, t, r) {
            const n = this._getKey (this._nodes[t]);
            return this._getKey (this._nodes[r]) > n && r < e ? r : t;
          }
          clone () {
            return super._clone (i);
          }
          static heapify (e) {
            return super._heapify (e, i);
          }
          static isHeapified (e) {
            return super._isHeapified (e, i);
          }
        }
        t.MaxHeap = i;
      },
      573: (e, t, r) => {
        /**
   * @license MIT
   * @copyright 2019 Eyas Ranjous <eyas.ranjous@gmail.com>
   */
        const {Heap: n} = r (613);
        class i extends n {
          _compareKeys (e, t) {
            return e < t;
          }
          _compareChildrenBefore (e, t, r) {
            const n = this._getKey (this._nodes[t]);
            return this._getKey (this._nodes[r]) < n && r < e ? r : t;
          }
          clone () {
            return super._clone (i);
          }
          static heapify (e) {
            return super._heapify (e, i);
          }
          static isHeapified (e) {
            return super._isHeapified (e, i);
          }
        }
        t.MinHeap = i;
      },
      702: (e, t, r) => {
        const {Queue: n} = r (56);
        t.c = n;
      },
      56: (e, t) => {
        /**
   * @license MIT
   * @copyright 2020 Eyas Ranjous <eyas.ranjous@gmail.com>
   *
   * @class
   */
        class r {
          constructor (e) {
            (this._elements = Array.isArray (e) ? e : []), (this._offset = 0);
          }
          enqueue (e) {
            return this._elements.push (e), this;
          }
          dequeue () {
            if (0 === this.size ()) return null;
            const e = this.front ();
            return (this._offset += 1), 2 * this._offset <
              this._elements.length ||
              ((this._elements = this._elements.slice (
                this._offset
              )), (this._offset = 0)), e;
          }
          front () {
            return this.size () > 0 ? this._elements[this._offset] : null;
          }
          back () {
            return this.size () > 0
              ? this._elements[this._elements.length - 1]
              : null;
          }
          size () {
            return this._elements.length - this._offset;
          }
          isEmpty () {
            return 0 === this.size ();
          }
          toArray () {
            return this._elements.slice (this._offset);
          }
          clear () {
            (this._elements = []), (this._offset = 0);
          }
          clone () {
            return new r (this._elements.slice (this._offset));
          }
          static fromArray (e) {
            return new r (e);
          }
        }
        t.Queue = r;
      },
      560: function (e, t, r) {
        var n;
        !(function (i) {
          'use strict';
          function a (e, t) {
            var r = (65535 & e) + (65535 & t);
            return (((e >> 16) + (t >> 16) + (r >> 16)) << 16) | (65535 & r);
          }
          function s (e, t, r, n, i, s) {
            return a (
              ((o = a (a (t, e), a (n, s))) << (u = i)) | (o >>> (32 - u)),
              r
            );
            var o, u;
          }
          function o (e, t, r, n, i, a, o) {
            return s ((t & r) | (~t & n), e, t, i, a, o);
          }
          function u (e, t, r, n, i, a, o) {
            return s ((t & n) | (r & ~n), e, t, i, a, o);
          }
          function c (e, t, r, n, i, a, o) {
            return s (t ^ r ^ n, e, t, i, a, o);
          }
          function l (e, t, r, n, i, a, o) {
            return s (r ^ (t | ~n), e, t, i, a, o);
          }
          function h (e, t) {
            var r, n, i, s, h;
            (e[t >> 5] |= 128 << (t % 32)), (e[14 + ((t + 64) >>> 9 << 4)] = t);
            var f = 1732584193, d = -271733879, p = -1732584194, _ = 271733878;
            for (r = 0; r < e.length; r += 16)
              (n = f), (i = d), (s = p), (h = _), (f = o (
                f,
                d,
                p,
                _,
                e[r],
                7,
                -680876936
              )), (_ = o (_, f, d, p, e[r + 1], 12, -389564586)), (p = o (
                p,
                _,
                f,
                d,
                e[r + 2],
                17,
                606105819
              )), (d = o (d, p, _, f, e[r + 3], 22, -1044525330)), (f = o (
                f,
                d,
                p,
                _,
                e[r + 4],
                7,
                -176418897
              )), (_ = o (_, f, d, p, e[r + 5], 12, 1200080426)), (p = o (
                p,
                _,
                f,
                d,
                e[r + 6],
                17,
                -1473231341
              )), (d = o (d, p, _, f, e[r + 7], 22, -45705983)), (f = o (
                f,
                d,
                p,
                _,
                e[r + 8],
                7,
                1770035416
              )), (_ = o (_, f, d, p, e[r + 9], 12, -1958414417)), (p = o (
                p,
                _,
                f,
                d,
                e[r + 10],
                17,
                -42063
              )), (d = o (d, p, _, f, e[r + 11], 22, -1990404162)), (f = o (
                f,
                d,
                p,
                _,
                e[r + 12],
                7,
                1804603682
              )), (_ = o (_, f, d, p, e[r + 13], 12, -40341101)), (p = o (
                p,
                _,
                f,
                d,
                e[r + 14],
                17,
                -1502002290
              )), (f = u (
                f,
                (d = o (d, p, _, f, e[r + 15], 22, 1236535329)),
                p,
                _,
                e[r + 1],
                5,
                -165796510
              )), (_ = u (_, f, d, p, e[r + 6], 9, -1069501632)), (p = u (
                p,
                _,
                f,
                d,
                e[r + 11],
                14,
                643717713
              )), (d = u (d, p, _, f, e[r], 20, -373897302)), (f = u (
                f,
                d,
                p,
                _,
                e[r + 5],
                5,
                -701558691
              )), (_ = u (_, f, d, p, e[r + 10], 9, 38016083)), (p = u (
                p,
                _,
                f,
                d,
                e[r + 15],
                14,
                -660478335
              )), (d = u (d, p, _, f, e[r + 4], 20, -405537848)), (f = u (
                f,
                d,
                p,
                _,
                e[r + 9],
                5,
                568446438
              )), (_ = u (_, f, d, p, e[r + 14], 9, -1019803690)), (p = u (
                p,
                _,
                f,
                d,
                e[r + 3],
                14,
                -187363961
              )), (d = u (d, p, _, f, e[r + 8], 20, 1163531501)), (f = u (
                f,
                d,
                p,
                _,
                e[r + 13],
                5,
                -1444681467
              )), (_ = u (_, f, d, p, e[r + 2], 9, -51403784)), (p = u (
                p,
                _,
                f,
                d,
                e[r + 7],
                14,
                1735328473
              )), (f = c (
                f,
                (d = u (d, p, _, f, e[r + 12], 20, -1926607734)),
                p,
                _,
                e[r + 5],
                4,
                -378558
              )), (_ = c (_, f, d, p, e[r + 8], 11, -2022574463)), (p = c (
                p,
                _,
                f,
                d,
                e[r + 11],
                16,
                1839030562
              )), (d = c (d, p, _, f, e[r + 14], 23, -35309556)), (f = c (
                f,
                d,
                p,
                _,
                e[r + 1],
                4,
                -1530992060
              )), (_ = c (_, f, d, p, e[r + 4], 11, 1272893353)), (p = c (
                p,
                _,
                f,
                d,
                e[r + 7],
                16,
                -155497632
              )), (d = c (d, p, _, f, e[r + 10], 23, -1094730640)), (f = c (
                f,
                d,
                p,
                _,
                e[r + 13],
                4,
                681279174
              )), (_ = c (_, f, d, p, e[r], 11, -358537222)), (p = c (
                p,
                _,
                f,
                d,
                e[r + 3],
                16,
                -722521979
              )), (d = c (d, p, _, f, e[r + 6], 23, 76029189)), (f = c (
                f,
                d,
                p,
                _,
                e[r + 9],
                4,
                -640364487
              )), (_ = c (_, f, d, p, e[r + 12], 11, -421815835)), (p = c (
                p,
                _,
                f,
                d,
                e[r + 15],
                16,
                530742520
              )), (f = l (
                f,
                (d = c (d, p, _, f, e[r + 2], 23, -995338651)),
                p,
                _,
                e[r],
                6,
                -198630844
              )), (_ = l (_, f, d, p, e[r + 7], 10, 1126891415)), (p = l (
                p,
                _,
                f,
                d,
                e[r + 14],
                15,
                -1416354905
              )), (d = l (d, p, _, f, e[r + 5], 21, -57434055)), (f = l (
                f,
                d,
                p,
                _,
                e[r + 12],
                6,
                1700485571
              )), (_ = l (_, f, d, p, e[r + 3], 10, -1894986606)), (p = l (
                p,
                _,
                f,
                d,
                e[r + 10],
                15,
                -1051523
              )), (d = l (d, p, _, f, e[r + 1], 21, -2054922799)), (f = l (
                f,
                d,
                p,
                _,
                e[r + 8],
                6,
                1873313359
              )), (_ = l (_, f, d, p, e[r + 15], 10, -30611744)), (p = l (
                p,
                _,
                f,
                d,
                e[r + 6],
                15,
                -1560198380
              )), (d = l (d, p, _, f, e[r + 13], 21, 1309151649)), (f = l (
                f,
                d,
                p,
                _,
                e[r + 4],
                6,
                -145523070
              )), (_ = l (_, f, d, p, e[r + 11], 10, -1120210379)), (p = l (
                p,
                _,
                f,
                d,
                e[r + 2],
                15,
                718787259
              )), (d = l (d, p, _, f, e[r + 9], 21, -343485551)), (f = a (
                f,
                n
              )), (d = a (d, i)), (p = a (p, s)), (_ = a (_, h));
            return [f, d, p, _];
          }
          function f (e) {
            var t, r = '', n = 32 * e.length;
            for (t = 0; t < n; t += 8)
              r += String.fromCharCode ((e[t >> 5] >>> (t % 32)) & 255);
            return r;
          }
          function d (e) {
            var t, r = [];
            for (
              (r[(e.length >> 2) - 1] = void 0), (t = 0);
              t < r.length;
              t += 1
            )
              r[t] = 0;
            var n = 8 * e.length;
            for (t = 0; t < n; t += 8)
              r[t >> 5] |= (255 & e.charCodeAt (t / 8)) << (t % 32);
            return r;
          }
          function p (e) {
            var t, r, n = '0123456789abcdef', i = '';
            for (r = 0; r < e.length; r += 1)
              (t = e.charCodeAt (r)), (i +=
                n.charAt ((t >>> 4) & 15) + n.charAt (15 & t));
            return i;
          }
          function _ (e) {
            return unescape (encodeURIComponent (e));
          }
          function v (e) {
            return (function (e) {
              return f (h (d (e), 8 * e.length));
            }) (_ (e));
          }
          function g (e, t) {
            return (function (e, t) {
              var r, n, i = d (e), a = [], s = [];
              for (
                (a[15] = s[15] = void 0), i.length > 16 &&
                  (i = h (i, 8 * e.length)), (r = 0);
                r < 16;
                r += 1
              )
                (a[r] = 909522486 ^ i[r]), (s[r] = 1549556828 ^ i[r]);
              return (n = h (a.concat (d (t)), 512 + 8 * t.length)), f (
                h (s.concat (n), 640)
              );
            }) (_ (e), _ (t));
          }
          function y (e, t, r) {
            return t ? (r ? g (t, e) : p (g (t, e))) : r ? v (e) : p (v (e));
          }
          void 0 ===
            (n = function () {
              return y;
            }.call (t, r, t, e)) || (e.exports = n);
        }) ();
      },
      729: e => {
        'use strict';
        var t = Object.prototype.hasOwnProperty, r = '~';
        function n () {}
        function i (e, t, r) {
          (this.fn = e), (this.context = t), (this.once = r || !1);
        }
        function a (e, t, n, a, s) {
          if ('function' != typeof n)
            throw new TypeError ('The listener must be a function');
          var o = new i (n, a || e, s), u = r ? r + t : t;
          return e._events[u]
            ? e._events[u].fn
                ? (e._events[u] = [e._events[u], o])
                : e._events[u].push (o)
            : ((e._events[u] = o), e._eventsCount++), e;
        }
        function s (e, t) {
          0 == --e._eventsCount ? (e._events = new n ()) : delete e._events[t];
        }
        function o () {
          (this._events = new n ()), (this._eventsCount = 0);
        }
        Object.create &&
          ((n.prototype = Object.create (null)), new n ().__proto__ ||
            (r = !1)), (o.prototype.eventNames = function () {
          var e, n, i = [];
          if (0 === this._eventsCount) return i;
          for (n in (e = this._events))
            t.call (e, n) && i.push (r ? n.slice (1) : n);
          return Object.getOwnPropertySymbols
            ? i.concat (Object.getOwnPropertySymbols (e))
            : i;
        }), (o.prototype.listeners = function (e) {
          var t = r ? r + e : e, n = this._events[t];
          if (!n) return [];
          if (n.fn) return [n.fn];
          for (var i = 0, a = n.length, s = new Array (a); i < a; i++)
            s[i] = n[i].fn;
          return s;
        }), (o.prototype.listenerCount = function (e) {
          var t = r ? r + e : e, n = this._events[t];
          return n ? (n.fn ? 1 : n.length) : 0;
        }), (o.prototype.emit = function (e, t, n, i, a, s) {
          var o = r ? r + e : e;
          if (!this._events[o]) return !1;
          var u, c, l = this._events[o], h = arguments.length;
          if (l.fn) {
            switch ((l.once && this.removeListener (e, l.fn, void 0, !0), h)) {
              case 1:
                return l.fn.call (l.context), !0;
              case 2:
                return l.fn.call (l.context, t), !0;
              case 3:
                return l.fn.call (l.context, t, n), !0;
              case 4:
                return l.fn.call (l.context, t, n, i), !0;
              case 5:
                return l.fn.call (l.context, t, n, i, a), !0;
              case 6:
                return l.fn.call (l.context, t, n, i, a, s), !0;
            }
            for ((c = 1), (u = new Array (h - 1)); c < h; c++)
              u[c - 1] = arguments[c];
            l.fn.apply (l.context, u);
          } else {
            var f, d = l.length;
            for (c = 0; c < d; c++)
              switch ((l[c].once &&
                this.removeListener (e, l[c].fn, void 0, !0), h)) {
                case 1:
                  l[c].fn.call (l[c].context);
                  break;
                case 2:
                  l[c].fn.call (l[c].context, t);
                  break;
                case 3:
                  l[c].fn.call (l[c].context, t, n);
                  break;
                case 4:
                  l[c].fn.call (l[c].context, t, n, i);
                  break;
                default:
                  if (!u)
                    for ((f = 1), (u = new Array (h - 1)); f < h; f++)
                      u[f - 1] = arguments[f];
                  l[c].fn.apply (l[c].context, u);
              }
          }
          return !0;
        }), (o.prototype.on = function (e, t, r) {
          return a (this, e, t, r, !1);
        }), (o.prototype.once = function (e, t, r) {
          return a (this, e, t, r, !0);
        }), (o.prototype.removeListener = function (e, t, n, i) {
          var a = r ? r + e : e;
          if (!this._events[a]) return this;
          if (!t) return s (this, a), this;
          var o = this._events[a];
          if (o.fn)
            o.fn !== t ||
              (i && !o.once) ||
              (n && o.context !== n) ||
              s (this, a);
          else {
            for (var u = 0, c = [], l = o.length; u < l; u++)
              (o[u].fn !== t ||
                (i && !o[u].once) ||
                (n && o[u].context !== n)) &&
                c.push (o[u]);
            c.length
              ? (this._events[a] = 1 === c.length ? c[0] : c)
              : s (this, a);
          }
          return this;
        }), (o.prototype.removeAllListeners = function (e) {
          var t;
          return e
            ? ((t = r ? r + e : e), this._events[t] && s (this, t))
            : ((this._events = new n ()), (this._eventsCount = 0)), this;
        }), (o.prototype.off =
          o.prototype.removeListener), (o.prototype.addListener =
          o.prototype.on), (o.prefixed = r), (o.EventEmitter = o), (e.exports = o);
      },
      666: e => {
        var t = (function (e) {
          'use strict';
          var t,
            r = Object.prototype,
            n = r.hasOwnProperty,
            i = 'function' == typeof Symbol ? Symbol : {},
            a = i.iterator || '@@iterator',
            s = i.asyncIterator || '@@asyncIterator',
            o = i.toStringTag || '@@toStringTag';
          function u (e, t, r) {
            return Object.defineProperty (e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }), e[t];
          }
          try {
            u ({}, '');
          } catch (e) {
            u = function (e, t, r) {
              return (e[t] = r);
            };
          }
          function c (e, t, r, n) {
            var i = t && t.prototype instanceof v ? t : v,
              a = Object.create (i.prototype),
              s = new L (n || []);
            return (a._invoke = (function (e, t, r) {
              var n = h;
              return function (i, a) {
                if (n === d) throw new Error ('Generator is already running');
                if (n === p) {
                  if ('throw' === i) throw a;
                  return T ();
                }
                for ((r.method = i), (r.arg = a); ; ) {
                  var s = r.delegate;
                  if (s) {
                    var o = A (s, r);
                    if (o) {
                      if (o === _) continue;
                      return o;
                    }
                  }
                  if ('next' === r.method) r.sent = r._sent = r.arg;
                  else if ('throw' === r.method) {
                    if (n === h) throw ((n = p), r.arg);
                    r.dispatchException (r.arg);
                  } else 'return' === r.method && r.abrupt ('return', r.arg);
                  n = d;
                  var u = l (e, t, r);
                  if ('normal' === u.type) {
                    if (((n = r.done ? p : f), u.arg === _)) continue;
                    return {value: u.arg, done: r.done};
                  }
                  'throw' === u.type &&
                    ((n = p), (r.method = 'throw'), (r.arg = u.arg));
                }
              };
            }) (e, r, s)), a;
          }
          function l (e, t, r) {
            try {
              return {type: 'normal', arg: e.call (t, r)};
            } catch (e) {
              return {type: 'throw', arg: e};
            }
          }
          e.wrap = c;
          var h = 'suspendedStart',
            f = 'suspendedYield',
            d = 'executing',
            p = 'completed',
            _ = {};
          function v () {}
          function g () {}
          function y () {}
          var m = {};
          u (m, a, function () {
            return this;
          });
          var b = Object.getPrototypeOf, E = b && b (b (k ([])));
          E && E !== r && n.call (E, a) && (m = E);
          var x = (y.prototype = v.prototype = Object.create (m));
          function w (e) {
            ['next', 'throw', 'return'].forEach (function (t) {
              u (e, t, function (e) {
                return this._invoke (t, e);
              });
            });
          }
          function S (e, t) {
            function r (i, a, s, o) {
              var u = l (e[i], e, a);
              if ('throw' !== u.type) {
                var c = u.arg, h = c.value;
                return h && 'object' == typeof h && n.call (h, '__await')
                  ? t.resolve (h.__await).then (
                      function (e) {
                        r ('next', e, s, o);
                      },
                      function (e) {
                        r ('throw', e, s, o);
                      }
                    )
                  : t.resolve (h).then (
                      function (e) {
                        (c.value = e), s (c);
                      },
                      function (e) {
                        return r ('throw', e, s, o);
                      }
                    );
              }
              o (u.arg);
            }
            var i;
            this._invoke = function (e, n) {
              function a () {
                return new t (function (t, i) {
                  r (e, n, t, i);
                });
              }
              return (i = i ? i.then (a, a) : a ());
            };
          }
          function A (e, r) {
            var n = e.iterator[r.method];
            if (n === t) {
              if (((r.delegate = null), 'throw' === r.method)) {
                if (
                  e.iterator.return &&
                  ((r.method = 'return'), (r.arg = t), A (e, r), 'throw' ===
                    r.method)
                )
                  return _;
                (r.method = 'throw'), (r.arg = new TypeError (
                  "The iterator does not provide a 'throw' method"
                ));
              }
              return _;
            }
            var i = l (n, e.iterator, r.arg);
            if ('throw' === i.type)
              return (r.method = 'throw'), (r.arg =
                i.arg), (r.delegate = null), _;
            var a = i.arg;
            return a
              ? a.done
                  ? ((r[e.resultName] = a.value), (r.next =
                      e.nextLoc), 'return' !== r.method &&
                      ((r.method =
                        'next'), (r.arg = t)), (r.delegate = null), _)
                  : a
              : ((r.method = 'throw'), (r.arg = new TypeError (
                  'iterator result is not an object'
                )), (r.delegate = null), _);
          }
          function P (e) {
            var t = {tryLoc: e[0]};
            1 in e && (t.catchLoc = e[1]), 2 in e &&
              ((t.finallyLoc = e[2]), (t.afterLoc =
                e[3])), this.tryEntries.push (t);
          }
          function C (e) {
            var t = e.completion || {};
            (t.type = 'normal'), delete t.arg, (e.completion = t);
          }
          function L (e) {
            (this.tryEntries = [{tryLoc: 'root'}]), e.forEach (
              P,
              this
            ), this.reset (!0);
          }
          function k (e) {
            if (e) {
              var r = e[a];
              if (r) return r.call (e);
              if ('function' == typeof e.next) return e;
              if (!isNaN (e.length)) {
                var i = -1,
                  s = function r () {
                    for (; ++i < e.length; )
                      if (n.call (e, i))
                        return (r.value = e[i]), (r.done = !1), r;
                    return (r.value = t), (r.done = !0), r;
                  };
                return (s.next = s);
              }
            }
            return {next: T};
          }
          function T () {
            return {value: t, done: !0};
          }
          return (g.prototype = y), u (x, 'constructor', y), u (
            y,
            'constructor',
            g
          ), (g.displayName = u (
            y,
            o,
            'GeneratorFunction'
          )), (e.isGeneratorFunction = function (e) {
            var t = 'function' == typeof e && e.constructor;
            return (
              !!t &&
              (t === g || 'GeneratorFunction' === (t.displayName || t.name))
            );
          }), (e.mark = function (e) {
            return Object.setPrototypeOf
              ? Object.setPrototypeOf (e, y)
              : ((e.__proto__ = y), u (
                  e,
                  o,
                  'GeneratorFunction'
                )), (e.prototype = Object.create (x)), e;
          }), (e.awrap = function (e) {
            return {__await: e};
          }), w (S.prototype), u (S.prototype, s, function () {
            return this;
          }), (e.AsyncIterator = S), (e.async = function (t, r, n, i, a) {
            void 0 === a && (a = Promise);
            var s = new S (c (t, r, n, i), a);
            return e.isGeneratorFunction (r)
              ? s
              : s.next ().then (function (e) {
                  return e.done ? e.value : s.next ();
                });
          }), w (x), u (x, o, 'Generator'), u (x, a, function () {
            return this;
          }), u (x, 'toString', function () {
            return '[object Generator]';
          }), (e.keys = function (e) {
            var t = [];
            for (var r in e)
              t.push (r);
            return t.reverse (), function r () {
              for (; t.length; ) {
                var n = t.pop ();
                if (n in e) return (r.value = n), (r.done = !1), r;
              }
              return (r.done = !0), r;
            };
          }), (e.values = k), (L.prototype = {
            constructor: L,
            reset: function (e) {
              if (
                ((this.prev = 0), (this.next = 0), (this.sent = this._sent = t), (this.done = !1), (this.delegate = null), (this.method =
                  'next'), (this.arg = t), this.tryEntries.forEach (C), !e)
              )
                for (var r in this)
                  't' === r.charAt (0) &&
                    n.call (this, r) &&
                    !isNaN (+r.slice (1)) &&
                    (this[r] = t);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ('throw' === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var r = this;
              function i (n, i) {
                return (o.type = 'throw'), (o.arg = e), (r.next = n), i &&
                  ((r.method = 'next'), (r.arg = t)), !!i;
              }
              for (var a = this.tryEntries.length - 1; a >= 0; --a) {
                var s = this.tryEntries[a], o = s.completion;
                if ('root' === s.tryLoc) return i ('end');
                if (s.tryLoc <= this.prev) {
                  var u = n.call (s, 'catchLoc'), c = n.call (s, 'finallyLoc');
                  if (u && c) {
                    if (this.prev < s.catchLoc) return i (s.catchLoc, !0);
                    if (this.prev < s.finallyLoc) return i (s.finallyLoc);
                  } else if (u) {
                    if (this.prev < s.catchLoc) return i (s.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error (
                        'try statement without catch or finally'
                      );
                    if (this.prev < s.finallyLoc) return i (s.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r];
                if (
                  i.tryLoc <= this.prev &&
                  n.call (i, 'finallyLoc') &&
                  this.prev < i.finallyLoc
                ) {
                  var a = i;
                  break;
                }
              }
              a &&
                ('break' === e || 'continue' === e) &&
                a.tryLoc <= t &&
                t <= a.finallyLoc &&
                (a = null);
              var s = a ? a.completion : {};
              return (s.type = e), (s.arg = t), a
                ? ((this.method = 'next'), (this.next = a.finallyLoc), _)
                : this.complete (s);
            },
            complete: function (e, t) {
              if ('throw' === e.type) throw e.arg;
              return 'break' === e.type || 'continue' === e.type
                ? (this.next = e.arg)
                : 'return' === e.type
                    ? ((this.rval = this.arg = e.arg), (this.method =
                        'return'), (this.next = 'end'))
                    : 'normal' === e.type && t && (this.next = t), _;
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var r = this.tryEntries[t];
                if (r.finallyLoc === e)
                  return this.complete (r.completion, r.afterLoc), C (r), _;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var r = this.tryEntries[t];
                if (r.tryLoc === e) {
                  var n = r.completion;
                  if ('throw' === n.type) {
                    var i = n.arg;
                    C (r);
                  }
                  return i;
                }
              }
              throw new Error ('illegal catch attempt');
            },
            delegateYield: function (e, r, n) {
              return (this.delegate = {
                iterator: k (e),
                resultName: r,
                nextLoc: n,
              }), 'next' === this.method && (this.arg = t), _;
            },
          }), e;
        }) (e.exports);
        try {
          regeneratorRuntime = t;
        } catch (e) {
          'object' == typeof globalThis
            ? (globalThis.regeneratorRuntime = t)
            : Function ('r', 'regeneratorRuntime = r') (t);
        }
      },
      692: e => {
        var t = (e.exports = {
          v: [{name: 'version', reg: /^(\d*)$/}],
          o: [
            {
              name: 'origin',
              reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
              names: [
                'username',
                'sessionId',
                'sessionVersion',
                'netType',
                'ipVer',
                'address',
              ],
              format: '%s %s %d %s IP%d %s',
            },
          ],
          s: [{name: 'name'}],
          i: [{name: 'description'}],
          u: [{name: 'uri'}],
          e: [{name: 'email'}],
          p: [{name: 'phone'}],
          z: [{name: 'timezones'}],
          r: [{name: 'repeats'}],
          t: [
            {
              name: 'timing',
              reg: /^(\d*) (\d*)/,
              names: ['start', 'stop'],
              format: '%d %d',
            },
          ],
          c: [
            {
              name: 'connection',
              reg: /^IN IP(\d) (\S*)/,
              names: ['version', 'ip'],
              format: 'IN IP%d %s',
            },
          ],
          b: [
            {
              push: 'bandwidth',
              reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
              names: ['type', 'limit'],
              format: '%s:%s',
            },
          ],
          m: [
            {
              reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
              names: ['type', 'port', 'protocol', 'payloads'],
              format: '%s %d %s %s',
            },
          ],
          a: [
            {
              push: 'rtp',
              reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
              names: ['payload', 'codec', 'rate', 'encoding'],
              format: function (e) {
                return e.encoding
                  ? 'rtpmap:%d %s/%s/%s'
                  : e.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
              },
            },
            {
              push: 'fmtp',
              reg: /^fmtp:(\d*) ([\S| ]*)/,
              names: ['payload', 'config'],
              format: 'fmtp:%d %s',
            },
            {name: 'control', reg: /^control:(.*)/, format: 'control:%s'},
            {
              name: 'rtcp',
              reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
              names: ['port', 'netType', 'ipVer', 'address'],
              format: function (e) {
                return null != e.address ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
              },
            },
            {
              push: 'rtcpFbTrrInt',
              reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
              names: ['payload', 'value'],
              format: 'rtcp-fb:%s trr-int %d',
            },
            {
              push: 'rtcpFb',
              reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
              names: ['payload', 'type', 'subtype'],
              format: function (e) {
                return null != e.subtype ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
              },
            },
            {
              push: 'ext',
              reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
              names: ['value', 'direction', 'encrypt-uri', 'uri', 'config'],
              format: function (e) {
                return (
                  'extmap:%d' +
                  (e.direction ? '/%s' : '%v') +
                  (e['encrypt-uri'] ? ' %s' : '%v') +
                  ' %s' +
                  (e.config ? ' %s' : '')
                );
              },
            },
            {name: 'extmapAllowMixed', reg: /^(extmap-allow-mixed)/},
            {
              push: 'crypto',
              reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
              names: ['id', 'suite', 'config', 'sessionConfig'],
              format: function (e) {
                return null != e.sessionConfig
                  ? 'crypto:%d %s %s %s'
                  : 'crypto:%d %s %s';
              },
            },
            {name: 'setup', reg: /^setup:(\w*)/, format: 'setup:%s'},
            {
              name: 'connectionType',
              reg: /^connection:(new|existing)/,
              format: 'connection:%s',
            },
            {name: 'mid', reg: /^mid:([^\s]*)/, format: 'mid:%s'},
            {name: 'msid', reg: /^msid:(.*)/, format: 'msid:%s'},
            {name: 'ptime', reg: /^ptime:(\d*(?:\.\d*)*)/, format: 'ptime:%d'},
            {
              name: 'maxptime',
              reg: /^maxptime:(\d*(?:\.\d*)*)/,
              format: 'maxptime:%d',
            },
            {name: 'direction', reg: /^(sendrecv|recvonly|sendonly|inactive)/},
            {name: 'icelite', reg: /^(ice-lite)/},
            {name: 'iceUfrag', reg: /^ice-ufrag:(\S*)/, format: 'ice-ufrag:%s'},
            {name: 'icePwd', reg: /^ice-pwd:(\S*)/, format: 'ice-pwd:%s'},
            {
              name: 'fingerprint',
              reg: /^fingerprint:(\S*) (\S*)/,
              names: ['type', 'hash'],
              format: 'fingerprint:%s %s',
            },
            {
              push: 'candidates',
              reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
              names: [
                'foundation',
                'component',
                'transport',
                'priority',
                'ip',
                'port',
                'type',
                'raddr',
                'rport',
                'tcptype',
                'generation',
                'network-id',
                'network-cost',
              ],
              format: function (e) {
                var t = 'candidate:%s %d %s %d %s %d typ %s';
                return (t += null != e.raddr
                  ? ' raddr %s rport %d'
                  : '%v%v'), (t += null != e.tcptype
                  ? ' tcptype %s'
                  : '%v'), null != e.generation &&
                  (t += ' generation %d'), (t += null != e['network-id']
                  ? ' network-id %d'
                  : '%v'), (t += null != e['network-cost']
                  ? ' network-cost %d'
                  : '%v');
              },
            },
            {name: 'endOfCandidates', reg: /^(end-of-candidates)/},
            {
              name: 'remoteCandidates',
              reg: /^remote-candidates:(.*)/,
              format: 'remote-candidates:%s',
            },
            {
              name: 'iceOptions',
              reg: /^ice-options:(\S*)/,
              format: 'ice-options:%s',
            },
            {
              push: 'ssrcs',
              reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
              names: ['id', 'attribute', 'value'],
              format: function (e) {
                var t = 'ssrc:%d';
                return null != e.attribute &&
                  ((t += ' %s'), null != e.value && (t += ':%s')), t;
              },
            },
            {
              push: 'ssrcGroups',
              reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
              names: ['semantics', 'ssrcs'],
              format: 'ssrc-group:%s %s',
            },
            {
              name: 'msidSemantic',
              reg: /^msid-semantic:\s?(\w*) (\S*)/,
              names: ['semantic', 'token'],
              format: 'msid-semantic: %s %s',
            },
            {
              push: 'groups',
              reg: /^group:(\w*) (.*)/,
              names: ['type', 'mids'],
              format: 'group:%s %s',
            },
            {name: 'rtcpMux', reg: /^(rtcp-mux)/},
            {name: 'rtcpRsize', reg: /^(rtcp-rsize)/},
            {
              name: 'sctpmap',
              reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
              names: ['sctpmapNumber', 'app', 'maxMessageSize'],
              format: function (e) {
                return null != e.maxMessageSize
                  ? 'sctpmap:%s %s %s'
                  : 'sctpmap:%s %s';
              },
            },
            {
              name: 'xGoogleFlag',
              reg: /^x-google-flag:([^\s]*)/,
              format: 'x-google-flag:%s',
            },
            {
              push: 'rids',
              reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
              names: ['id', 'direction', 'params'],
              format: function (e) {
                return e.params ? 'rid:%s %s %s' : 'rid:%s %s';
              },
            },
            {
              push: 'imageattrs',
              reg: new RegExp (
                '^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?'
              ),
              names: ['pt', 'dir1', 'attrs1', 'dir2', 'attrs2'],
              format: function (e) {
                return 'imageattr:%s %s %s' + (e.dir2 ? ' %s %s' : '');
              },
            },
            {
              name: 'simulcast',
              reg: new RegExp (
                '^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$'
              ),
              names: ['dir1', 'list1', 'dir2', 'list2'],
              format: function (e) {
                return 'simulcast:%s %s' + (e.dir2 ? ' %s %s' : '');
              },
            },
            {
              name: 'simulcast_03',
              reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
              names: ['value'],
              format: 'simulcast: %s',
            },
            {
              name: 'framerate',
              reg: /^framerate:(\d+(?:$|\.\d+))/,
              format: 'framerate:%s',
            },
            {
              name: 'sourceFilter',
              reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
              names: [
                'filterMode',
                'netType',
                'addressTypes',
                'destAddress',
                'srcList',
              ],
              format: 'source-filter: %s %s %s %s %s',
            },
            {name: 'bundleOnly', reg: /^(bundle-only)/},
            {name: 'label', reg: /^label:(.+)/, format: 'label:%s'},
            {
              name: 'sctpPort',
              reg: /^sctp-port:(\d+)$/,
              format: 'sctp-port:%s',
            },
            {
              name: 'maxMessageSize',
              reg: /^max-message-size:(\d+)$/,
              format: 'max-message-size:%s',
            },
            {
              push: 'tsRefClocks',
              reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
              names: ['clksrc', 'clksrcExt'],
              format: function (e) {
                return 'ts-refclk:%s' + (null != e.clksrcExt ? '=%s' : '');
              },
            },
            {
              name: 'mediaClk',
              reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
              names: [
                'id',
                'mediaClockName',
                'mediaClockValue',
                'rateNumerator',
                'rateDenominator',
              ],
              format: function (e) {
                var t = 'mediaclk:';
                return (t += null != e.id ? 'id=%s %s' : '%v%s'), (t += null !=
                  e.mediaClockValue
                  ? '=%s'
                  : ''), (t += null != e.rateNumerator
                  ? ' rate=%s'
                  : ''), (t += null != e.rateDenominator ? '/%s' : '');
              },
            },
            {name: 'keywords', reg: /^keywds:(.+)$/, format: 'keywds:%s'},
            {name: 'content', reg: /^content:(.+)/, format: 'content:%s'},
            {
              name: 'bfcpFloorCtrl',
              reg: /^floorctrl:(c-only|s-only|c-s)/,
              format: 'floorctrl:%s',
            },
            {name: 'bfcpConfId', reg: /^confid:(\d+)/, format: 'confid:%s'},
            {name: 'bfcpUserId', reg: /^userid:(\d+)/, format: 'userid:%s'},
            {
              name: 'bfcpFloorId',
              reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
              names: ['id', 'mStream'],
              format: 'floorid:%s mstrm:%s',
            },
            {push: 'invalid', names: ['value']},
          ],
        });
        Object.keys (t).forEach (function (e) {
          t[e].forEach (function (e) {
            e.reg || (e.reg = /(.*)/), e.format || (e.format = '%s');
          });
        });
      },
      766: (e, t, r) => {
        var n = r (962);
        r (776), (t.Qc = n.parse), (t.rz =
          n.parseParams), n.parseFmtpConfig, n.parsePayloads, n.parseRemoteCandidates, n.parseImageAttributes, n.parseSimulcastStreamList;
      },
      962: (e, t, r) => {
        var n = function (e) {
          return String (Number (e)) === e ? Number (e) : e;
        },
          i = function (e, t, r) {
            var i = e.name && e.names;
            e.push && !t[e.push]
              ? (t[e.push] = [])
              : i && !t[e.name] && (t[e.name] = {});
            var a = e.push ? {} : i ? t[e.name] : t;
            !(function (e, t, r, i) {
              if (i && !r) t[i] = n (e[1]);
              else
                for (var a = 0; a < r.length; a += 1)
                  null != e[a + 1] && (t[r[a]] = n (e[a + 1]));
            }) (r.match (e.reg), a, e.names, e.name), e.push &&
              t[e.push].push (a);
          },
          a = r (692),
          s = RegExp.prototype.test.bind (/^([a-z])=(.*)/);
        t.parse = function (e) {
          var t = {}, r = [], n = t;
          return e.split (/(\r\n|\r|\n)/).filter (s).forEach (function (e) {
            var t = e[0], s = e.slice (2);
            'm' === t && (r.push ({rtp: [], fmtp: []}), (n = r[r.length - 1]));
            for (var o = 0; o < (a[t] || []).length; o += 1) {
              var u = a[t][o];
              if (u.reg.test (s)) return i (u, n, s);
            }
          }), (t.media = r), t;
        };
        var o = function (e, t) {
          var r = t.split (/=(.+)/, 2);
          return 2 === r.length
            ? (e[r[0]] = n (r[1]))
            : 1 === r.length && t.length > 1 && (e[r[0]] = void 0), e;
        };
        (t.parseParams = function (e) {
          return e.split (/;\s?/).reduce (o, {});
        }), (t.parseFmtpConfig = t.parseParams), (t.parsePayloads = function (
          e
        ) {
          return e.toString ().split (' ').map (Number);
        }), (t.parseRemoteCandidates = function (e) {
          for (
            var t = [], r = e.split (' ').map (n), i = 0;
            i < r.length;
            i += 3
          )
            t.push ({component: r[i], ip: r[i + 1], port: r[i + 2]});
          return t;
        }), (t.parseImageAttributes = function (e) {
          return e.split (' ').map (function (e) {
            return e.substring (1, e.length - 1).split (',').reduce (o, {});
          });
        }), (t.parseSimulcastStreamList = function (e) {
          return e.split (';').map (function (e) {
            return e.split (',').map (function (e) {
              var t, r = !1;
              return '~' !== e[0]
                ? (t = n (e))
                : ((t = n (
                    e.substring (1, e.length)
                  )), (r = !0)), {scid: t, paused: r};
            });
          });
        });
      },
      776: (e, t, r) => {
        var n = r (692),
          i = /%[sdv%]/g,
          a = function (e) {
            var t = 1, r = arguments, n = r.length;
            return e.replace (i, function (e) {
              if (t >= n) return e;
              var i = r[t];
              switch (((t += 1), e)) {
                case '%%':
                  return '%';
                case '%s':
                  return String (i);
                case '%d':
                  return Number (i);
                case '%v':
                  return '';
              }
            });
          },
          s = function (e, t, r) {
            var n = [
              e +
                '=' +
                (t.format instanceof Function
                  ? t.format (t.push ? r : r[t.name])
                  : t.format),
            ];
            if (t.names)
              for (var i = 0; i < t.names.length; i += 1) {
                var s = t.names[i];
                t.name ? n.push (r[t.name][s]) : n.push (r[t.names[i]]);
              }
            else n.push (r[t.name]);
            return a.apply (null, n);
          },
          o = ['v', 'o', 's', 'i', 'u', 'e', 'p', 'c', 'b', 't', 'r', 'z', 'a'],
          u = ['i', 'c', 'b', 'a'];
        e.exports = function (e, t) {
          (t = t || {}), null == e.version && (e.version = 0), null == e.name &&
            (e.name = ' '), e.media.forEach (function (e) {
            null == e.payloads && (e.payloads = '');
          });
          var r = t.outerOrder || o, i = t.innerOrder || u, a = [];
          return r.forEach (function (t) {
            n[t].forEach (function (r) {
              r.name in e && null != e[r.name]
                ? a.push (s (t, r, e))
                : r.push in e &&
                    null != e[r.push] &&
                    e[r.push].forEach (function (e) {
                      a.push (s (t, r, e));
                    });
            });
          }), e.media.forEach (function (e) {
            a.push (s ('m', n.m[0], e)), i.forEach (function (t) {
              n[t].forEach (function (r) {
                r.name in e && null != e[r.name]
                  ? a.push (s (t, r, e))
                  : r.push in e &&
                      null != e[r.push] &&
                      e[r.push].forEach (function (e) {
                        a.push (s (t, r, e));
                      });
              });
            });
          }), a.join ('\r\n') + '\r\n';
        };
      },
      662: e => {
        var t = {
          validateDimension: function (e) {
            if (e <= 0 || e !== (0 | e))
              throw 'YUV plane dimensions must be a positive integer';
          },
          validateOffset: function (e) {
            if (e < 0 || e !== (0 | e))
              throw 'YUV plane offsets must be a non-negative integer';
          },
          format: function (e) {
            var t = e.width,
              r = e.height,
              n = e.chromaWidth || t,
              i = e.chromaHeight || r,
              a = e.cropLeft || 0,
              s = e.cropTop || 0,
              o = e.cropWidth || t - a,
              u = e.cropHeight || r - s,
              c = e.displayWidth || o,
              l = e.displayHeight || u;
            return this.validateDimension (t), this.validateDimension (
              r
            ), this.validateDimension (n), this.validateDimension (
              i
            ), this.validateOffset (a), this.validateOffset (
              s
            ), this.validateDimension (o), this.validateDimension (
              u
            ), this.validateDimension (c), this.validateDimension (l), {
              width: t,
              height: r,
              chromaWidth: n,
              chromaHeight: i,
              cropLeft: a,
              cropTop: s,
              cropWidth: o,
              cropHeight: u,
              displayWidth: c,
              displayHeight: l,
            };
          },
          allocPlane: function (e, r) {
            return t.validateDimension (e), t.validateDimension (r), {
              bytes: new Uint8Array (e * r),
              stride: e,
            };
          },
          suitableStride: function (e) {
            t.validateDimension (e);
            var r = e % 4;
            return 0 == r ? e : e + (4 - r);
          },
          allocPlane: function (e, t, r, n, i) {
            var a, s;
            if (
              (this.validateDimension (e), this.validateDimension (t), (i =
                i || 0), (n =
                n || this.suitableStride (e)), this.validateDimension (n), n <
                e)
            )
              throw 'Invalid input stride for YUV plane; must be larger than width';
            if (((a = n * t), r)) {
              if (r.length - i < a)
                throw 'Invalid input buffer for YUV plane; must be large enough for stride times height';
              s = r.slice (i, i + a);
            } else (s = new Uint8Array (a)), (n = n || this.suitableStride (e));
            return {bytes: s, stride: n};
          },
          lumaPlane: function (e, t, r, n) {
            return this.allocPlane (e.width, e.height, t, r, n);
          },
          chromaPlane: function (e, t, r, n) {
            return this.allocPlane (e.chromaWidth, e.chromaHeight, t, r, n);
          },
          frame: function (e, t, r, n) {
            return {
              format: e,
              y: (t = t || this.lumaPlane (e)),
              u: (r = r || this.chromaPlane (e)),
              v: (n = n || this.chromaPlane (e)),
            };
          },
          copyPlane: function (e) {
            return {bytes: e.bytes.slice (), stride: e.stride};
          },
          copyFrame: function (e) {
            return {
              format: e.format,
              y: this.copyPlane (e.y),
              u: this.copyPlane (e.u),
              v: this.copyPlane (e.v),
            };
          },
          transferables: function (e) {
            return [e.y.bytes.buffer, e.u.bytes.buffer, e.v.bytes.buffer];
          },
        };
        e.exports = t;
      },
      826: e => {
        e.exports = {
          vertex: 'precision lowp float;\n\nattribute vec2 aPosition;\nattribute vec2 aLumaPosition;\nattribute vec2 aChromaPosition;\nvarying vec2 vLumaPosition;\nvarying vec2 vChromaPosition;\nvoid main() {\n    gl_Position = vec4(aPosition, 0, 1);\n    vLumaPosition = aLumaPosition;\n    vChromaPosition = aChromaPosition;\n}\n',
          fragment: '// inspired by https://github.com/mbebenita/Broadway/blob/master/Player/canvas.js\n\nprecision lowp float;\n\nuniform sampler2D uTextureY;\nuniform sampler2D uTextureCb;\nuniform sampler2D uTextureCr;\nvarying vec2 vLumaPosition;\nvarying vec2 vChromaPosition;\nvoid main() {\n   // Y, Cb, and Cr planes are uploaded as LUMINANCE textures.\n   float fY = texture2D(uTextureY, vLumaPosition).x;\n   float fCb = texture2D(uTextureCb, vChromaPosition).x;\n   float fCr = texture2D(uTextureCr, vChromaPosition).x;\n\n   // Premultipy the Y...\n   float fYmul = fY * 1.1643828125;\n\n   // And convert that to RGB!\n   gl_FragColor = vec4(\n     fYmul + 1.59602734375 * fCr - 0.87078515625,\n     fYmul - 0.39176171875 * fCb - 0.81296875 * fCr + 0.52959375,\n     fYmul + 2.017234375   * fCb - 1.081390625,\n     1\n   );\n}\n',
          vertexStripe: 'precision lowp float;\n\nattribute vec2 aPosition;\nattribute vec2 aTexturePosition;\nvarying vec2 vTexturePosition;\n\nvoid main() {\n    gl_Position = vec4(aPosition, 0, 1);\n    vTexturePosition = aTexturePosition;\n}\n',
          fragmentStripe: "// extra 'stripe' texture fiddling to work around IE 11's poor performance on gl.LUMINANCE and gl.ALPHA textures\n\nprecision lowp float;\n\nuniform sampler2D uStripe;\nuniform sampler2D uTexture;\nvarying vec2 vTexturePosition;\nvoid main() {\n   // Y, Cb, and Cr planes are mapped into a pseudo-RGBA texture\n   // so we can upload them without expanding the bytes on IE 11\n   // which doesn't allow LUMINANCE or ALPHA textures\n   // The stripe textures mark which channel to keep for each pixel.\n   // Each texture extraction will contain the relevant value in one\n   // channel only.\n\n   float fLuminance = dot(\n      texture2D(uStripe, vTexturePosition),\n      texture2D(uTexture, vTexturePosition)\n   );\n\n   gl_FragColor = vec4(fLuminance, fLuminance, fLuminance, 1);\n}\n",
        };
      },
      487: e => {
        !(function () {
          'use strict';
          function t (e, t) {
            throw new Error ('abstract');
          }
          (t.prototype.drawFrame = function (e) {
            throw new Error ('abstract');
          }), (t.prototype.clear = function () {
            throw new Error ('abstract');
          }), (e.exports = t);
        }) ();
      },
      926: (e, t, r) => {
        !(function () {
          'use strict';
          var t = r (487), n = r (627);
          function i (e) {
            var t = this, r = e.getContext ('2d'), i = null, a = null, s = null;
            return (t.drawFrame = function (t) {
              var o = t.format;
              (e.width === o.displayWidth && e.height === o.displayHeight) ||
                ((e.width = o.displayWidth), (e.height =
                  o.displayHeight)), (null !== i &&
                i.width == o.width &&
                i.height == o.height) ||
                (function (e, t) {
                  for (
                    var n = (i = r.createImageData (e, t)).data,
                      a = e * t * 4,
                      s = 0;
                    s < a;
                    s += 4
                  )
                    n[s + 3] = 255;
                }) (o.width, o.height), n.convertYCbCr (t, i.data);
              var u,
                c,
                l,
                h =
                  o.cropWidth != o.displayWidth ||
                  o.cropHeight != o.displayHeight;
              h
                ? (a ||
                    ((c = o.cropWidth), (l =
                      o.cropHeight), ((a = document.createElement (
                      'canvas'
                    )).width = c), (a.height = l), (s = a.getContext (
                      '2d'
                    ))), (u = s))
                : (u = r), u.putImageData (
                i,
                -o.cropLeft,
                -o.cropTop,
                o.cropLeft,
                o.cropTop,
                o.cropWidth,
                o.cropHeight
              ), h && r.drawImage (a, 0, 0, o.displayWidth, o.displayHeight);
            }), (t.clear = function () {
              r.clearRect (0, 0, e.width, e.height);
            }), t;
          }
          (i.prototype = Object.create (t.prototype)), (e.exports = i);
        }) ();
      },
      895: (e, t, r) => {
        !(function () {
          'use strict';
          var t = r (487), n = r (826);
          function i (e) {
            var t, r, a = this, s = i.contextForCanvas (e);
            if (null === s) throw new Error ('WebGL unavailable');
            function o (e, t) {
              var r = s.createShader (e);
              if (
                (s.shaderSource (r, t), s.compileShader (
                  r
                ), !s.getShaderParameter (r, s.COMPILE_STATUS))
              ) {
                var n = s.getShaderInfoLog (r);
                throw (s.deleteShader (r), new Error (
                  'GL shader compilation for ' + e + ' failed: ' + n
                ));
              }
              return r;
            }
            var u,
              c,
              l,
              h,
              f,
              d,
              p,
              _,
              v,
              g,
              y = new Float32Array ([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
              m = {},
              b = {},
              E = {};
            function x (e, t) {
              return (m[e] && !t) || (m[e] = s.createTexture ()), m[e];
            }
            function w (e, t, r, n, a) {
              var o = x (e, t);
              if ((s.activeTexture (s.TEXTURE0), i.stripe)) {
                var u = !m[e + '_temp'] || t, c = x (e + '_temp', t);
                s.bindTexture (s.TEXTURE_2D, c), u
                  ? (s.texParameteri (
                      s.TEXTURE_2D,
                      s.TEXTURE_WRAP_S,
                      s.CLAMP_TO_EDGE
                    ), s.texParameteri (
                      s.TEXTURE_2D,
                      s.TEXTURE_WRAP_T,
                      s.CLAMP_TO_EDGE
                    ), s.texParameteri (
                      s.TEXTURE_2D,
                      s.TEXTURE_MIN_FILTER,
                      s.NEAREST
                    ), s.texParameteri (
                      s.TEXTURE_2D,
                      s.TEXTURE_MAG_FILTER,
                      s.NEAREST
                    ), s.texImage2D (
                      s.TEXTURE_2D,
                      0,
                      s.RGBA,
                      r / 4,
                      n,
                      0,
                      s.RGBA,
                      s.UNSIGNED_BYTE,
                      a
                    ))
                  : s.texSubImage2D (
                      s.TEXTURE_2D,
                      0,
                      0,
                      0,
                      r / 4,
                      n,
                      s.RGBA,
                      s.UNSIGNED_BYTE,
                      a
                    );
                var l = m[e + '_stripe'], h = !l || t;
                h && (l = x (e + '_stripe', t)), s.bindTexture (
                  s.TEXTURE_2D,
                  l
                ), h &&
                  (s.texParameteri (
                    s.TEXTURE_2D,
                    s.TEXTURE_WRAP_S,
                    s.CLAMP_TO_EDGE
                  ), s.texParameteri (
                    s.TEXTURE_2D,
                    s.TEXTURE_WRAP_T,
                    s.CLAMP_TO_EDGE
                  ), s.texParameteri (
                    s.TEXTURE_2D,
                    s.TEXTURE_MIN_FILTER,
                    s.NEAREST
                  ), s.texParameteri (
                    s.TEXTURE_2D,
                    s.TEXTURE_MAG_FILTER,
                    s.NEAREST
                  ), s.texImage2D (
                    s.TEXTURE_2D,
                    0,
                    s.RGBA,
                    r,
                    1,
                    0,
                    s.RGBA,
                    s.UNSIGNED_BYTE,
                    (function (e) {
                      if (E[e]) return E[e];
                      for (
                        var t = e, r = new Uint32Array (t), n = 0;
                        n < t;
                        n += 4
                      )
                        (r[n] = 255), (r[n + 1] = 65280), (r[
                          n + 2
                        ] = 16711680), (r[n + 3] = 4278190080);
                      return (E[e] = new Uint8Array (r.buffer));
                    }) (r)
                  ));
              } else
                s.bindTexture (s.TEXTURE_2D, o), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_WRAP_S,
                  s.CLAMP_TO_EDGE
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_WRAP_T,
                  s.CLAMP_TO_EDGE
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_MIN_FILTER,
                  s.LINEAR
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_MAG_FILTER,
                  s.LINEAR
                ), s.texImage2D (
                  s.TEXTURE_2D,
                  0,
                  s.LUMINANCE,
                  r,
                  n,
                  0,
                  s.LUMINANCE,
                  s.UNSIGNED_BYTE,
                  a
                );
            }
            function S (e, t, n, i) {
              var a = m[e];
              s.useProgram (r);
              var o = b[e];
              (o && !t) ||
                (s.activeTexture (s.TEXTURE0), s.bindTexture (
                  s.TEXTURE_2D,
                  a
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_WRAP_S,
                  s.CLAMP_TO_EDGE
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_WRAP_T,
                  s.CLAMP_TO_EDGE
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_MIN_FILTER,
                  s.LINEAR
                ), s.texParameteri (
                  s.TEXTURE_2D,
                  s.TEXTURE_MAG_FILTER,
                  s.LINEAR
                ), s.texImage2D (
                  s.TEXTURE_2D,
                  0,
                  s.RGBA,
                  n,
                  i,
                  0,
                  s.RGBA,
                  s.UNSIGNED_BYTE,
                  null
                ), (o = b[e] = s.createFramebuffer ())), s.bindFramebuffer (
                s.FRAMEBUFFER,
                o
              ), s.framebufferTexture2D (
                s.FRAMEBUFFER,
                s.COLOR_ATTACHMENT0,
                s.TEXTURE_2D,
                a,
                0
              );
              var p = m[e + '_temp'];
              s.activeTexture (s.TEXTURE1), s.bindTexture (
                s.TEXTURE_2D,
                p
              ), s.uniform1i (d, 1);
              var _ = m[e + '_stripe'];
              s.activeTexture (s.TEXTURE2), s.bindTexture (
                s.TEXTURE_2D,
                _
              ), s.uniform1i (f, 2), s.bindBuffer (
                s.ARRAY_BUFFER,
                u
              ), s.enableVertexAttribArray (c), s.vertexAttribPointer (
                c,
                2,
                s.FLOAT,
                !1,
                0,
                0
              ), s.bindBuffer (s.ARRAY_BUFFER, l), s.enableVertexAttribArray (
                h
              ), s.vertexAttribPointer (h, 2, s.FLOAT, !1, 0, 0), s.viewport (
                0,
                0,
                n,
                i
              ), s.drawArrays (
                s.TRIANGLES,
                0,
                y.length / 2
              ), s.bindFramebuffer (s.FRAMEBUFFER, null);
            }
            function A (e, r, n) {
              s.activeTexture (r), s.bindTexture (
                s.TEXTURE_2D,
                m[e]
              ), s.texParameteri (
                s.TEXTURE_2D,
                s.TEXTURE_WRAP_S,
                s.CLAMP_TO_EDGE
              ), s.texParameteri (
                s.TEXTURE_2D,
                s.TEXTURE_WRAP_T,
                s.CLAMP_TO_EDGE
              ), s.texParameteri (
                s.TEXTURE_2D,
                s.TEXTURE_MIN_FILTER,
                s.LINEAR
              ), s.texParameteri (
                s.TEXTURE_2D,
                s.TEXTURE_MAG_FILTER,
                s.LINEAR
              ), s.uniform1i (s.getUniformLocation (t, e), n);
            }
            function P (e, t) {
              var r = o (s.VERTEX_SHADER, e),
                n = o (s.FRAGMENT_SHADER, t),
                i = s.createProgram ();
              if (
                (s.attachShader (i, r), s.attachShader (i, n), s.linkProgram (
                  i
                ), !s.getProgramParameter (i, s.LINK_STATUS))
              ) {
                var a = s.getProgramInfoLog (i);
                throw (s.deleteProgram (i), new Error (
                  'GL program linking failed: ' + a
                ));
              }
              return i;
            }
            return (a.drawFrame = function (o) {
              var m = o.format,
                b =
                  !t ||
                  e.width !== m.displayWidth ||
                  e.height !== m.displayHeight;
              if (
                (b &&
                  ((e.width = m.displayWidth), (e.height =
                    m.displayHeight), a.clear ()), t ||
                  (function () {
                    if (i.stripe) {
                      (r = P (
                        n.vertexStripe,
                        n.fragmentStripe
                      )), s.getAttribLocation (
                        r,
                        'aPosition'
                      ), (l = s.createBuffer ());
                      var e = new Float32Array ([
                        0,
                        0,
                        1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        1,
                        0,
                        1,
                        1,
                      ]);
                      s.bindBuffer (s.ARRAY_BUFFER, l), s.bufferData (
                        s.ARRAY_BUFFER,
                        e,
                        s.STATIC_DRAW
                      ), (h = s.getAttribLocation (
                        r,
                        'aTexturePosition'
                      )), (f = s.getUniformLocation (
                        r,
                        'uStripe'
                      )), (d = s.getUniformLocation (r, 'uTexture'));
                    }
                    (t = P (
                      n.vertex,
                      n.fragment
                    )), (u = s.createBuffer ()), s.bindBuffer (
                      s.ARRAY_BUFFER,
                      u
                    ), s.bufferData (
                      s.ARRAY_BUFFER,
                      y,
                      s.STATIC_DRAW
                    ), (c = s.getAttribLocation (
                      t,
                      'aPosition'
                    )), (p = s.createBuffer ()), (_ = s.getAttribLocation (
                      t,
                      'aLumaPosition'
                    )), (v = s.createBuffer ()), (g = s.getAttribLocation (
                      t,
                      'aChromaPosition'
                    ));
                  }) (), b)
              ) {
                var E = function (e, t, r) {
                  var n = m.cropLeft / r,
                    i = (m.cropLeft + m.cropWidth) / r,
                    a = (m.cropTop + m.cropHeight) / m.height,
                    o = m.cropTop / m.height,
                    u = new Float32Array ([n, a, i, a, n, o, n, o, i, a, i, o]);
                  s.bindBuffer (s.ARRAY_BUFFER, e), s.bufferData (
                    s.ARRAY_BUFFER,
                    u,
                    s.STATIC_DRAW
                  );
                };
                E (p, 0, o.y.stride), E (
                  v,
                  0,
                  o.u.stride * m.width / m.chromaWidth
                );
              }
              w ('uTextureY', b, o.y.stride, m.height, o.y.bytes), w (
                'uTextureCb',
                b,
                o.u.stride,
                m.chromaHeight,
                o.u.bytes
              ), w (
                'uTextureCr',
                b,
                o.v.stride,
                m.chromaHeight,
                o.v.bytes
              ), i.stripe &&
                (S ('uTextureY', b, o.y.stride, m.height), S (
                  'uTextureCb',
                  b,
                  o.u.stride,
                  m.chromaHeight
                ), S (
                  'uTextureCr',
                  b,
                  o.v.stride,
                  m.chromaHeight
                )), s.useProgram (t), s.viewport (0, 0, e.width, e.height), A (
                'uTextureY',
                s.TEXTURE0,
                0
              ), A ('uTextureCb', s.TEXTURE1, 1), A (
                'uTextureCr',
                s.TEXTURE2,
                2
              ), s.bindBuffer (s.ARRAY_BUFFER, u), s.enableVertexAttribArray (
                c
              ), s.vertexAttribPointer (c, 2, s.FLOAT, !1, 0, 0), s.bindBuffer (
                s.ARRAY_BUFFER,
                p
              ), s.enableVertexAttribArray (_), s.vertexAttribPointer (
                _,
                2,
                s.FLOAT,
                !1,
                0,
                0
              ), s.bindBuffer (s.ARRAY_BUFFER, v), s.enableVertexAttribArray (
                g
              ), s.vertexAttribPointer (g, 2, s.FLOAT, !1, 0, 0), s.drawArrays (
                s.TRIANGLES,
                0,
                y.length / 2
              );
            }), (a.clear = function () {
              s.viewport (0, 0, e.width, e.height), s.clearColor (
                0,
                0,
                0,
                0
              ), s.clear (s.COLOR_BUFFER_BIT);
            }), a.clear (), a;
          }
          (i.stripe =
            -1 !==
            navigator.userAgent.indexOf (
              'Windows'
            )), (i.contextForCanvas = function (e) {
            var t = {
              preferLowPowerToHighPerformance: !0,
              powerPreference: 'low-power',
              failIfMajorPerformanceCaveat: !0,
              preserveDrawingBuffer: !0,
            };
            return (
              e.getContext ('webgl', t) ||
              e.getContext ('experimental-webgl', t)
            );
          }), (i.isAvailable = function () {
            var e, t = document.createElement ('canvas');
            (t.width = 1), (t.height = 1);
            try {
              e = i.contextForCanvas (t);
            } catch (e) {
              return !1;
            }
            if (e) {
              var r = e.TEXTURE0,
                n = e.createTexture (),
                a = new Uint8Array (16),
                s = i.stripe ? 1 : 4,
                o = i.stripe ? e.RGBA : e.LUMINANCE,
                u = i.stripe ? e.NEAREST : e.LINEAR;
              return e.activeTexture (r), e.bindTexture (
                e.TEXTURE_2D,
                n
              ), e.texParameteri (
                e.TEXTURE_2D,
                e.TEXTURE_WRAP_S,
                e.CLAMP_TO_EDGE
              ), e.texParameteri (
                e.TEXTURE_2D,
                e.TEXTURE_WRAP_T,
                e.CLAMP_TO_EDGE
              ), e.texParameteri (
                e.TEXTURE_2D,
                e.TEXTURE_MIN_FILTER,
                u
              ), e.texParameteri (
                e.TEXTURE_2D,
                e.TEXTURE_MAG_FILTER,
                u
              ), e.texImage2D (
                e.TEXTURE_2D,
                0,
                o,
                s,
                4,
                0,
                o,
                e.UNSIGNED_BYTE,
                a
              ), !e.getError ();
            }
            return !1;
          }), (i.prototype = Object.create (t.prototype)), (e.exports = i);
        }) ();
      },
      627: (e, t, r) => {
        !(function () {
          'use strict';
          var t = r (877);
          /**
     * Basic YCbCr->RGB conversion
     *
     * @author Brion Vibber <brion@pobox.com>
     * @copyright 2014-2019
     * @license MIT-style
     *
     * @param {YUVFrame} buffer - input frame buffer
     * @param {Uint8ClampedArray} output - array to draw RGBA into
     * Assumes that the output array already has alpha channel set to opaque.
     */ e.exports = {
            convertYCbCr: function (e, r) {
              var n = 0 | e.format.width,
                i = 0 | e.format.height,
                a = 0 | t (e.format.width / e.format.chromaWidth),
                s = 0 | t (e.format.height / e.format.chromaHeight),
                o = e.y.bytes,
                u = e.u.bytes,
                c = e.v.bytes,
                l = 0 | e.y.stride,
                h = 0 | e.u.stride,
                f = 0 | e.v.stride,
                d = n << 2,
                p = 0,
                _ = 0,
                v = 0,
                g = 0,
                y = 0,
                m = 0,
                b = 0,
                E = 0,
                x = 0,
                w = 0,
                S = 0,
                A = 0,
                P = 0,
                C = 0,
                L = 0,
                k = 0,
                T = 0,
                R = 0;
              if (1 == a && 1 == s)
                for ((b = 0), (E = d), (R = 0), (k = 0); k < i; k += 2) {
                  for (
                    (v = ((_ = (k * l) | 0) + l) | 0), (g = (R * h) | 0), (y =
                      (R * f) | 0), (L = 0);
                    L < n;
                    L += 2
                  )
                    (x = 0 | u[g++]), (A =
                      (((409 * (w = 0 | c[y++])) | 0) - 57088) | 0), (P =
                      (((100 * x) | 0) + ((208 * w) | 0) - 34816) | 0), (C =
                      (((516 * x) | 0) - 70912) | 0), (S =
                      (298 * o[_++]) | 0), (r[b] = (S + A) >> 8), (r[b + 1] =
                      (S - P) >> 8), (r[b + 2] = (S + C) >> 8), (b += 4), (S =
                      (298 * o[_++]) | 0), (r[b] = (S + A) >> 8), (r[b + 1] =
                      (S - P) >> 8), (r[b + 2] = (S + C) >> 8), (b += 4), (S =
                      (298 * o[v++]) | 0), (r[E] = (S + A) >> 8), (r[E + 1] =
                      (S - P) >> 8), (r[E + 2] = (S + C) >> 8), (E += 4), (S =
                      (298 * o[v++]) | 0), (r[E] = (S + A) >> 8), (r[E + 1] =
                      (S - P) >> 8), (r[E + 2] = (S + C) >> 8), (E += 4);
                  (b += d), (E += d), R++;
                }
              else
                for ((m = 0), (k = 0); k < i; k++)
                  for (
                    (T = 0), (p = (k * l) | 0), (g =
                      ((R = k >> s) * h) | 0), (y = (R * f) | 0), (L = 0);
                    L < n;
                    L++
                  )
                    (x = 0 | u[g + (T = L >> a)]), (A =
                      (((409 * (w = 0 | c[y + T])) | 0) - 57088) | 0), (P =
                      (((100 * x) | 0) + ((208 * w) | 0) - 34816) | 0), (C =
                      (((516 * x) | 0) - 70912) | 0), (S =
                      (298 * o[p++]) | 0), (r[m] = (S + A) >> 8), (r[m + 1] =
                      (S - P) >> 8), (r[m + 2] = (S + C) >> 8), (m += 4);
            },
          };
        }) ();
      },
      877: e => {
        !(function () {
          'use strict';
          /**
     * Convert a ratio into a bit-shift count; for instance a ratio of 2
     * becomes a bit-shift of 1, while a ratio of 1 is a bit-shift of 0.
     *
     * @author Brion Vibber <brion@pobox.com>
     * @copyright 2016
     * @license MIT-style
     *
     * @param {number} ratio - the integer ratio to convert.
     * @returns {number} - number of bits to shift to multiply/divide by the ratio.
     * @throws exception if given a non-power-of-two
     */ e.exports = function (
            e
          ) {
            for (var t = 0, r = e >> 1; 0 != r; )
              (r >>= 1), t++;
            if (e !== 1 << t)
              throw 'chroma plane dimensions must be power of 2 ratio to luma plane dimensions; got ' +
                e;
            return t;
          };
        }) ();
      },
      731: (e, t, r) => {
        !(function () {
          'use strict';
          var t = r (487),
            n = r (926),
            i = r (895),
            a = {
              FrameSink: t,
              SoftwareFrameSink: n,
              WebGLFrameSink: i,
              attach: function (e, t) {
                return ('webGL' in (t = t || {}) ? t.webGL : i.isAvailable ())
                  ? new i (e, t)
                  : new n (e, t);
              },
            };
          e.exports = a;
        }) ();
      },
    },
      t = {};
    function r (n) {
      var i = t[n];
      if (void 0 !== i) return i.exports;
      var a = (t[n] = {exports: {}});
      return e[n].call (a.exports, a, a.exports, r), a.exports;
    }
    (r.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return r.d (t, {a: t}), t;
    }), (r.d = (e, t) => {
      for (var n in t)
        r.o (t, n) &&
          !r.o (e, n) &&
          Object.defineProperty (e, n, {enumerable: !0, get: t[n]});
    }), (r.o = (e, t) =>
      Object.prototype.hasOwnProperty.call (e, t)), (r.r = e => {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty (e, Symbol.toStringTag, {
          value: 'Module',
        }), Object.defineProperty (e, '__esModule', {value: !0});
    });
    var n = {};
    return (() => {
      'use strict';
      function e (e, t) {
        if (!(e instanceof t))
          throw new TypeError ('Cannot call a class as a function');
      }
      function t (e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          (n.enumerable = n.enumerable || !1), (n.configurable = !0), 'value' in
            n && (n.writable = !0), Object.defineProperty (e, n.key, n);
        }
      }
      function i (e, r, n) {
        return r && t (e.prototype, r), n && t (e, n), e;
      }
      function a (e, t, r) {
        return t in e
          ? Object.defineProperty (e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = r), e;
      }
      function s (e) {
        return (s = 'function' == typeof Symbol &&
          'symbol' == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                'function' == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? 'symbol'
                : typeof e;
            }) (e);
      }
      function o (e, t, r, n, i, a) {
        a.beginPath (), 0 != n.status &&
          ((a.globalAlpha = n.opacity), 1 == n.status
            ? ((n.opacity -= EventStyle.opacitySpeed), n.opacity <= 0.5 &&
                ((n.opacity = 0.5), (n.status = 2)))
            : ((n.opacity += EventStyle.opacitySpeed), n.opacity >= 1 &&
                ((n.opacity = 1), (n.status = 1)))), (a.lineWidth = r), (a.strokeStyle = t), a.beginPath (), a.moveTo (
          e[0].x,
          e[0].y
        );
        for (var s = 1; s < e.length; s++)
          a.lineTo (e[s].x, e[s].y);
        a.closePath (), a.stroke (), i && i > 0
          ? ((a.globalAlpha = i * n.opacity), (a.fillStyle = t), a.fill ())
          : 0 != n.status &&
              ((a.globalAlpha =
                0.3 *
                n.opacity), (a.fillStyle = t), a.fill ()), (a.globalAlpha = 1);
      }
      function u (e, t, r, n) {
        var i = [], a = {x: e, y: t};
        i.push (a);
        var s = {x: e + r, y: t};
        i.push (s);
        var o = {x: e + r, y: t + n};
        i.push (o);
        var u = {x: e, y: t + n};
        return i.push (u), i;
      }
      r.r (n), r.d (n, {default: () => Er});
      var c,
        l = 'white',
        h = 1,
        f = (function () {
          function t (r, n, i) {
            e (
              this,
              t
            ), (this.tracklets = {}), (this.offlineCtx = r), (this.canvasWidth = n), (this.canvasHeight = i);
          }
          return i (t, [
            {
              key: 'setCanvas',
              value: function (e, t) {
                (this.canvasWidth = e), (this.canvasHeight = t);
              },
            },
            {
              key: 'style',
              value: function (e) {
                if (e.algo && AlgoObjectInfoMap[e.algo.appName]) {
                  switch (e.algo.objectType) {
                    case 'OBJECT_FACE':
                      return PreviewInfoObjectMap[1];
                    case 'OBJECT_PEDESTRIAN':
                      return PreviewInfoObjectMap[2];
                    case 'OBJECT_AUTOMOBILE':
                      return PreviewInfoObjectMap[3];
                    case 'OBJECT_CYCLIST':
                      return PreviewInfoObjectMap[4];
                    case 'OBJECT_HUMAN_POWERED_VEHICLE':
                      return PreviewInfoObjectMap[5];
                  }
                  var t = AlgoObjectInfoMap[e.algo.appName][e.algo.objectType];
                  if (t) return t;
                }
                return PreviewInfoObjectMap[e.objectType];
              },
            },
            {
              key: 'enqueue',
              value: function (e, t, r, n, i) {
                if (n && n.bounding) {
                  var a = 0;
                  this.offlineCtx.font = TextStyle.textFont;
                  var s = [], o = this.style (n);
                  if (o) {
                    var c = 1;
                    if (
                      ((c = t / r > this.canvasWidth / this.canvasHeight
                        ? this.canvasWidth / t
                        : this.canvasHeight / r), s.push (
                        o.title
                      ), n.attributes)
                    )
                      for (var f in o.attrs) {
                        var d = o.attrs[f],
                          p =
                            AttributeEnglishToChinese[n.attributes[f]] ||
                            n.attributes[f];
                        if (p) {
                          var _ = d + ': ' + p;
                          s.push (_);
                          var v = this.offlineCtx.measureText (_).width;
                          v > a && (a = v);
                        }
                      }
                    var g = n.bounding.vertices[1].x - n.bounding.vertices[0].x,
                      y = n.bounding.vertices[1].y - n.bounding.vertices[0].y,
                      m = n.bounding.vertices[0].x,
                      b = n.bounding.vertices[0].y;
                    (g *= c), (y *= c), (m *= c), (b *= c), (this.tracklets[
                      n.trackId
                    ] = {
                      roi: u (m, b, g, y),
                      object: n.objectId || '',
                      style: {
                        color: o.color || l,
                        lineWidth: o.lineWidth || h,
                        opacity: o.opacity || 0,
                        frameWidth: a + 8,
                      },
                      attr: {items: s},
                      animation: {
                        duration: o.duration || 200,
                        status: i,
                        opacity: 1,
                      },
                      ts: e,
                    });
                  }
                }
              },
            },
            {
              key: '_rendererTracklet',
              value: function (e, t) {
                o (
                  e.roi,
                  e.style.color,
                  e.style.lineWidth,
                  e.animation,
                  e.style.opacity,
                  t
                );
                var r = e.attr.items;
                if (r.length > 0) {
                  var n = 0, i = 0;
                  (n = e.roi[0].x), (i = e.roi[0].y);
                  for (var a = 1; a < e.roi.length; a++)
                    n < e.roi[a].x && (n = e.roi[a].x), i > e.roi[a].y &&
                      (i = e.roi[a].y);
                  (t.font = TextStyle.textFont), (t.textAlign =
                    'start'), r.forEach (function (r, a) {
                    (t.fillStyle =
                      TextStyle.textBackgroundColor), t.fillRect (n, i + TextStyle.lineSpace * a + TextStyle.textFrameInterval * a, e.style.frameWidth, TextStyle.textFrameInterval), (t.fillStyle = TextStyle.textColor), t.fillText (r, n + 4, i + TextStyle.lineSpace * a + TextStyle.textFrameInterval * (a + 1));
                  });
                }
              },
            },
            {
              key: 'render',
              value: function (e) {
                var t = this;
                Object.keys (this.tracklets).forEach (function (r) {
                  t._rendererTracklet (t.tracklets[r], t.offlineCtx);
                  var n = t.tracklets[r].ts;
                  e - n > t.tracklets[r].animation.duration &&
                    delete t.tracklets[r];
                });
              },
            },
            {
              key: 'clear',
              value: function () {
                var e = this;
                Object.keys (this.tracklets).forEach (function (t) {
                  delete e.tracklets[t];
                });
              },
            },
          ]), t;
        }) (),
        d = (a (
          (c = {
            jet: [
              {index: 0, rgb: [0, 0, 131]},
              {index: 0.125, rgb: [0, 60, 170]},
              {index: 0.375, rgb: [5, 255, 255]},
              {index: 0.625, rgb: [255, 255, 0]},
              {index: 0.875, rgb: [250, 0, 0]},
              {index: 1, rgb: [128, 0, 0]},
            ],
            hsv: [
              {index: 0, rgb: [255, 0, 0]},
              {index: 0.169, rgb: [253, 255, 2]},
              {index: 0.173, rgb: [247, 255, 2]},
              {index: 0.337, rgb: [0, 252, 4]},
              {index: 0.341, rgb: [0, 252, 10]},
              {index: 0.506, rgb: [1, 249, 255]},
              {index: 0.671, rgb: [2, 0, 253]},
              {index: 0.675, rgb: [8, 0, 253]},
              {index: 0.839, rgb: [255, 0, 251]},
              {index: 0.843, rgb: [255, 0, 245]},
              {index: 1, rgb: [255, 0, 6]},
            ],
            hot: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 0.3, rgb: [230, 0, 0]},
              {index: 0.6, rgb: [255, 210, 0]},
              {index: 1, rgb: [255, 255, 255]},
            ],
            cool: [
              {index: 0, rgb: [0, 255, 255]},
              {index: 1, rgb: [255, 0, 255]},
            ],
            spring: [
              {index: 0, rgb: [255, 0, 255]},
              {index: 1, rgb: [255, 255, 0]},
            ],
            summer: [
              {index: 0, rgb: [0, 128, 102]},
              {index: 1, rgb: [255, 255, 102]},
            ],
            autumn: [
              {index: 0, rgb: [255, 0, 0]},
              {index: 1, rgb: [255, 255, 0]},
            ],
            winter: [
              {index: 0, rgb: [0, 0, 255]},
              {index: 1, rgb: [0, 255, 128]},
            ],
            bone: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 0.376, rgb: [84, 84, 116]},
              {index: 0.753, rgb: [169, 200, 200]},
              {index: 1, rgb: [255, 255, 255]},
            ],
            copper: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 0.804, rgb: [255, 160, 102]},
              {index: 1, rgb: [255, 199, 127]},
            ],
            greys: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 1, rgb: [255, 255, 255]},
            ],
            yignbu: [
              {index: 0, rgb: [8, 29, 88]},
              {index: 0.125, rgb: [37, 52, 148]},
              {index: 0.25, rgb: [34, 94, 168]},
              {index: 0.375, rgb: [29, 145, 192]},
              {index: 0.5, rgb: [65, 182, 196]},
              {index: 0.625, rgb: [127, 205, 187]},
              {index: 0.75, rgb: [199, 233, 180]},
              {index: 0.875, rgb: [237, 248, 217]},
              {index: 1, rgb: [255, 255, 217]},
            ],
            greens: [
              {index: 0, rgb: [0, 68, 27]},
              {index: 0.125, rgb: [0, 109, 44]},
              {index: 0.25, rgb: [35, 139, 69]},
              {index: 0.375, rgb: [65, 171, 93]},
              {index: 0.5, rgb: [116, 196, 118]},
              {index: 0.625, rgb: [161, 217, 155]},
              {index: 0.75, rgb: [199, 233, 192]},
              {index: 0.875, rgb: [229, 245, 224]},
              {index: 1, rgb: [247, 252, 245]},
            ],
            yiorrd: [
              {index: 0, rgb: [128, 0, 38]},
              {index: 0.125, rgb: [189, 0, 38]},
              {index: 0.25, rgb: [227, 26, 28]},
              {index: 0.375, rgb: [252, 78, 42]},
              {index: 0.5, rgb: [253, 141, 60]},
              {index: 0.625, rgb: [254, 178, 76]},
              {index: 0.75, rgb: [254, 217, 118]},
              {index: 0.875, rgb: [255, 237, 160]},
              {index: 1, rgb: [255, 255, 204]},
            ],
            bluered: [
              {index: 0, rgb: [0, 0, 255]},
              {index: 1, rgb: [255, 0, 0]},
            ],
            rdbu: [
              {index: 0, rgb: [5, 10, 172]},
              {index: 0.35, rgb: [106, 137, 247]},
              {index: 0.5, rgb: [190, 190, 190]},
              {index: 0.6, rgb: [220, 170, 132]},
              {index: 0.7, rgb: [230, 145, 90]},
              {index: 1, rgb: [178, 10, 28]},
            ],
            picnic: [
              {index: 0, rgb: [0, 0, 255]},
              {index: 0.1, rgb: [51, 153, 255]},
              {index: 0.2, rgb: [102, 204, 255]},
              {index: 0.3, rgb: [153, 204, 255]},
              {index: 0.4, rgb: [204, 204, 255]},
              {index: 0.5, rgb: [255, 255, 255]},
              {index: 0.6, rgb: [255, 204, 255]},
              {index: 0.7, rgb: [255, 153, 255]},
              {index: 0.8, rgb: [255, 102, 204]},
              {index: 0.9, rgb: [255, 102, 102]},
              {index: 1, rgb: [255, 0, 0]},
            ],
            rainbow: [
              {index: 0, rgb: [150, 0, 90]},
              {index: 0.125, rgb: [0, 0, 200]},
              {index: 0.25, rgb: [0, 25, 255]},
              {index: 0.375, rgb: [0, 152, 255]},
              {index: 0.5, rgb: [44, 255, 150]},
              {index: 0.625, rgb: [151, 255, 0]},
              {index: 0.75, rgb: [255, 234, 0]},
              {index: 0.875, rgb: [255, 111, 0]},
              {index: 1, rgb: [255, 0, 0]},
            ],
            portland: [
              {index: 0, rgb: [12, 51, 131]},
              {index: 0.25, rgb: [10, 136, 186]},
              {index: 0.5, rgb: [242, 211, 56]},
              {index: 0.75, rgb: [242, 143, 56]},
              {index: 1, rgb: [217, 30, 30]},
            ],
            blackbody: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 0.2, rgb: [230, 0, 0]},
              {index: 0.4, rgb: [230, 210, 0]},
              {index: 0.7, rgb: [255, 255, 255]},
              {index: 1, rgb: [160, 200, 255]},
            ],
            earth: [
              {index: 0, rgb: [0, 0, 130]},
              {index: 0.1, rgb: [0, 180, 180]},
              {index: 0.2, rgb: [40, 210, 40]},
              {index: 0.4, rgb: [230, 230, 50]},
              {index: 0.6, rgb: [120, 70, 20]},
              {index: 1, rgb: [255, 255, 255]},
            ],
            electric: [
              {index: 0, rgb: [0, 0, 0]},
              {index: 0.15, rgb: [30, 0, 100]},
              {index: 0.4, rgb: [120, 0, 100]},
              {index: 0.6, rgb: [160, 90, 0]},
              {index: 0.8, rgb: [230, 200, 0]},
              {index: 1, rgb: [255, 250, 220]},
            ],
            alpha: [
              {index: 0, rgb: [255, 255, 255, 0]},
              {index: 1, rgb: [255, 255, 255, 1]},
            ],
            viridis: [
              {index: 0, rgb: [68, 1, 84]},
              {index: 0.13, rgb: [71, 44, 122]},
              {index: 0.25, rgb: [59, 81, 139]},
              {index: 0.38, rgb: [44, 113, 142]},
              {index: 0.5, rgb: [33, 144, 141]},
              {index: 0.63, rgb: [39, 173, 129]},
              {index: 0.75, rgb: [92, 200, 99]},
              {index: 0.88, rgb: [170, 220, 50]},
              {index: 1, rgb: [253, 231, 37]},
            ],
            inferno: [
              {index: 0, rgb: [0, 0, 4]},
              {index: 0.13, rgb: [31, 12, 72]},
              {index: 0.25, rgb: [85, 15, 109]},
              {index: 0.38, rgb: [136, 34, 106]},
              {index: 0.5, rgb: [186, 54, 85]},
              {index: 0.63, rgb: [227, 89, 51]},
              {index: 0.75, rgb: [249, 140, 10]},
              {index: 0.88, rgb: [249, 201, 50]},
              {index: 1, rgb: [252, 255, 164]},
            ],
            magma: [
              {index: 0, rgb: [0, 0, 4]},
              {index: 0.13, rgb: [28, 16, 68]},
              {index: 0.25, rgb: [79, 18, 123]},
              {index: 0.38, rgb: [129, 37, 129]},
              {index: 0.5, rgb: [181, 54, 122]},
              {index: 0.63, rgb: [229, 80, 100]},
              {index: 0.75, rgb: [251, 135, 97]},
              {index: 0.88, rgb: [254, 194, 135]},
              {index: 1, rgb: [252, 253, 191]},
            ],
            plasma: [
              {index: 0, rgb: [13, 8, 135]},
              {index: 0.13, rgb: [75, 3, 161]},
              {index: 0.25, rgb: [125, 3, 168]},
              {index: 0.38, rgb: [168, 34, 150]},
              {index: 0.5, rgb: [203, 70, 121]},
              {index: 0.63, rgb: [229, 107, 93]},
              {index: 0.75, rgb: [248, 148, 65]},
              {index: 0.88, rgb: [253, 195, 40]},
              {index: 1, rgb: [240, 249, 33]},
            ],
            warm: [
              {index: 0, rgb: [125, 0, 179]},
              {index: 0.13, rgb: [172, 0, 187]},
              {index: 0.25, rgb: [219, 0, 170]},
              {index: 0.38, rgb: [255, 0, 130]},
              {index: 0.5, rgb: [255, 63, 74]},
              {index: 0.63, rgb: [255, 123, 0]},
              {index: 0.75, rgb: [234, 176, 0]},
              {index: 0.88, rgb: [190, 228, 0]},
              {index: 1, rgb: [147, 255, 0]},
            ],
          }),
          'cool',
          [
            {index: 0, rgb: [125, 0, 179]},
            {index: 0.13, rgb: [116, 0, 218]},
            {index: 0.25, rgb: [98, 74, 237]},
            {index: 0.38, rgb: [68, 146, 231]},
            {index: 0.5, rgb: [0, 204, 197]},
            {index: 0.63, rgb: [0, 247, 146]},
            {index: 0.75, rgb: [0, 255, 88]},
            {index: 0.88, rgb: [40, 255, 8]},
            {index: 1, rgb: [147, 255, 0]},
          ]
        ), a (c, 'rainbow-soft', [
          {index: 0, rgb: [125, 0, 179]},
          {index: 0.1, rgb: [199, 0, 180]},
          {index: 0.2, rgb: [255, 0, 121]},
          {index: 0.3, rgb: [255, 108, 0]},
          {index: 0.4, rgb: [222, 194, 0]},
          {index: 0.5, rgb: [150, 255, 0]},
          {index: 0.6, rgb: [0, 255, 55]},
          {index: 0.7, rgb: [0, 246, 150]},
          {index: 0.8, rgb: [50, 167, 222]},
          {index: 0.9, rgb: [103, 51, 235]},
          {index: 1, rgb: [124, 0, 186]},
        ]), a (c, 'bathymetry', [
          {index: 0, rgb: [40, 26, 44]},
          {index: 0.13, rgb: [59, 49, 90]},
          {index: 0.25, rgb: [64, 76, 139]},
          {index: 0.38, rgb: [63, 110, 151]},
          {index: 0.5, rgb: [72, 142, 158]},
          {index: 0.63, rgb: [85, 174, 163]},
          {index: 0.75, rgb: [120, 206, 163]},
          {index: 0.88, rgb: [187, 230, 172]},
          {index: 1, rgb: [253, 254, 204]},
        ]), a (c, 'cdom', [
          {index: 0, rgb: [47, 15, 62]},
          {index: 0.13, rgb: [87, 23, 86]},
          {index: 0.25, rgb: [130, 28, 99]},
          {index: 0.38, rgb: [171, 41, 96]},
          {index: 0.5, rgb: [206, 67, 86]},
          {index: 0.63, rgb: [230, 106, 84]},
          {index: 0.75, rgb: [242, 149, 103]},
          {index: 0.88, rgb: [249, 193, 135]},
          {index: 1, rgb: [254, 237, 176]},
        ]), a (c, 'chlorophyll', [
          {index: 0, rgb: [18, 36, 20]},
          {index: 0.13, rgb: [25, 63, 41]},
          {index: 0.25, rgb: [24, 91, 59]},
          {index: 0.38, rgb: [13, 119, 72]},
          {index: 0.5, rgb: [18, 148, 80]},
          {index: 0.63, rgb: [80, 173, 89]},
          {index: 0.75, rgb: [132, 196, 122]},
          {index: 0.88, rgb: [175, 221, 162]},
          {index: 1, rgb: [215, 249, 208]},
        ]), a (c, 'density', [
          {index: 0, rgb: [54, 14, 36]},
          {index: 0.13, rgb: [89, 23, 80]},
          {index: 0.25, rgb: [110, 45, 132]},
          {index: 0.38, rgb: [120, 77, 178]},
          {index: 0.5, rgb: [120, 113, 213]},
          {index: 0.63, rgb: [115, 151, 228]},
          {index: 0.75, rgb: [134, 185, 227]},
          {index: 0.88, rgb: [177, 214, 227]},
          {index: 1, rgb: [230, 241, 241]},
        ]), a (c, 'freesurface-blue', [
          {index: 0, rgb: [30, 4, 110]},
          {index: 0.13, rgb: [47, 14, 176]},
          {index: 0.25, rgb: [41, 45, 236]},
          {index: 0.38, rgb: [25, 99, 212]},
          {index: 0.5, rgb: [68, 131, 200]},
          {index: 0.63, rgb: [114, 156, 197]},
          {index: 0.75, rgb: [157, 181, 203]},
          {index: 0.88, rgb: [200, 208, 216]},
          {index: 1, rgb: [241, 237, 236]},
        ]), a (c, 'freesurface-red', [
          {index: 0, rgb: [60, 9, 18]},
          {index: 0.13, rgb: [100, 17, 27]},
          {index: 0.25, rgb: [142, 20, 29]},
          {index: 0.38, rgb: [177, 43, 27]},
          {index: 0.5, rgb: [192, 87, 63]},
          {index: 0.63, rgb: [205, 125, 105]},
          {index: 0.75, rgb: [216, 162, 148]},
          {index: 0.88, rgb: [227, 199, 193]},
          {index: 1, rgb: [241, 237, 236]},
        ]), a (c, 'oxygen', [
          {index: 0, rgb: [64, 5, 5]},
          {index: 0.13, rgb: [106, 6, 15]},
          {index: 0.25, rgb: [144, 26, 7]},
          {index: 0.38, rgb: [168, 64, 3]},
          {index: 0.5, rgb: [188, 100, 4]},
          {index: 0.63, rgb: [206, 136, 11]},
          {index: 0.75, rgb: [220, 174, 25]},
          {index: 0.88, rgb: [231, 215, 44]},
          {index: 1, rgb: [248, 254, 105]},
        ]), a (c, 'par', [
          {index: 0, rgb: [51, 20, 24]},
          {index: 0.13, rgb: [90, 32, 35]},
          {index: 0.25, rgb: [129, 44, 34]},
          {index: 0.38, rgb: [159, 68, 25]},
          {index: 0.5, rgb: [182, 99, 19]},
          {index: 0.63, rgb: [199, 134, 22]},
          {index: 0.75, rgb: [212, 171, 35]},
          {index: 0.88, rgb: [221, 210, 54]},
          {index: 1, rgb: [225, 253, 75]},
        ]), a (c, 'phase', [
          {index: 0, rgb: [145, 105, 18]},
          {index: 0.13, rgb: [184, 71, 38]},
          {index: 0.25, rgb: [186, 58, 115]},
          {index: 0.38, rgb: [160, 71, 185]},
          {index: 0.5, rgb: [110, 97, 218]},
          {index: 0.63, rgb: [50, 123, 164]},
          {index: 0.75, rgb: [31, 131, 110]},
          {index: 0.88, rgb: [77, 129, 34]},
          {index: 1, rgb: [145, 105, 18]},
        ]), a (c, 'salinity', [
          {index: 0, rgb: [42, 24, 108]},
          {index: 0.13, rgb: [33, 50, 162]},
          {index: 0.25, rgb: [15, 90, 145]},
          {index: 0.38, rgb: [40, 118, 137]},
          {index: 0.5, rgb: [59, 146, 135]},
          {index: 0.63, rgb: [79, 175, 126]},
          {index: 0.75, rgb: [120, 203, 104]},
          {index: 0.88, rgb: [193, 221, 100]},
          {index: 1, rgb: [253, 239, 154]},
        ]), a (c, 'temperature', [
          {index: 0, rgb: [4, 35, 51]},
          {index: 0.13, rgb: [23, 51, 122]},
          {index: 0.25, rgb: [85, 59, 157]},
          {index: 0.38, rgb: [129, 79, 143]},
          {index: 0.5, rgb: [175, 95, 130]},
          {index: 0.63, rgb: [222, 112, 101]},
          {index: 0.75, rgb: [249, 146, 66]},
          {index: 0.88, rgb: [249, 196, 65]},
          {index: 1, rgb: [232, 250, 91]},
        ]), a (c, 'turbidity', [
          {index: 0, rgb: [34, 31, 27]},
          {index: 0.13, rgb: [65, 50, 41]},
          {index: 0.25, rgb: [98, 69, 52]},
          {index: 0.38, rgb: [131, 89, 57]},
          {index: 0.5, rgb: [161, 112, 59]},
          {index: 0.63, rgb: [185, 140, 66]},
          {index: 0.75, rgb: [202, 174, 88]},
          {index: 0.88, rgb: [216, 209, 126]},
          {index: 1, rgb: [233, 246, 171]},
        ]), a (c, 'velocity-blue', [
          {index: 0, rgb: [17, 32, 64]},
          {index: 0.13, rgb: [35, 52, 116]},
          {index: 0.25, rgb: [29, 81, 156]},
          {index: 0.38, rgb: [31, 113, 162]},
          {index: 0.5, rgb: [50, 144, 169]},
          {index: 0.63, rgb: [87, 173, 176]},
          {index: 0.75, rgb: [149, 196, 189]},
          {index: 0.88, rgb: [203, 221, 211]},
          {index: 1, rgb: [254, 251, 230]},
        ]), a (c, 'velocity-green', [
          {index: 0, rgb: [23, 35, 19]},
          {index: 0.13, rgb: [24, 64, 38]},
          {index: 0.25, rgb: [11, 95, 45]},
          {index: 0.38, rgb: [39, 123, 35]},
          {index: 0.5, rgb: [95, 146, 12]},
          {index: 0.63, rgb: [152, 165, 18]},
          {index: 0.75, rgb: [201, 186, 69]},
          {index: 0.88, rgb: [233, 216, 137]},
          {index: 1, rgb: [255, 253, 205]},
        ]), a (c, 'cubehelix', [
          {index: 0, rgb: [0, 0, 0]},
          {index: 0.07, rgb: [22, 5, 59]},
          {index: 0.13, rgb: [60, 4, 105]},
          {index: 0.2, rgb: [109, 1, 135]},
          {index: 0.27, rgb: [161, 0, 147]},
          {index: 0.33, rgb: [210, 2, 142]},
          {index: 0.4, rgb: [251, 11, 123]},
          {index: 0.47, rgb: [255, 29, 97]},
          {index: 0.53, rgb: [255, 54, 69]},
          {index: 0.6, rgb: [255, 85, 46]},
          {index: 0.67, rgb: [255, 120, 34]},
          {index: 0.73, rgb: [255, 157, 37]},
          {index: 0.8, rgb: [241, 191, 57]},
          {index: 0.87, rgb: [224, 220, 93]},
          {index: 0.93, rgb: [218, 241, 142]},
          {index: 1, rgb: [227, 253, 198]},
        ]), a (c, 'crowd', [
          {index: 0, rgba: [0, 0, 131, 0]},
          {index: 0.125, rgba: [0, 60, 170, 0.3]},
          {index: 0.3, rgba: [5, 255, 255, 0.3]},
          {index: 0.4, rgba: [255, 255, 0, 0.3]},
          {index: 0.5, rgba: [250, 0, 0, 0.3]},
          {index: 1, rgba: [128, 0, 0, 0.3]},
        ]), c),
        p = d.crowd,
        _ = (function () {
          function t (r) {
            e (this, t), this.updateConfig (r);
          }
          return i (t, [
            {
              key: '_configFromList',
              value: function (e) {
                for (var t, r = {}, n = 0; n < e.length; n++)
                  (t = e[n]).rgba
                    ? (r[t.index] =
                        'rgba(' +
                        t.rgba[0] +
                        ',' +
                        t.rgba[1] +
                        ',' +
                        t.rgba[2] +
                        ',' +
                        t.rgba[3] +
                        ')')
                    : (r[t.index] =
                        'rgb(' +
                        t.rgb[0] +
                        ',' +
                        t.rgb[1] +
                        ',' +
                        t.rgb[2] +
                        ')');
                return r;
              },
            },
            {
              key: 'updateConfig',
              value: function (e) {
                e && s (e) == s ('') && (e = d[e]), e &&
                  s (e) == s ([]) &&
                  (e = this._configFromList (e)), e ||
                  (console.log (
                    'colormap config not set, use default'
                  ), (e = this._configFromList (p)));
                var t = document.createElement ('canvas'),
                  r = t.getContext ('2d');
                (t.width = 256), (t.height = 1);
                var n = r.createLinearGradient (0, 0, 256, 1);
                for (var i in e)
                  n.addColorStop (i, e[i]);
                (r.fillStyle = n), r.fillRect (
                  0,
                  0,
                  256,
                  1
                ), (this.data = r.getImageData (0, 0, 256, 1).data);
              },
            },
            {
              key: 'getColor',
              value: function (e) {
                e < 0 ? (e = 0) : e > 255 && (e = 255);
                var t = 4 * e;
                return [
                  this.data[t],
                  this.data[t + 1],
                  this.data[t + 2],
                  this.data[t + 3],
                ];
              },
            },
          ]), t;
        }) ();
      var v = (function () {
        function t (r) {
          e (this, t), (this.src = new DataView (
            r.buffer,
            r.byteOffset,
            r.byteLength
          )), (this.bitpos = 0), (this.byte = this.src.getUint8 (
            0
          )), (this.bytepos = 0);
        }
        return i (t, [
          {
            key: 'readBits',
            value: function (e) {
              if (32 < (0 | e) || 0 == (0 | e)) throw new Error ('too big');
              for (var t = 0, r = e; r > 0; --r)
                (t =
                  ((0 | t) << 1) |
                  (((0 | this.byte) >> (8 - ++this.bitpos)) & 1)), (0 |
                  this.bitpos) >=
                  8 &&
                  ((this.byte = this.src.getUint8 (
                    ++this.bytepos
                  )), (this.bitpos &= 7));
              return t;
            },
          },
          {
            key: 'skipBits',
            value: function (e) {
              return (this.bitpos += 7 & (0 | e)), (this.bytepos +=
                (0 | e) >>> 3), this.bitpos > 7 &&
                ((this.bitpos &= 7), ++this.bytepos), this.finished ()
                ? this.bytepos - this.src.byteLength - this.src.bitpos
                : ((this.byte = this.src.getUint8 (this.bytepos)), 0);
            },
          },
          {
            key: 'finished',
            value: function () {
              return this.bytepos >= this.src.byteLength;
            },
          },
        ]), t;
      }) (),
        g = (function () {
          function t (r, n, i, a) {
            e (
              this,
              t
            ), (this.offlineCtx = r), (this.canvasWidth = n), (this.canvasHeight = i), (this.colormap = new _ (
              a
            )), (this.offlineHeatmapCanvas = document.createElement (
              'canvas'
            )), (this.offlineHeatmapCtx = this.offlineHeatmapCanvas.getContext (
              '2d'
            )), (this.offlineHeatmapCtx.show = !1), (this.offlineHeatmapCtx.duration =
              HeatmapStyle.duration || 200), (this.offlineHeatmapCtx.ts = 0);
          }
          return i (t, [
            {
              key: 'setCanvas',
              value: function (e, t) {
                (this.canvasWidth = e), (this.canvasHeight = t);
              },
            },
            {key: 'style', value: function (e) {}},
            {
              key: 'enqueue',
              value: function (e, t, r, n) {
                if (n && HeatmapStyle && HeatmapStyle.enable) {
                  if (8 == n.objectType && n.algo && n.algo.data) {
                    var i = JSON.parse (n.algo.data);
                    if (!i || !i.density_map) return;
                    var a = i.density_map,
                      s = (function (e) {
                        for (
                          var t = window.atob (e),
                            r = t.length,
                            n = new Uint8Array (r),
                            i = 0;
                          i < r;
                          i++
                        )
                          n[i] = t.charCodeAt (i);
                        return n.buffer;
                      }) (a.buffer),
                      o = (a.width * a.height * a.bits + 7) / 8;
                    (o = Math.floor (o)), (a.buffer = new v (
                      new Uint8Array (s, 0, o)
                    )), Console.isConsole &&
                      Console.consoleAlgo &&
                      (console.log (n), console.log (
                        a
                      )), (this.offlineHeatmapCanvas.width =
                      a.width), (this.offlineHeatmapCanvas.height = a.height);
                    for (
                      var u = this.offlineHeatmapCtx.getImageData (
                        0,
                        0,
                        a.width,
                        a.height
                      ),
                        c = 0;
                      c < a.height;
                      c++
                    )
                      for (var l = 0; l < a.width; l++)
                        (f = c * a.width + l) < 8 ||
                          ((h = a.buffer.readBits (a.bits)), (h <<=
                            8 - a.bits), (f *= 4), (d = this.colormap.getColor (
                            h
                          )), (u.data[f] = d[0]), (u.data[f + 1] =
                            d[1]), (u.data[f + 2] = d[2]), (u.data[f + 3] =
                            d[3]));
                    this.offlineHeatmapCtx.putImageData (
                      u,
                      0,
                      0
                    ), (this.offlineHeatmapCtx.show = !0), (this.offlineHeatmapCtx.content =
                      ''), (this.offlineHeatmapCtx.ts = e);
                  }
                  if (6 == n.objectType && n.crowd) {
                    Console.isConsole &&
                      Console.consoleCrowd &&
                      console.log (n), (this.offlineHeatmapCanvas.width =
                      n.crowd.densitySize.width), (this.offlineHeatmapCanvas.height =
                      n.crowd.densitySize.height);
                    var h, f, d;
                    for (
                      (u = this.offlineHeatmapCtx.getImageData (
                        0,
                        0,
                        n.crowd.densitySize.width,
                        n.crowd.densitySize.height
                      )), (c = 0);
                      c < n.crowd.densitySize.height;
                      c++
                    )
                      for (l = 0; l < n.crowd.densitySize.width; l++)
                        (f = c * n.crowd.densitySize.width + l), (h =
                          n.crowd.density[
                            f
                          ]), (f *= 4), (d = this.colormap.getColor (
                          h
                        )), (u.data[f] = d[0]), (u.data[f + 1] = d[1]), (u.data[
                          f + 2
                        ] =
                          d[2]), (u.data[f + 3] = d[3]);
                    this.offlineHeatmapCtx.putImageData (
                      u,
                      0,
                      0
                    ), (this.offlineHeatmapCtx.show = !0), (this.offlineHeatmapCtx.content =
                      HeatmapStyle.content +
                      n.crowd.quantity), (this.offlineHeatmapCtx.ts = e);
                  }
                }
              },
            },
            {
              key: 'render',
              value: function (e) {
                e - this.offlineHeatmapCtx.ts >=
                  this.offlineHeatmapCtx.duration &&
                  (this.offlineHeatmapCtx.show = !1), this.offlineHeatmapCtx
                  .show &&
                  (this.offlineCtx.drawImage (
                    this.offlineHeatmapCanvas,
                    0,
                    0,
                    this.canvasWidth,
                    this.canvasHeight
                  ), (this.offlineCtx.textAlign =
                    'left'), (this.offlineCtx.font =
                    HeatmapStyle.textFont), (this.offlineCtx.fillStyle =
                    HeatmapStyle.textColor), this.offlineCtx.fillText (
                    this.offlineHeatmapCtx.content,
                    HeatmapStyle.left,
                    HeatmapStyle.top,
                    HeatmapStyle.textWidth,
                    HeatmapStyle.textHeight
                  ));
              },
            },
            {
              key: 'clear',
              value: function () {
                this.offlineHeatmapCtx.show = !1;
              },
            },
          ]), t;
        }) (),
        y = 'black',
        m = 1,
        b = (function () {
          function t (r, n, i) {
            e (
              this,
              t
            ), (this.eventrules = {}), (this.offlineCtx = r), (this.canvasWidth = n), (this.canvasHeight = i);
          }
          return i (t, [
            {
              key: 'setCanvas',
              value: function (e, t) {
                (this.canvasWidth = e), (this.canvasHeight = t);
              },
            },
            {
              key: 'style',
              value: function (e) {
                return PreviewInfoEventMap[e.type];
              },
            },
            {
              key: '_addEventRule',
              value: function (e, t) {
                Console.isConsole &&
                  Console.consoleEventRule &&
                  console.log (t);
                var r = this.style (t);
                if (r) {
                  var n, i, a = !0;
                  for (i = 0; i < t.roi.vertices.length; i++)
                    if ((n = t.roi.vertices[i]).x > 1 || n.y > 1) {
                      a = !1;
                      break;
                    }
                  var s = this.scale, o = this.scale;
                  a && ((s = this.canvasWidth), (o = this.canvasHeight));
                  var u = [];
                  t.roi.vertices.forEach (function (e) {
                    var t = {x: e.x * s, y: e.y * o};
                    u.push (t);
                  }), (this.eventrules[t.ruleId] = {
                    type: t.type,
                    roi: u,
                    ts: e,
                    style: {
                      color: r.color || y,
                      lineWidth: r.lineWidth || m,
                      opacity: r.opacity || 0,
                    },
                    animation: {
                      duration: r.duration || 1e3,
                      status: 1,
                      opacity: 1,
                    },
                  });
                }
              },
            },
            {
              key: 'update',
              value: function (e, t, r, n) {
                var i = this, a = 1;
                (a = t / r > this.canvasWidth / this.canvasHeight
                  ? this.canvasWidth / t
                  : this.canvasHeight /
                      r), (this.scale = a), n.forEach (function (t) {
                  i._addEventRule (e, t);
                });
              },
            },
            {
              key: 'enqueue',
              value: function (e, t, r, n) {
                var i = this, a = 1;
                (a = t / r > this.canvasWidth / this.canvasHeight
                  ? this.canvasWidth / t
                  : this.canvasHeight / r), (this.scale = a);
                var s = !1;
                if (
                  (n.events &&
                    n.events.forEach (function (e) {
                      i.eventrules[e.ruleId] &&
                        ((s = !0), (i.eventrules[
                          e.ruleId
                        ].animation.status = 1));
                    }), n.algo && n.algo.data)
                ) {
                  var o = JSON.parse (n.algo.data);
                  o &&
                    o.rule &&
                    (this._addEventRule (e, o.rule), this.eventrules[
                      o.rule.ruleId
                    ] &&
                      ((this.eventrules[
                        o.rule.ruleId
                      ].animation.status = 1), (s = !0)));
                }
                return s;
              },
            },
            {
              key: '_renderEventrule',
              value: function (e, t, r) {
                e.type;
                if (
                  (r || ((e.animation.opacity = 1), (e.animation.status = 0)), e
                    .roi.length > 0 &&
                    (o (
                      e.roi,
                      e.style.color,
                      e.style.lineWidth,
                      e.animation,
                      e.style.opacity,
                      t
                    ), r))
                ) {
                  for (var n = 0, i = 0, a = 0; a < e.roi.length; a++)
                    (n += e.roi[a].x), (i += e.roi[a].y);
                  (n /= e.roi.length), (i /= e.roi.length), (t.textAlign =
                    'center'), (t.font = EventStyle.textFont);
                  var s = PreviewInfoEventMap[e.type].title,
                    u = t.measureText (s).width + 8;
                  (t.fillStyle = EventStyle.textBackgroundColor), t.fillRect (
                    n - u / 2,
                    i - EventStyle.textFrameInterval / 2,
                    u,
                    EventStyle.textFrameInterval
                  ), (t.fillStyle = EventStyle.textColor), t.fillText (
                    s,
                    n,
                    i -
                      EventStyle.textFrameInterval / 2 +
                      EventStyle.textFrameHeightPerLine,
                    u,
                    EventStyle.textFrameInterval
                  );
                }
              },
            },
            {
              key: 'render',
              value: function (e) {
                var t = this;
                Object.keys (this.eventrules).forEach (function (r) {
                  var n = t.eventrules[r].ts,
                    i = e - n < t.eventrules[r].animation.duration;
                  t._renderEventrule (t.eventrules[r], t.offlineCtx, i);
                });
              },
            },
            {
              key: 'clear',
              value: function () {
                var e = this;
                Object.keys (this.eventrules).forEach (function (t) {
                  delete e.eventrules[t];
                });
              },
            },
          ]), t;
        }) (),
        E = {
          canvas: '#canvas',
          canvasWidth: 1920,
          canvasHeight: 1080,
          video: '#player',
        },
        x = (function () {
          function t (r, n) {
            e (this, t), this._initConfig (
              r
            ), (this.previewTrackID = 0), (this.eventRenderer = new b (
              this.offlineCtx,
              this.canvasWidth,
              this.canvasHeight
            )), (this.objectRenderer = new f (
              this.offlineCtx,
              this.canvasWidth,
              this.canvasHeight
            )), (this.heatmapRenderer = new g (
              this.offlineCtx,
              this.canvasWidth,
              this.canvasHeight,
              n
            ));
          }
          return i (t, [
            {
              key: 'getColormap',
              value: function () {
                return this.heatmapRenderer.colormap;
              },
            },
            {
              key: '_initConfig',
              value: function (e) {
                s ((e = e || E).canvas) == s ('')
                  ? (this.canvas = document.getElementById (e.canvas))
                  : (this.canvas = e.canvas), s (e.video) == s ('')
                  ? (this.video = document.getElementById (e.video))
                  : (this.video = e.video), (this.ctx = this.canvas.getContext (
                  '2d'
                )), (this.offlineCanvas = document.createElement (
                  'canvas'
                )), (this.offlineCanvas.width =
                  e.video.offsetWidth), (this.offlineCanvas.height =
                  e.video.offsetHeight), (this.offlineCanvas.style.width =
                  e.video.offsetWidth +
                  'px'), (this.offlineCanvas.style.height =
                  e.video.offsetHeight +
                  'px'), (this.offlineCtx = this.offlineCanvas.getContext (
                  '2d'
                )), (this.canvasWidth =
                  e.video.offsetWidth), (this.canvasHeight =
                  e.video.offsetHeight);
              },
            },
            {
              key: 'restart',
              value: function () {
                this.objectRenderer.clear (), this.heatmapRenderer.clear (), this.eventRenderer.clear (), this.ctx.clearRect (
                  0,
                  0,
                  this.canvasWidth,
                  this.canvasHeight
                );
              },
            },
            {
              key: 'updateCanvas',
              value: function () {
                var e = this.video.offsetWidth, t = this.video.offsetHeight;
                (this.canvasWidth = e), (this.canvasHeight = t), (this.offlineCanvas.width = e), (this.offlineCanvas.height = t), (this.offlineCanvas.style.width =
                  e + 'px'), (this.offlineCanvas.style.height =
                  t + 'px'), this.objectRenderer.setCanvas (
                  e,
                  t
                ), this.heatmapRenderer.setCanvas (
                  e,
                  t
                ), this.eventRenderer.setCanvas (e, t);
              },
            },
            {
              key: 'render',
              value: function (e, t, r, n) {
                var i = this;
                this.updateCanvas (), this.offlineCtx.clearRect (
                  0,
                  0,
                  this.canvasWidth,
                  this.canvasHeight
                ), t &&
                  (t.rules &&
                    this.eventRenderer.update (
                      e,
                      r,
                      n,
                      t.rules
                    ), t.objects.forEach (function (t) {
                    (null != t.trackId && 0 != t.trackId) ||
                      (i.previewTrackID++, (t.trackId =
                        i.previewTrackID), i.previewTrackID > 1e6 &&
                        (i.previewTrackID = 0));
                    var a = i.eventRenderer.enqueue (e, r, n, t) ? 1 : 0;
                    i.objectRenderer.enqueue (
                      e,
                      r,
                      n,
                      t,
                      a
                    ), i.heatmapRenderer.enqueue (e, r, n, t, a);
                  })), this.heatmapRenderer.render (
                  e
                ), this.eventRenderer.render (e), this.objectRenderer.render (
                  e
                ), this.ctx.clearRect (
                  0,
                  0,
                  this.canvasWidth,
                  this.canvasHeight
                ), this.ctx.drawImage (
                  this.offlineCanvas,
                  0,
                  0,
                  this.canvasWidth,
                  this.canvasHeight
                );
              },
            },
          ]), t;
        }) (),
        w = {Error: 0, Warn: 1, Log: 2, Debug: 3},
        S = {wasmDebugMode: 0, defaultLogLevel: w.Debug, logLevels: {}};
      function A (e) {
        if (void 0 === e)
          throw new ReferenceError (
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function P (e, t) {
        return (P =
          Object.setPrototypeOf ||
          function (e, t) {
            return (e.__proto__ = t), e;
          }) (e, t);
      }
      function C (e, t) {
        if ('function' != typeof t && null !== t)
          throw new TypeError (
            'Super expression must either be null or a function'
          );
        (e.prototype = Object.create (t && t.prototype, {
          constructor: {value: e, writable: !0, configurable: !0},
        })), t && P (e, t);
      }
      function L (e, t) {
        if (t && ('object' === s (t) || 'function' == typeof t)) return t;
        if (void 0 !== t)
          throw new TypeError (
            'Derived constructors may only return object or undefined'
          );
        return A (e);
      }
      function k (e) {
        return (k = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (e) {
              return e.__proto__ || Object.getPrototypeOf (e);
            }) (e);
      }
      function T (e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array (t); r < t; r++)
          n[r] = e[r];
        return n;
      }
      function R (e, t) {
        if (e) {
          if ('string' == typeof e) return T (e, t);
          var r = Object.prototype.toString.call (e).slice (8, -1);
          return 'Object' === r &&
            e.constructor &&
            (r = e.constructor.name), 'Map' === r || 'Set' === r
            ? Array.from (e)
            : 'Arguments' === r ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test (r)
                ? T (e, t)
                : void 0;
        }
      }
      function N (e) {
        return (
          (function (e) {
            if (Array.isArray (e)) return T (e);
          }) (e) ||
          (function (e) {
            if (
              ('undefined' != typeof Symbol && null != e[Symbol.iterator]) ||
              null != e['@@iterator']
            )
              return Array.from (e);
          }) (e) ||
          R (e) ||
          (function () {
            throw new TypeError (
              'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          }) ()
        );
      }
      var U = (function () {
        function t () {
          e (this, t), a (this, 'map_', {});
        }
        return i (t, [
          {
            key: 'push',
            value: function (e, t) {
              this.map_.hasOwnProperty (e)
                ? this.map_[e].push (t)
                : (this.map_[e] = [t]);
            },
          },
          {
            key: 'get',
            value: function (e) {
              var t = this.map_[e];
              return t ? t.slice () : null;
            },
          },
          {
            key: 'getAll',
            value: function () {
              var e = [];
              for (var t in this.map_)
                e.push.apply (e, N (this.map_[t]));
              return e;
            },
          },
          {
            key: 'remove',
            value: function (e, t) {
              e in this.map_ &&
                ((this.map_[e] = this.map_[e].filter (function (e) {
                  return e != t;
                })), 0 == this.map_[e].length && delete this.map_[e]);
            },
          },
          {
            key: 'clear',
            value: function () {
              this.map_ = {};
            },
          },
          {
            key: 'forEach',
            value: function (e) {
              for (var t in this.map_)
                e (t, this.map_[t]);
            },
          },
          {
            key: 'size',
            value: function () {
              return Object.keys (this.map_).length;
            },
          },
          {
            key: 'keys',
            value: function () {
              return Object.keys (this.map_);
            },
          },
        ]), t;
      }) ();
      function H (e, t) {
        var r;
        if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
          if (
            Array.isArray (e) ||
            (r = (function (e, t) {
              if (!e) return;
              if ('string' == typeof e) return D (e, t);
              var r = Object.prototype.toString.call (e).slice (8, -1);
              'Object' === r && e.constructor && (r = e.constructor.name);
              if ('Map' === r || 'Set' === r) return Array.from (e);
              if (
                'Arguments' === r ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test (r)
              )
                return D (e, t);
            }) (e)) ||
            (t && e && 'number' == typeof e.length)
          ) {
            r && (e = r);
            var n = 0, i = function () {};
            return {
              s: i,
              n: function () {
                return n >= e.length ? {done: !0} : {done: !1, value: e[n++]};
              },
              e: function (e) {
                throw e;
              },
              f: i,
            };
          }
          throw new TypeError (
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        }
        var a, s = !0, o = !1;
        return {
          s: function () {
            r = e[Symbol.iterator] ();
          },
          n: function () {
            var e = r.next ();
            return (s = e.done), e;
          },
          e: function (e) {
            (o = !0), (a = e);
          },
          f: function () {
            try {
              s || null == r.return || r.return ();
            } finally {
              if (o) throw a;
            }
          },
        };
      }
      function D (e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array (t); r < t; r++)
          n[r] = e[r];
        return n;
      }
      var I = 'DecodedFrame',
        B = 'DemuxedOOB',
        V = 'MP4FragmentData',
        O = 'mediaInfo',
        F = 'Player.play',
        M = 'Player.pause',
        G = 'AudioPlayer.Canplay',
        j = 'VideoPlayer.Canplay',
        W = 'AudioPlayer.decodeError',
        z = 'RTSPClient.data',
        X = 'RTSPClient.videoNalu',
        q = 'RTSPClient.aac',
        Y = 'VideoProbeDone',
        K = 'AudioProbeDone',
        Q = 'VideoProcessorReady',
        $ = (function () {
          function t (r) {
            e (this, t), a (this, '_raw', void 0), a (
              this,
              '_evMap',
              void 0
            ), (this._raw = r), (this._evMap = new U ());
          }
          return i (t, [
            {
              key: 'removeAll',
              value: function () {
                var e = this;
                this._evMap &&
                  (this._evMap.forEach (function (t, r) {
                    var n, i = H (r);
                    try {
                      for (i.s (); !(n = i.n ()).done; ) {
                        var a = n.value;
                        e._raw.off (t, a);
                      }
                    } catch (e) {
                      i.e (e);
                    } finally {
                      i.f ();
                    }
                  }), this._evMap.clear ());
              },
            },
            {
              key: 'once',
              value: function (e, t) {
                var r = this;
                return this.on (e, function n () {
                  r.off (e, n), t.apply (void 0, arguments);
                }), this;
              },
            },
            {
              key: 'on',
              value: function (e, t) {
                if (this._evMap)
                  return this._evMap.push (e, t), this._raw.on (e, t), this;
              },
            },
            {
              key: 'off',
              value: function (e, t) {
                if (this._evMap)
                  return this._evMap.remove (e, t), this._raw.off (e, t), this;
              },
            },
            {
              key: 'emit',
              value: function (e) {
                for (
                  var t,
                    r = arguments.length,
                    n = new Array (r > 1 ? r - 1 : 0),
                    i = 1;
                  i < r;
                  i++
                )
                  n[i - 1] = arguments[i];
                return (t = this._raw).emit.apply (t, [e].concat (n)), this;
              },
            },
          ]), t;
        }) (),
        J = (function () {
          function t (r) {
            e (this, t), a (this, 'tag', void 0), a (
              this,
              'level',
              void 0
            ), (this.tag = r), S.logLevels[r]
              ? this.setLevel (this.level)
              : this.setLevel (S.defaultLogLevel);
          }
          return i (
            t,
            [
              {
                key: 'setTag',
                value: function (e) {
                  this.tag = e;
                },
              },
              {
                key: 'setLevel',
                value: function (e) {
                  this.level = e;
                },
              },
              {
                key: '_log',
                value: function (e) {
                  for (
                    var r = arguments.length,
                      n = new Array (r > 1 ? r - 1 : 0),
                      i = 1;
                    i < r;
                    i++
                  )
                    n[i - 1] = arguments[i];
                  (n = Array.prototype.slice.call (n)), this.tag &&
                    n.unshift ('['.concat (this.tag, ']')), this.level >= e &&
                    console[t.level_map[e]].apply (console, n);
                },
              },
              {
                key: 'log',
                value: function () {
                  for (
                    var e = arguments.length, t = new Array (e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  this._log.apply (this, [w.Log].concat (t));
                },
              },
              {
                key: 'debug',
                value: function () {
                  for (
                    var e = arguments.length, t = new Array (e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  this._log.apply (this, [w.Debug].concat (t));
                },
              },
              {
                key: 'error',
                value: function () {
                  for (
                    var e = arguments.length, t = new Array (e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  this._log.apply (this, [w.Error].concat (t));
                },
              },
              {
                key: 'warn',
                value: function () {
                  for (
                    var e = arguments.length, t = new Array (e), r = 0;
                    r < e;
                    r++
                  )
                    t[r] = arguments[r];
                  this._log.apply (this, [w.Warn].concat (t));
                },
              },
            ],
            [
              {
                key: 'level_map',
                get: function () {
                  var e;
                  return a ((e = {}), w.Debug, 'log'), a (e, w.Log, 'log'), a (
                    e,
                    w.Warn,
                    'warn'
                  ), a (e, w.Error, 'error'), e;
                },
              },
            ]
          ), t;
        }) ();
      const Z = (function () {
        function t (r) {
          e (this, t), a (this, 'options', void 0), a (
            this,
            'logger',
            void 0
          ), a (
            this,
            '_events',
            void 0
          ), (this.options = r), (this.logger = new J (
            this.constructor.name
          )), (this._events = new $ (r.events));
        }
        return i (t, [
          {
            key: 'setLogger',
            value: function (e) {
              this.logger.setTag (e);
            },
          },
          {
            key: 'events',
            get: function () {
              return this._events;
            },
          },
          {
            key: 'metrics',
            get: function () {
              return this.options.metrics;
            },
          },
          {
            key: 'once',
            value: function (e, t) {
              return this.events.once (e, t), this;
            },
          },
          {
            key: 'on',
            value: function (e, t) {
              return this.events.on (e, t), this;
            },
          },
          {
            key: 'off',
            value: function (e, t) {
              return this.events.off (e, t), this;
            },
          },
        ]), t;
      }) ();
      var ee = (function () {
        function t (r) {
          if (
            (e (this, t), a (this, '_buffer', void 0), a (
              this,
              '_capacity',
              void 0
            ), a (this, '_first', void 0), a (this, '_size', void 0), r % 1 !=
              0 || r < 1)
          )
            throw new TypeError ('Invalid capacity');
          (this._buffer = new Array (
            r
          )), (this._capacity = r), (this._first = 0), (this._size = 0);
        }
        return i (t, [
          {
            key: 'size',
            value: function () {
              return this._size;
            },
          },
          {
            key: 'capacity',
            value: function () {
              return this._capacity;
            },
          },
          {
            key: 'enq',
            value: function (e) {
              this._first > 0
                ? this._first--
                : (this._first = this._capacity - 1), (this._buffer[
                this._first
              ] = e), this._size < this._capacity && this._size++;
            },
          },
          {
            key: 'push',
            value: function (e) {
              this._size == this._capacity
                ? ((this._buffer[this._first] = e), (this._first =
                    (this._first + 1) % this._capacity))
                : ((this._buffer[
                    (this._first + this._size) % this._capacity
                  ] = e), this._size++);
            },
          },
          {
            key: 'deq',
            value: function () {
              if (0 == this._size)
                throw new RangeError ('dequeue on empty buffer');
              var e = this._buffer[
                (this._first + this._size - 1) % this._capacity
              ];
              return this._size--, e;
            },
          },
          {
            key: 'pop',
            value: function () {
              return this.deq ();
            },
          },
          {
            key: 'shift',
            value: function () {
              if (0 == this._size)
                throw new RangeError ('shift on empty buffer');
              var e = this._buffer[this._first];
              return this._first == this._capacity - 1
                ? (this._first = 0)
                : this._first++, this._size--, e;
            },
          },
          {
            key: 'get',
            value: function (e, t) {
              if (0 == this._size && 0 == e && (null == t || 0 == t)) return [];
              if ('number' != typeof e || e % 1 != 0 || e < 0)
                throw new TypeError ('Invalid start');
              if (e >= this._size)
                throw new RangeError ('Index past end of buffer: ' + e);
              if (null == t)
                return this._buffer[(this._first + e) % this._capacity];
              if ('number' != typeof t || t % 1 != 0 || t < 0)
                throw new TypeError ('Invalid end');
              if (t >= this._size)
                throw new RangeError ('Index past end of buffer: ' + t);
              return this._first + e >= this._capacity &&
                ((e -= this._capacity), (t -= this._capacity)), this._first +
                t <
                this._capacity
                ? this._buffer.slice (this._first + e, this._first + t + 1)
                : this._buffer
                    .slice (this._first + e, this._capacity)
                    .concat (
                      this._buffer.slice (
                        0,
                        this._first + t + 1 - this._capacity
                      )
                    );
            },
          },
          {
            key: 'toarray',
            value: function () {
              return 0 == this._size ? [] : this.get (0, this._size - 1);
            },
          },
        ]), t;
      }) ();
      function te (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var re = (function (t) {
        C (n, t);
        var r = te (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            '_oobBuffer',
            void 0
          ), (i._oobBuffer = new ee (1e3)), i.events.on (B, function (e) {
            i._oobBuffer.size () == i._oobBuffer.capacity () &&
              i._oobBuffer.deq (), i._oobBuffer.enq (e);
          }), i;
        }
        return i (n, [
          {
            key: 'pullOOBData',
            value: function (e) {
              for (var t = []; this._oobBuffer.size (); ) {
                if (
                  e <
                  this._oobBuffer.get (this._oobBuffer.size () - 1).scaledPTS
                )
                  break;
                t.push (this._oobBuffer.deq ());
              }
              return t;
            },
          },
        ]), n;
      }) (Z);
      function ne (e, t, r, n, i, a, s) {
        try {
          var o = e[a] (s), u = o.value;
        } catch (e) {
          return void r (e);
        }
        o.done ? t (u) : Promise.resolve (u).then (n, i);
      }
      function ie (e) {
        return function () {
          var t = this, r = arguments;
          return new Promise (function (n, i) {
            var a = e.apply (t, r);
            function s (e) {
              ne (a, n, i, s, o, 'next', e);
            }
            function o (e) {
              ne (a, n, i, s, o, 'throw', e);
            }
            s (void 0);
          });
        };
      }
      var ae = r (757), se = r.n (ae);
      function oe (e, t) {
        return (
          (function (e) {
            if (Array.isArray (e)) return e;
          }) (e) ||
          (function (e, t) {
            var r = null == e
              ? null
              : ('undefined' != typeof Symbol && e[Symbol.iterator]) ||
                  e['@@iterator'];
            if (null != r) {
              var n, i, a = [], s = !0, o = !1;
              try {
                for (
                  r = r.call (e);
                  !(s = (n = r.next ()).done) &&
                  (a.push (n.value), !t || a.length !== t);
                  s = !0
                );
              } catch (e) {
                (o = !0), (i = e);
              } finally {
                try {
                  s || null == r.return || r.return ();
                } finally {
                  if (o) throw i;
                }
              }
              return a;
            }
          }) (e, t) ||
          R (e, t) ||
          (function () {
            throw new TypeError (
              'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          }) ()
        );
      }
      var ue = function t () {
        e (this, t), a (this, 'full', void 0), a (this, 'protocol', void 0), a (
          this,
          'urlpath',
          void 0
        ), a (this, 'basename', void 0), a (this, 'basepath', void 0), a (
          this,
          'user',
          void 0
        ), a (this, 'pass', void 0), a (this, 'host', void 0), a (
          this,
          'auth',
          void 0
        ), a (this, 'port', void 0), a (this, 'portDefined', void 0), a (
          this,
          'location',
          void 0
        ), a (this, 'socket', void 0);
      },
        ce = (function () {
          function t () {
            e (this, t);
          }
          return i (t, null, [
            {
              key: 'parse',
              value: function (e) {
                var r = new ue (), n = /^([^:]+):\/\/([^\/]+)(.*)$/.exec (e);
                if (!n) throw new Error ('bad url');
                (r.full = e), (r.protocol = n[1]), (r.urlpath = n[3]);
                var i = r.urlpath.split ('/');
                (r.basename = i
                  .pop ()
                  .split (/\?|#/)[0]), (r.basepath = i.join ('/'));
                var a = n[2].split (/(.+)@(.+)$/).filter (function (e) {
                  return e;
                }),
                  s = a[0].split (':'),
                  o = [null, null];
                return 2 === a.length &&
                  ((o = a[0].split (':')), (s = a[1].split (':'))), (r.user =
                  o[0]), (r.pass = o[1]), (r.host = s[0]), (r.auth = r.user &&
                  r.pass
                  ? ''.concat (r.user, ':').concat (r.pass)
                  : ''), (r.port = null == s[1]
                  ? t.protocolDefaultPort (r.protocol)
                  : parseInt (s[1])), (r.portDefined =
                  null != s[1]), (r.location = ''
                  .concat (r.host, ':')
                  .concat (r.port)), 'unix' == r.protocol &&
                  ((r.socket = r.port), (r.port = void 0)), r;
              },
            },
            {
              key: 'full',
              value: function (e) {
                return ''
                  .concat (e.protocol, '://')
                  .concat (e.location, '/')
                  .concat (e.urlpath);
              },
            },
            {
              key: 'isAbsolute',
              value: function (e) {
                return /^[^:]+:\/\//.test (e);
              },
            },
            {
              key: 'protocolDefaultPort',
              value: function (e) {
                switch (e) {
                  case 'rtsp':
                    return 554;
                  case 'http':
                    return 80;
                  case 'https':
                    return 443;
                }
                return 0;
              },
            },
          ]), t;
        }) (),
        le = (function () {
          function t () {
            var r, n;
            e (this, t);
            var i = new Promise (function (e, t) {
              (r = e), (n = t);
            });
            return (i.resolve = r), (i.reject = n), i;
          }
          return i (t, [
            {key: 'resolve', value: function (e) {}},
            {key: 'reject', value: function (e) {}},
            {key: 'then', value: function (e) {}},
          ]), t;
        }) (),
        he = r (560),
        fe = r.n (he),
        de = r (766);
      function pe (e, t) {
        var r;
        if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
          if (
            Array.isArray (e) ||
            (r = (function (e, t) {
              if (!e) return;
              if ('string' == typeof e) return _e (e, t);
              var r = Object.prototype.toString.call (e).slice (8, -1);
              'Object' === r && e.constructor && (r = e.constructor.name);
              if ('Map' === r || 'Set' === r) return Array.from (e);
              if (
                'Arguments' === r ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test (r)
              )
                return _e (e, t);
            }) (e)) ||
            (t && e && 'number' == typeof e.length)
          ) {
            r && (e = r);
            var n = 0, i = function () {};
            return {
              s: i,
              n: function () {
                return n >= e.length ? {done: !0} : {done: !1, value: e[n++]};
              },
              e: function (e) {
                throw e;
              },
              f: i,
            };
          }
          throw new TypeError (
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        }
        var a, s = !0, o = !1;
        return {
          s: function () {
            r = e[Symbol.iterator] ();
          },
          n: function () {
            var e = r.next ();
            return (s = e.done), e;
          },
          e: function (e) {
            (o = !0), (a = e);
          },
          f: function () {
            try {
              s || null == r.return || r.return ();
            } finally {
              if (o) throw a;
            }
          },
        };
      }
      function _e (e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array (t); r < t; r++)
          n[r] = e[r];
        return n;
      }
      function ve (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var ge = function t () {
        e (this, t), a (this, 'headers', {}), a (this, 'body', void 0), a (
          this,
          'code',
          void 0
        ), a (this, 'statusLine', void 0);
      },
        ye = function t () {
          e (this, t), a (this, 'code', void 0), a (this, 'msg', void 0), a (
            this,
            'headers',
            {}
          ), a (this, 'payload', void 0);
        },
        me = (function (t) {
          C (y, t);
          var r, n, s, o, u, c, l, h, f, d, p, _, v, g = ve (y);
          function y (t) {
            var r, n, i;
            return e (this, y), a (
              A ((r = g.call (this, t))),
              '_headers',
              void 0
            ), a (A (r), '_parsedRTSPUrl', void 0), a (
              A (r),
              '_ctrlChannel',
              void 0
            ), a (A (r), '_dataChannel', void 0), a (
              A (r),
              '_dataJoinPromise',
              void 0
            ), a (A (r), '_wsurl', void 0), a (A (r), '_url', void 0), a (
              A (r),
              '_getSeq',
              void 0
            ), a (A (r), '_nextFreeInterleavedChannel', void 0), a (
              A (r),
              '_awaitingPromises',
              {}
            ), a (A (r), '_authenticator', void 0), a (
              A (r),
              '_methods',
              []
            ), a (A (r), '_keepAliveTimerHandle', void 0), a (
              A (r),
              '_keepAliveInterval',
              3e4
            ), r.setLogger ('RTSPClient'), (r._parsedRTSPUrl = ce.parse (
              t.url
            )), (r._url = ''
              .concat (r._parsedRTSPUrl.protocol, '://')
              .concat (r._parsedRTSPUrl.location)
              .concat (r._parsedRTSPUrl.urlpath)), (r._wsurl =
              t.socketurl), (r._headers = {
              'User-Agent': 'shandowc/1.0',
            }), (r._getSeq = ((n = 0), function () {
              return ++n;
            })), (r._nextFreeInterleavedChannel = ((i = 0), function () {
              return i++;
            })), r;
          }
          return i (y, [
            {
              key: '_buildRTSPMessage',
              value: function (e, t, r, n) {
                var i = ''.concat (e, ' ').concat (t, ' RTSP/1.0\r\n');
                Object.assign (r, this._headers);
                var a = this._getSeq ();
                for (var s in ((r.CSeq = ''.concat (a)), this._authenticator &&
                  (r.Authorization = this._authenticator (e)), r))
                  i += ''.concat (s, ': ').concat (r[s], '\r\n');
                return n &&
                  (i += 'Content-Length: '.concat (n.length, '\r\n')), (i +=
                  '\r\n'), n && (i += n), i;
              },
            },
            {
              key: '_parseRTSPMessage',
              value: function (e) {
                var t,
                  r = e.split ('\r\n'),
                  n = new ge (),
                  i = oe (
                    r[0].match (new RegExp ('RTSP/1.0[ ]+([0-9]{3})[ ]+(.*)')),
                    3
                  );
                i[0], (t = i[1]), (n.statusLine = i[2]), (n.code = parseInt (
                  t
                ));
                for (var a = 1; r[a]; ) {
                  var s = oe (r[a].split (/:(.+)/), 2), o = s[0], u = s[1];
                  (n.headers[o.toLowerCase ()] = u.trim ()), a++;
                }
                return (n.body = r.slice (a).join ('\n\r')), n;
              },
            },
            {
              key: '_buildWSMessage',
              value: function (e, t, r, n) {
                var i = '';
                for (var a in (n &&
                  (r.contentLength = ''.concat (n.length)), (r.seq = ''.concat (
                  e
                )), r))
                  i += ''.concat (a, ': ').concat (r[a], '\r\n');
                return 'WSP/1.1 '
                  .concat (t, '\r\n')
                  .concat (i, '\r\n')
                  .concat (n || '');
              },
            },
            {
              key: '_parseWSMesssage',
              value: function (e) {
                var t = e.indexOf ('\r\n\r\n'),
                  r = e.substr (0, t).split ('\r\n'),
                  n = r
                    .shift ()
                    .match (new RegExp ('WSP/1.1\\s+(\\d+)\\s+(.+)'));
                if (n) {
                  var i = new ye ();
                  for ((i.code = parseInt (n[1])), (i.msg = n[2]); r.length; ) {
                    var a = r.shift ();
                    if (!a) break;
                    var s = oe (a.split (':'), 2), o = s[0], u = s[1];
                    i.headers[o.trim ()] = u.trim ();
                  }
                  return (i.payload = e.substr (t + 4)), i;
                }
                return null;
              },
            },
            {
              key: '_onCtrlMsg',
              value: function (e) {
                this.logger.debug ('[ctrl] onmessage\r\n'.concat (e.data));
                var t = this._parseWSMesssage (e.data);
                if (t) {
                  var r = t.headers.seq;
                  r in this._awaitingPromises
                    ? (t.code < 300
                        ? this._awaitingPromises[r].resolve (t)
                        : this._awaitingPromises[r].reject (t), delete this
                        ._awaitingPromises[r])
                    : this.logger.error ('unknown ctrl res '.concat (e.data));
                } else this.logger.error ('invalid res '.concat (e.data));
              },
            },
            {
              key: '_onDataMsg',
              value: function (e) {
                if (e.data instanceof ArrayBuffer) {
                  var t = new Uint8Array (e.data);
                  if (36 == t[0]) {
                    var r = t[1];
                    this.events.emit (z, r, t.subarray (4));
                  } else
                    this.logger.warn (
                      '_onDataMsg invalid data: '.concat (e.data)
                    );
                } else
                  this.logger.warn ('_onDataMsg invalid type: '.concat (e));
              },
            },
            {
              key: '_requestWS',
              value: ((v = ie (
                se ().mark (function e (t, r, n, i) {
                  var a, s, o, u, c;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (a = this._getSeq ()), (s = this._buildWSMessage (
                              a,
                              t,
                              r,
                              n
                            )), (o = new le ()), (u = i || this._ctrlChannel), i
                              ? (this._dataJoinPromise = o)
                              : (this._awaitingPromises[
                                  a
                                ] = o), this.logger.debug (s), u.send (
                              s
                            ), (e.next = 9), Promise.race ([
                              o,
                              new Promise (function (e, r) {
                                setTimeout (function () {
                                  r (
                                    new Error (
                                      'request cmd: '
                                        .concat (t, ', payload: ')
                                        .concat (n, ' timeout')
                                    )
                                  );
                                }, 3e3);
                              }),
                            ]);
                          case 9:
                            return (c = e.sent), e.abrupt ('return', c);
                          case 11:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function (e, t, r, n) {
                return v.apply (this, arguments);
              }),
            },
            {
              key: '_resetChannels',
              value: function () {
                null != this._dataChannel &&
                  (this._dataChannel.close (), (this._dataChannel = null)), null !=
                  this._ctrlChannel &&
                  (this._ctrlChannel.close (), (this._ctrlChannel = null));
              },
            },
            {
              key: '_setupDataChannel',
              value: ((_ = ie (
                se ().mark (function e (t) {
                  var r = this;
                  return se ().wrap (function (e) {
                    for (;;) switch ((e.prev = e.next)) {
                        case 0:
                          return e.abrupt (
                            'return',
                            new Promise (function (e, n) {
                              (r._dataChannel = new WebSocket (
                                r._wsurl,
                                'data'
                              )), (r._dataChannel.binaryType = 'arraybuffer'), (r._dataChannel.onopen = ie (
                                se ().mark (function e () {
                                  return se ().wrap (function (e) {
                                    for (;;) switch ((e.prev = e.next)) {
                                        case 0:
                                          return (e.next = 2), r._requestWS ('JOIN', {channel: t}, null, r._dataChannel);
                                        case 2:
                                          e.sent ||
                                            n (new Error ('data proto error'));
                                        case 4:
                                        case 'end':
                                          return e.stop ();
                                      }
                                  }, e);
                                })
                              )), (r._dataChannel.onmessage = function (t) {
                                r.logger.debug ('[data]\r\n'.concat (t.data));
                                var i = r._parseWSMesssage (t.data);
                                if (!i)
                                  return n (
                                    new Error (
                                      'invalid data ctrl: '.concat (t.data)
                                    )
                                  );
                                r._dataJoinPromise.resolve (
                                  i
                                ), (r._dataChannel.onmessage = function (e) {
                                  r._onDataMsg (e);
                                }), e (null);
                              }), (r._dataChannel.onerror = function (e) {
                                r.logger.error (
                                  '[data] '
                                    .concat (e.type, ', reason: ')
                                    .concat (e)
                                ), r._dataChannel.close (), n (
                                  new Error ('data onerror '.concat (e))
                                );
                              }), (r._dataChannel.onclose = function (e) {
                                n (new Error ('data onclose '.concat (e)));
                              });
                            })
                          );
                        case 1:
                        case 'end':
                          return e.stop ();
                      }
                  }, e);
                })
              )), function (e) {
                return _.apply (this, arguments);
              }),
            },
            {
              key: '_setupCtrlChannel',
              value: ((p = ie (
                se ().mark (function e () {
                  var t = this;
                  return se ().wrap (function (e) {
                    for (;;) switch ((e.prev = e.next)) {
                        case 0:
                          return e.abrupt (
                            'return',
                            new Promise (function (e, r) {
                              (t._ctrlChannel = new WebSocket (
                                t._wsurl,
                                'control'
                              )), (t._ctrlChannel.onopen = ie (
                                se ().mark (function r () {
                                  var n, i;
                                  return se ().wrap (function (r) {
                                    for (;;) switch ((r.prev = r.next)) {
                                        case 0:
                                          return (n = {
                                            proto: 'rtsp',
                                            host: t._parsedRTSPUrl.host,
                                            port: ''.concat (
                                              t._parsedRTSPUrl.port
                                            ),
                                          }), (r.next = 3), t._requestWS ('INIT', n);
                                        case 3:
                                          return (i =
                                            r.sent), (r.next = 6), t._setupDataChannel (i.headers.channel);
                                        case 6:
                                          e (null);
                                        case 7:
                                        case 'end':
                                          return r.stop ();
                                      }
                                  }, r);
                                })
                              )), (t._ctrlChannel.onmessage = function (e) {
                                t._onCtrlMsg (e);
                              }), (t._ctrlChannel.onerror = function (e) {
                                r (e);
                              }), (t._ctrlChannel.onclose = function (e) {
                                r (e);
                              });
                            })
                          );
                        case 1:
                        case 'end':
                          return e.stop ();
                      }
                  }, e);
                })
              )), function () {
                return p.apply (this, arguments);
              }),
            },
            {
              key: '_requestRTSP',
              value: ((d = ie (
                se ().mark (function e (t, r, n) {
                  var i, a, s;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (i = this._buildRTSPMessage (
                              t,
                              n || this._url,
                              r
                            )), (e.next = 3), this._requestWS ('WRAP', {}, i);
                          case 3:
                            return (a = e.sent), (s = this._parseRTSPMessage (
                              a.payload
                            )) &&
                              s.headers.session &&
                              (this._headers.Session = s.headers.session.split (
                                ';'
                              )[0]), e.abrupt ('return', s);
                          case 7:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function (e, t, r) {
                return d.apply (this, arguments);
              }),
            },
            {
              key: '_initAuthenticator',
              value: function (e) {
                var t = this,
                  r = e.headers['www-authenticate'],
                  n = r.substring (0, r.indexOf (' ')),
                  i = (r = r.substr (n.length + 1)).split (',');
                if ('digest' == n.toLowerCase ()) {
                  var a, s = {}, o = pe (i);
                  try {
                    for (o.s (); !(a = o.n ()).done; ) {
                      var u = oe (a.value.trim ().split ('='), 2),
                        c = u[0],
                        l = u[1];
                      s[c] = l.substr (1, l.length - 2);
                    }
                  } catch (e) {
                    o.e (e);
                  } finally {
                    o.f ();
                  }
                  this._authenticator = function (e) {
                    var r = t._parsedRTSPUrl,
                      n = fe () (
                        ''
                          .concat (r.user, ':')
                          .concat (s.realm, ':')
                          .concat (r.pass)
                      ),
                      i = fe () (''.concat (e, ':').concat (t._url)),
                      a = fe () (
                        ''.concat (n, ':').concat (s.nonce, ':').concat (i)
                      );
                    return 'Digest username="'
                      .concat (r.user, '", realm="')
                      .concat (s.realm, '", nonce="')
                      .concat (s.nonce, '", uri="')
                      .concat (t._url, '", response="')
                      .concat (a, '"')
                      .concat ('');
                  };
                } else
                  this._authenticator = function () {
                    return 'Basic '.concat (btoa (t._parsedRTSPUrl.auth));
                  };
              },
            },
            {
              key: 'request',
              value: ((f = ie (
                se ().mark (function e (t, r, n) {
                  var i;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), this._requestRTSP (t, r, n);
                          case 2:
                            if (401 != (i = e.sent).code) {
                              e.next = 10;
                              break;
                            }
                            if (
                              this._parsedRTSPUrl.user &&
                              this._parsedRTSPUrl.pass
                            ) {
                              e.next = 6;
                              break;
                            }
                            throw new Error ('unauthorized');
                          case 6:
                            return this._initAuthenticator (
                              i
                            ), (e.next = 9), this._requestRTSP (t, r, n);
                          case 9:
                            i = e.sent;
                          case 10:
                            return e.abrupt ('return', i);
                          case 11:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function (e, t, r) {
                return f.apply (this, arguments);
              }),
            },
            {
              key: 'isSupport',
              value: function (e) {
                return this._methods.includes (e);
              },
            },
            {
              key: '_needRedirect',
              value: function (e) {
                if (e.code >= 301 && e.code < 400) {
                  if (e.headers.location != this._url)
                    return this.logger.debug (
                      'need redirect: (',
                      this._url,
                      ')--\x3e(',
                      e.headers.location,
                      ')'
                    ), (this._url =
                      e.headers.location), (this._parsedRTSPUrl = ce.parse (
                      e.headers.location
                    )), !0;
                  this.logger.warn (
                    'The redirect destination URL is the same as the current URL.'
                  );
                }
                return !1;
              },
            },
            {
              key: 'sendOptions',
              value: ((h = ie (
                se ().mark (function e () {
                  var t, r, n = arguments;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (t = n.length > 0 && void 0 !== n[0]
                              ? n[0]
                              : {}), (e.next = 3), this.request (
                              'OPTIONS',
                              t,
                              this._url
                            );
                          case 3:
                            return (r =
                              e.sent), (this._methods = r.headers.public
                              .split (',')
                              .map (function (e) {
                                return e.trim ();
                              })), e.abrupt ('return', r);
                          case 6:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return h.apply (this, arguments);
              }),
            },
            {
              key: 'sendDescribe',
              value: ((l = ie (
                se ().mark (function e () {
                  var t;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), this.request (
                              'DESCRIBE',
                              {Accept: 'application/sdp'},
                              this._url
                            );
                          case 2:
                            return (t = e.sent), e.abrupt ('return', t);
                          case 4:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return l.apply (this, arguments);
              }),
            },
            {
              key: 'sendSetup',
              value: ((c = ie (
                se ().mark (function e (t) {
                  var r, n, i;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return t.toLowerCase ().startsWith ('rtsp://') ||
                              (t =
                                this._url +
                                '/' +
                                t), (r = this._nextFreeInterleavedChannel ()), (n =
                              r + 1), (e.next = 5), this.request (
                              'SETUP',
                              {
                                Transport: 'RTP/AVP/TCP;unicast;interleaved='
                                  .concat (r, '-')
                                  .concat (n),
                                Date: new Date ().toUTCString (),
                              },
                              t
                            );
                          case 5:
                            return (i = e.sent), e.abrupt ('return', i);
                          case 7:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function (e) {
                return c.apply (this, arguments);
              }),
            },
            {
              key: 'play',
              value: ((u = ie (
                se ().mark (function e () {
                  var t;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), this.request (
                              'PLAY',
                              {},
                              this._url
                            );
                          case 2:
                            return (t = e.sent), e.abrupt ('return', t);
                          case 4:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return u.apply (this, arguments);
              }),
            },
            {
              key: 'pause',
              value: ((o = ie (
                se ().mark (function e () {
                  var t;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), this.request (
                              'PAUSE',
                              {},
                              this._url
                            );
                          case 2:
                            return (t = e.sent), e.abrupt ('return', t);
                          case 4:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return o.apply (this, arguments);
              }),
            },
            {
              key: 'teardown',
              value: ((s = ie (
                se ().mark (function e () {
                  var t;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), this.request (
                              'TEARDOWN',
                              {},
                              this._url
                            );
                          case 2:
                            return (t = e.sent), e.abrupt ('return', t);
                          case 4:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return s.apply (this, arguments);
              }),
            },
            {
              key: 'sendKeepAlive',
              value: ((n = ie (
                se ().mark (function e () {
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            if (!this.isSupport ('GET_PARAMETER')) {
                              e.next = 4;
                              break;
                            }
                            return e.abrupt (
                              'return',
                              this.request ('GET_PARAMETER', {})
                            );
                          case 4:
                            return e.abrupt ('return', this.sendOptions ());
                          case 5:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return n.apply (this, arguments);
              }),
            },
            {
              key: 'connect',
              value: ((r = ie (
                se ().mark (function e () {
                  var t, r, n, i;
                  return se ().wrap (
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            t = 0;
                          case 1:
                            if (!(t < 5)) {
                              e.next = 20;
                              break;
                            }
                            return this._resetChannels (), (e.next = 5), this._setupCtrlChannel ();
                          case 5:
                            return (e.next = 7), this.sendOptions ();
                          case 7:
                            if (((r = e.sent), !this._needRedirect (r))) {
                              e.next = 10;
                              break;
                            }
                            return e.abrupt ('continue', 17);
                          case 10:
                            return (e.next = 12), this.sendDescribe ();
                          case 12:
                            if (((n = e.sent), !this._needRedirect (n))) {
                              e.next = 15;
                              break;
                            }
                            return e.abrupt ('continue', 17);
                          case 15:
                            return (i = de.Qc (n.body)), e.abrupt ('return', i);
                          case 17:
                            t++, (e.next = 1);
                            break;
                          case 20:
                          case 'end':
                            return e.stop ();
                        }
                    },
                    e,
                    this
                  );
                })
              )), function () {
                return r.apply (this, arguments);
              }),
            },
            {
              key: 'startKeepAlive',
              value: function () {
                var e = this;
                this._keepAliveTimerHandle = setInterval (function () {
                  e.sendKeepAlive ();
                }, this._keepAliveInterval);
              },
            },
            {
              key: 'stopKeepAlive',
              value: function () {
                this._keepAliveInterval &&
                  (clearInterval (
                    this._keepAliveTimerHandle
                  ), (this._keepAliveInterval = null));
              },
            },
            {
              key: 'destroy',
              value: function () {
                this.stopKeepAlive (), this._resetChannels ();
              },
            },
          ]), y;
        }) (Z),
        be = (function () {
          function t () {
            e (this, t), a (this, '_offset', 0), a (
              this,
              '_lastTimestamp',
              void 0
            ), a (this, '_firstUnwrappedTimestamp', void 0);
          }
          return i (t, [
            {
              key: 'checkOverflow',
              value: function (e) {
                void 0 === this._lastTimestamp &&
                  (this._lastTimestamp = e), Math.abs (
                  e - this._lastTimestamp
                ) > 2147483647 &&
                  ((this._offset += 4294967295), console.log (
                    'check overflow, last_timestamp: ',
                    this._lastTimestamp,
                    ' timestamp: ',
                    e,
                    ' offset: ',
                    this._offset
                  )), (this._lastTimestamp = e);
              },
            },
            {
              key: 'adjust',
              value: function (e) {
                var t = e + this._offset;
                return void 0 === this._firstUnwrappedTimestamp &&
                  (this._firstUnwrappedTimestamp = e), t -
                  this._firstUnwrappedTimestamp;
              },
            },
          ]), t;
        }) ();
      const Ee = (e, t = e => (void 0 !== e ? ': ' + e : '')) =>
        class extends Error {
          constructor (r) {
            super (e (r) + t (r));
          }
        },
        xe = Ee (() => 'illegal argument(s)'),
        we = e => {
          throw new xe (e);
        },
        Se = Ee (() => 'illegal state'),
        Ae = Math.pow (2, 32);
      class Pe {
        constructor (e, t = 0, r = e.length << 3) {
          (this.buffer = e), (this.start = t), (this.limit = r), this.seek (t);
        }
        *[Symbol.iterator] () {
          let e = this.start, t = e >>> 3, r = 7 - (7 & e);
          for (; e < this.limit; )
            yield (this.buffer[t] >>> r) & 1, --r < 0 && (t++, (r = 7)), e++;
        }
        get length () {
          return this.limit;
        }
        get position () {
          return this.bitPos;
        }
        seek (e) {
          return (e < this.start || e >= this.limit) &&
            we (`seek pos out of bounds: ${e}`), (this.pos =
            e >>> 3), (this.bit = 8 - (7 & e)), (this.bitPos = e), this;
        }
        read (e = 1) {
          if (e > 32) return this.read (e - 32) * Ae + this.read (32);
          if (e > 8) {
            let t = 0, r = -8 & e, n = e - r;
            for (n > 0 && (t = this._read (n)); r > 0; )
              (t = ((t << 8) | this._read (8)) >>> 0), (r -= 8);
            return t;
          }
          return this._read (e);
        }
        readFields (e) {
          return e.map (e => this.read (e));
        }
        readWords (e, t = 8) {
          let r = [];
          for (; --e >= 0; )
            r.push (this.read (t));
          return r;
        }
        readStruct (e) {
          return e.reduce ((e, [t, r]) => ((e[t] = this.read (r)), e), {});
        }
        readBit () {
          this.checkLimit (1), this.bit--, this.bitPos++;
          let e = (this.buffer[this.pos] >>> this.bit) & 1;
          return 0 === this.bit && (this.pos++, (this.bit = 8)), e;
        }
        _read (e) {
          this.checkLimit (e);
          let t, r = this.bit - e;
          return r >= 0
            ? ((this.bit = r), (t =
                (this.buffer[this.pos] >>> r) & ((1 << e) - 1)), 0 === r &&
                (this.pos++, (this.bit = 8)))
            : ((t =
                (this.buffer[this.pos++] & ((1 << this.bit) - 1)) <<
                -r), (this.bit = 8 + r), (t |=
                this.buffer[this.pos] >>> this.bit)), (this.bitPos += e), t;
        }
        checkLimit (e) {
          this.bitPos + e > this.limit &&
            (e => {
              throw new Se (e);
            }) ("can't read past EOF");
        }
      }
      function Ce (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      function Le () {
        for (
          var e = 0, t = arguments.length, r = new Array (t), n = 0;
          n < t;
          n++
        )
          r[n] = arguments[n];
        r.forEach (function (t) {
          e += t.length;
        });
        var i = new Uint8Array (e), a = 0;
        return r.forEach (function (e) {
          i.set (e, a), (a += e.length);
        }), i;
      }
      function ke (e) {
        for (
          var t = window.atob (e), r = t.length, n = new Uint8Array (r), i = 0;
          i < r;
          i++
        )
          n[i] = t.charCodeAt (i);
        return n;
      }
      var Te = (function (t) {
        C (n, t);
        var r = Ce (n);
        function n () {
          return e (this, n), r.apply (this, arguments);
        }
        return i (n, [
          {
            key: 'skipBits',
            value: function (e) {
              this.read (e);
            },
          },
          {
            key: 'skipUEG',
            value: function () {
              this.readUEG ();
            },
          },
          {
            key: 'skipEG',
            value: function () {
              this.readEG ();
            },
          },
          {
            key: 'readBoolean',
            value: function () {
              return 1 === this.readBits (1);
            },
          },
          {
            key: 'readBits',
            value: function (e) {
              return this.read (e);
            },
          },
          {
            key: 'readEG',
            value: function () {
              var e = this.readUEG ();
              return 1 & e ? (1 + e) >>> 1 : -1 * (e >>> 1);
            },
          },
          {
            key: 'readUEG',
            value: function () {
              var e;
              for (e = 0; e < 32; e++) {
                if (this.readBit () > 0) break;
              }
              var t = this.read (e);
              return (t += (1 << e) - 1);
            },
          },
          {
            key: 'readFFLongUint',
            value: function () {
              var e = 0, t = 0;
              for (t = this.readUByte (); 255 === t; )
                (e += t), (t = this.readUByte ());
              return (e += t);
            },
          },
          {
            key: 'readUByte',
            value: function () {
              return this.readBits (8);
            },
          },
        ]), n;
      }) (Pe),
        Re = function t (r) {
          e (this, t), a (this, 'version', void 0), a (
            this,
            'padding',
            void 0
          ), a (this, 'hasExtension', void 0), a (this, 'csrcCnt', void 0), a (
            this,
            'marker',
            void 0
          ), a (this, 'payloadType', void 0), a (this, 'seq', void 0), a (
            this,
            'timestamp',
            void 0
          ), a (this, 'ssrc', void 0), a (this, 'payload', void 0);
          var n = new DataView (r.buffer, r.byteOffset, r.byteLength);
          (this.version = n.getUint8 (0) >>> 6), (this.padding =
            32 & n.getUint8 (0)), (this.hasExtension =
            16 & n.getUint8 (0)), (this.csrcCnt =
            15 & n.getUint8 (0)), (this.marker =
            n.getUint8 (1) >>> 7), (this.payloadType =
            127 & n.getUint8 (1)), (this.seq = n.getUint16 (
            2
          )), (this.timestamp = n.getUint32 (4)), (this.ssrc = n.getUint32 (8));
          var i = 12 + 4 * this.csrcCnt;
          this.hasExtension > 0 && (i += 4 + 4 * n.getUint16 (i + 2));
          var s = 0;
          this.padding > 0 &&
            (s = r[r.length - 1]), (this.payload = r.subarray (
            i,
            r.length - s
          ));
        };
      const Ne = Math.pow (2, 32);
      class Ue {
        constructor (e, t = 0) {
          (this.buffer = void 0 === e
            ? new Uint8Array (16)
            : 'number' == typeof e
                ? new Uint8Array (e)
                : e), (this.start = t), this.seek (t), (this.buffer[
            this.pos
          ] &= ~((1 << this.bit) - 1));
        }
        get position () {
          return this.bitPos;
        }
        seek (e) {
          return (e < this.start || e >= this.buffer.length << 3) &&
            we (`seek pos out of bounds: ${e}`), (this.pos =
            e >>> 3), (this.bit = 8 - (7 & e)), (this.bitPos = e), this;
        }
        bytes () {
          return this.buffer.slice (0, this.pos + (7 & this.bit ? 1 : 0));
        }
        reader (e = 0) {
          return new Pe (this.buffer, e, this.position);
        }
        write (e, t = 1) {
          if (t > 32) {
            let r = Math.floor (e / Ne);
            this.write (r, t - 32), this.write (e - r * Ne, 32);
          } else if (t > 8) {
            let r = -8 & t, n = t - r;
            for (n > 0 && this._write (e >>> r, n), (r -= 8); r >= 0; )
              this._write (e >>> r, 8), (r -= 8);
          } else this._write (e, t);
          return this;
        }
        writeWords (e, t = 8) {
          let r, n = e[Symbol.iterator] ();
          for (; (r = n.next ()), !r.done; )
            this.write (r.value, t);
        }
        writeBit (e) {
          return this.bit--, (this.buffer[this.pos] =
            (this.buffer[this.pos] & ~(1 << this.bit)) | (e << this.bit)), 0 ===
            this.bit && (this.ensureSize (), (this.bit = 8)), this
            .bitPos++, this;
        }
        _write (e, t) {
          e &= (1 << t) - 1;
          let r = this.buffer,
            n = this.pos,
            i = this.bit,
            a = i - t,
            s = i < 8 ? ~((1 << i) - 1) : 0;
          return a >= 0
            ? ((s |= (1 << a) - 1), (r[n] = (r[n] & s) | ((e << a) & ~s)), 0 ===
                a
                ? (this.ensureSize (), (this.bit = 8))
                : (this.bit = a))
            : ((this.bit = i = 8 + a), (r[n] =
                (r[n] & s) |
                ((e >>> -a) & ~s)), this.ensureSize (), (this.buffer[this.pos] =
                (this.buffer[this.pos] & ((1 << i) - 1)) |
                ((e << i) & 255))), (this.bitPos += t), this;
        }
        ensureSize () {
          if (++this.pos === this.buffer.length) {
            let e = new Uint8Array (this.buffer.length << 1);
            e.set (this.buffer), (this.buffer = e);
          }
        }
      }
      function He (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var De = [
        96e3,
        88200,
        64e3,
        48e3,
        44100,
        32e3,
        24e3,
        22050,
        16e3,
        12e3,
        11025,
        8e3,
        7350,
      ],
        Ie = {};
      !(function () {
        for (var e = 0; e < De.length; e++)
          Ie[De[e]] = e;
      }) ();
      var Be,
        Ve = (function (t) {
          C (n, t);
          var r = He (n);
          function n (t) {
            var i;
            e (this, n), a (
              A ((i = r.call (this, t))),
              '_objectType',
              void 0
            ), a (A (i), '_frequencyIndex', void 0), a (
              A (i),
              '_channelConfiguration',
              void 0
            ), a (A (i), '_sizeLength', void 0), a (
              A (i),
              '_indexLength',
              void 0
            ), a (A (i), '_timestampHandler', void 0), a (
              A (i),
              '_timescale',
              void 0
            ), a (A (i), '_rtpPayloadType', void 0);
            var s = t.mediaDesc;
            s.rtp && s.rtp.length > 0
              ? (i._timescale = s.rtp[0].rate)
              : (i._timescale = 44100), (i._rtpPayloadType = s.rtp[0].payload);
            var o = s.fmtp[0],
              u = (function (e) {
                for (
                  var t = e.length >> 1, r = new Uint8Array (t), n = 0;
                  n < t;
                  n++
                )
                  r[n] = parseInt (e.substr (n << 1, 2), 16);
                return r;
              }) (de.rz (o.config).config.toString ()),
              c = new Pe (u);
            return (i._objectType = c.read (5)), (i._frequencyIndex = c.read (
              4
            )), (i._channelConfiguration = c.read (4)), (i._sizeLength =
              u.SizeLength || 13), (i._indexLength =
              u.indexLength || 3), (i._sizeLength + i._indexLength) % 8 != 0 &&
              i.logger.error (
                'dangerous config: '
                  .concat (i._indexLength, ' ')
                  .concat (i._sizeLength)
              ), (i._timestampHandler = new be ()), i;
          }
          return i (n, [
            {
              key: '_constructToADTS',
              value: function (e) {
                var t = 7 + e.length, r = new Uint8Array (t), n = new Ue (r);
                n.write (4095, 12), n.write (0, 1), n.write (0, 2);
                n.write (1, 1), n.write (this._objectType - 1, 2), n.write (
                  this._frequencyIndex,
                  4
                ), n.write (0, 1), n.write (
                  this._channelConfiguration,
                  3
                ), n.write (0, 1), n.write (0, 1), n.write (0, 1), n.write (
                  0,
                  1
                ), n.write (t, 13), n.write (2047, 11);
                return n.write (0, 2), r.set (e, 7), r;
              },
            },
            {
              key: 'processRTP',
              value: function (e) {
                var t = this, r = new Re (e);
                if (r.payloadType === this._rtpPayloadType) {
                  var n = new Pe (r.payload),
                    i = n.read (16),
                    a = (Math.ceil (i / 8), this._sizeLength +
                      this._indexLength);
                  if (a <= 0 || i % a != 0)
                    this.logger.error (
                      'inalid au header size '.concat (a, ' ').concat (i)
                    );
                  else {
                    for (var s = i / a, o = [], u = 0; u < s; u++)
                      o.push ({
                        size: n.read (this._sizeLength),
                        index: n.read (this._indexLength),
                      });
                    if (s <= 0)
                      this.logger.warn ('empty aac rtp payload, '.concat (r));
                    else {
                      var c = Math.ceil (n.position / 8),
                        l = r.payload.subarray (c);
                      if (1 == s && o[0].size > l.length)
                        this.logger.warn ('not supported yet aac fragment');
                      else {
                        this._timestampHandler.checkOverflow (r.timestamp);
                        var h =
                          this._timestampHandler.adjust (r.timestamp) /
                          this._timescale,
                          f = [];
                        o.forEach (function (e) {
                          if (e.size > l.length)
                            t.logger.warn ('AU larger than packet size');
                          else {
                            var r = t._constructToADTS (l.subarray (0, e.size));
                            f.push (r), (l = l.subarray (0, e.size));
                          }
                        }), this.events.emit (q, Le.apply (void 0, f), h);
                      }
                    }
                  }
                }
              },
            },
            {key: 'processRTCP', value: function (e) {}},
          ]), n;
        }) (Z);
      function Oe (e) {
        return 31 & e[0];
      }
      function Fe (e) {
        return e === Be.H264_NAL_IDR_SLICE;
      }
      !(function (e) {
        (e[(e.H264_NAL_UNSPECIFIED = 0)] = 'H264_NAL_UNSPECIFIED'), (e[
          (e.H264_NAL_SLICE = 1)
        ] =
          'H264_NAL_SLICE'), (e[(e.H264_NAL_DPA = 2)] = 'H264_NAL_DPA'), (e[
          (e.H264_NAL_DPB = 3)
        ] =
          'H264_NAL_DPB'), (e[(e.H264_NAL_DPC = 4)] = 'H264_NAL_DPC'), (e[
          (e.H264_NAL_IDR_SLICE = 5)
        ] =
          'H264_NAL_IDR_SLICE'), (e[(e.H264_NAL_SEI = 6)] = 'H264_NAL_SEI'), (e[
          (e.H264_NAL_SPS = 7)
        ] =
          'H264_NAL_SPS'), (e[(e.H264_NAL_PPS = 8)] = 'H264_NAL_PPS'), (e[
          (e.H264_NAL_AUD = 9)
        ] =
          'H264_NAL_AUD'), (e[(e.H264_NAL_END_SEQUENCE = 10)] =
          'H264_NAL_END_SEQUENCE'), (e[(e.H264_NAL_END_STREAM = 11)] =
          'H264_NAL_END_STREAM'), (e[(e.H264_NAL_FILLER_DATA = 12)] =
          'H264_NAL_FILLER_DATA'), (e[(e.H264_NAL_SPS_EXT = 13)] =
          'H264_NAL_SPS_EXT'), (e[(e.H264_NAL_PREFIX = 14)] =
          'H264_NAL_PREFIX'), (e[(e.H264_NAL_SUB_SPS = 15)] =
          'H264_NAL_SUB_SPS'), (e[(e.H264_NAL_DPS = 16)] = 'H264_NAL_DPS'), (e[
          (e.H264_NAL_RESERVED17 = 17)
        ] =
          'H264_NAL_RESERVED17'), (e[(e.H264_NAL_RESERVED18 = 18)] =
          'H264_NAL_RESERVED18'), (e[(e.H264_NAL_AUXILIARY_SLICE = 19)] =
          'H264_NAL_AUXILIARY_SLICE'), (e[(e.H264_NAL_EXTEN_SLICE = 20)] =
          'H264_NAL_EXTEN_SLICE'), (e[(e.H264_NAL_DEPTH_EXTEN_SLICE = 21)] =
          'H264_NAL_DEPTH_EXTEN_SLICE'), (e[(e.H264_NAL_RESERVED22 = 22)] =
          'H264_NAL_RESERVED22'), (e[(e.H264_NAL_RESERVED23 = 23)] =
          'H264_NAL_RESERVED23'), (e[(e.H264_NAL_UNSPECIFIED24 = 24)] =
          'H264_NAL_UNSPECIFIED24'), (e[(e.H264_NAL_UNSPECIFIED25 = 25)] =
          'H264_NAL_UNSPECIFIED25'), (e[(e.H264_NAL_UNSPECIFIED26 = 26)] =
          'H264_NAL_UNSPECIFIED26'), (e[(e.H264_NAL_UNSPECIFIED27 = 27)] =
          'H264_NAL_UNSPECIFIED27'), (e[(e.H264_NAL_UNSPECIFIED28 = 28)] =
          'H264_NAL_UNSPECIFIED28'), (e[(e.H264_NAL_UNSPECIFIED29 = 29)] =
          'H264_NAL_UNSPECIFIED29'), (e[(e.H264_NAL_UNSPECIFIED30 = 30)] =
          'H264_NAL_UNSPECIFIED30'), (e[(e.H264_NAL_UNSPECIFIED31 = 31)] =
          'H264_NAL_UNSPECIFIED31');
      }) (Be || (Be = {}));
      var Me = function t () {
        e (this, t), a (this, 'profileIdc', void 0), a (
          this,
          'constraintSet',
          void 0
        ), a (this, 'levelIdc', void 0), a (this, 'width', void 0), a (
          this,
          'height',
          void 0
        );
      };
      function Ge (e, t) {
        for (var r = 8, n = 8, i = 0; i < t; i++)
          0 !== n && (n = (r + e.readEG () + 256) % 256), (r = 0 === n ? r : n);
      }
      function je (e) {
        for (var t = e.byteLength, r = e, n = 0; n + 1 < t; n += 2)
          if (
            0 == r[n] &&
            (n > 0 && 0 == r[n - 1] && n--, n + 2 < t &&
              0 == r[n + 1] &&
              r[n + 2] <= 3)
          ) {
            3 != r[n + 2] && 0 != r[n + 2] && (t = n);
            break;
          }
        if (n >= t - 1) return e.slice (0, t);
        for (
          var i = new ArrayBuffer (t), a = new Uint8Array (i), s = 0;
          s < n;
          s++
        )
          a[s] = r[s];
        for (var o = n, u = n; o + 2 < t; ) {
          if (r[o + 2] > 3) (a[u++] = r[o++]), (a[u++] = r[o++]);
          else if (0 == r[o] && 0 == r[o + 1] && 0 != r[o + 2]) {
            if (3 == r[o + 2]) {
              (a[u++] = 0), (a[u++] = 0), (o += 3);
              continue;
            }
            return new Uint8Array (i, 0, u);
          }
          a[u++] = r[o++];
        }
        for (; o < t; )
          a[u++] = r[o++];
        return new Uint8Array (i, 0, u);
      }
      var We = r (702);
      function ze (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var Xe,
        qe = (function (t) {
          C (n, t);
          var r = ze (n);
          function n (t) {
            var i;
            e (this, n), a (A ((i = r.call (this, t))), '_partialNal', []), a (
              A (i),
              '_timestampHandler',
              void 0
            ), a (A (i), '_timescale', void 0), a (
              A (i),
              '_idrFound',
              void 0
            ), a (A (i), '_rtpPayloadType', void 0), a (
              A (i),
              '_sps',
              void 0
            ), a (A (i), '_pps', void 0), a (A (i), '_isProbeDone', void 0), a (
              A (i),
              '_isProcessorReady',
              void 0
            ), a (A (i), '_pktBuffer', void 0);
            var s = t.mediaDesc;
            return s.rtp && s.rtp.length > 0
              ? (i._timescale = s.rtp[0].rate)
              : (i._timescale = 9e4), (i._pktBuffer = new We.c ()), (i._rtpPayloadType =
              s.rtp[0].payload), (i._timestampHandler = new be ()), i.events.on (
              Q,
              function () {
                for (i._isProcessorReady = !0; !i._pktBuffer.isEmpty (); ) {
                  var e = i._pktBuffer.dequeue ();
                  i.events.emit (X, e);
                }
              }
            ), i._extractSPSPPSFromSDP (s), i;
          }
          return i (n, [
            {
              key: '_extractSPSPPSFromSDP',
              value: function (e) {
                if (e.fmtp[0] && e.fmtp[0].config) {
                  var t = e.fmtp[0].config, r = de.rz (t);
                  if ('sprop-parameter-sets' in r) {
                    var n = r['sprop-parameter-sets'].toString ().split (',');
                    (this._sps = ke (n[0])), (this._pps = ke (
                      n[1]
                    )), this._checkProbeData ();
                  }
                }
              },
            },
            {
              key: '_checkProbeData',
              value: function () {
                if (!this._sps || !this._pps) return this._isProbeDone;
                var e = (function (e) {
                  var t = new Te (e),
                    r = new Me (),
                    n = 0,
                    i = 0,
                    a = 0,
                    s = 0,
                    o = 0;
                  if (
                    (t.readUByte (), (r.profileIdc = t.readUByte ()), (r.constraintSet = t.readBits (
                      6
                    )), t.skipBits (
                      2
                    ), (r.levelIdc = t.readUByte ()), t.skipUEG (), 100 ===
                      r.profileIdc ||
                      110 === r.profileIdc ||
                      122 === r.profileIdc ||
                      244 === r.profileIdc ||
                      44 === r.profileIdc ||
                      83 === r.profileIdc ||
                      86 === r.profileIdc ||
                      118 === r.profileIdc ||
                      128 === r.profileIdc)
                  ) {
                    var u = t.readUEG ();
                    if (
                      (3 === u &&
                        t.skipBits (1), t.skipUEG (), t.skipUEG (), t.skipBits (
                        1
                      ), t.readBoolean ())
                    )
                      for (var c = 3 !== u ? 8 : 12, l = 0; l < c; l++)
                        t.readBoolean () && Ge (t, l < 6 ? 16 : 64);
                  }
                  t.skipUEG ();
                  var h = t.readUEG ();
                  if (0 === h) t.readUEG ();
                  else if (1 === h) {
                    t.skipBits (
                      1
                    ), t.skipEG (), t.skipEG (), (o = t.readUEG ());
                    for (var f = 0; f < o; f++)
                      t.skipEG ();
                  }
                  t.skipUEG (), t.skipBits (1);
                  var d = t.readUEG (), p = t.readUEG (), _ = t.readBits (1);
                  return 0 === _ && t.skipBits (1), t.skipBits (
                    1
                  ), t.readBoolean () &&
                    ((n = t.readUEG ()), (i = t.readUEG ()), (a = t.readUEG ()), (s = t.readUEG ())), (r.width = Math.ceil (
                    16 * (d + 1) - 2 * n - 2 * i
                  )), (r.height =
                    (2 - _) * (p + 1) * 16 - (_ ? 2 : 4) * (a + s)), r;
                }) (this._sps),
                  t = (function (e) {
                    for (var t = 'avc1.', r = 0; r < 3; r++) {
                      var n = e[r + 1].toString (16);
                      n.length < 2 && (n = '0' + n), (t += n);
                    }
                    return t;
                  }) (this._sps),
                  r = {
                    width: e.width,
                    height: e.height,
                    codec: 'h264',
                    codecStr: t,
                  };
                return this.events.emit (
                  Y,
                  r
                ), (this._isProbeDone = !0), this._postNal (
                  this._sps,
                  0,
                  0
                ), this._postNal (this._pps, 0, 0), this._isProbeDone;
              },
            },
            {
              key: '_extractCustomSEIPayload',
              value: function (e) {
                var t = null;
                if (Oe (e) === Be.H264_NAL_SEI) {
                  var r = je (e.subarray (1)), n = new Te (r);
                  try {
                    if (5 === n.readFFLongUint ()) {
                      for (
                        var i = n.readFFLongUint (),
                          a = new Uint8Array (i),
                          s = 0;
                        s < i;
                        s++
                      )
                        a[s] = n.readUByte ();
                      t = a;
                    }
                  } catch (e) {
                    this.logger.debug ('invalid sei');
                  }
                }
                return t;
              },
            },
            {
              key: '_dealWithNal',
              value: function (e, t) {
                var r = Oe (e);
                if (
                  (this._isProbeDone ||
                    (r === Be.H264_NAL_SPS
                      ? (this._sps = e)
                      : r === Be.H264_NAL_PPS &&
                          (this._pps = e), this._checkProbeData ())) &&
                  (this._idrFound || Fe (r))
                ) {
                  this._idrFound = !0;
                  var n = this._extractCustomSEIPayload (e);
                  if (n) {
                    var i = this._timestampHandler.adjust (t) / this._timescale;
                    this.events.emit (B, {
                      timestamp: t,
                      scaledPTS: i,
                      payload: n,
                    });
                  } else {
                    this._timestampHandler.checkOverflow (t);
                    var a = this._timestampHandler.adjust (t) / this._timescale;
                    this._postNal (e, a, t);
                  }
                }
              },
            },
            {
              key: '_postNal',
              value: function (e, t, r) {
                var n = {data: e, pts: t, timestamp: r};
                this._isProcessorReady
                  ? this.events.emit (X, n)
                  : this._pktBuffer.enqueue (n);
              },
            },
            {
              key: 'processRTP',
              value: function (e) {
                var t = new Re (e);
                t.payloadType === this._rtpPayloadType &&
                  this._processRTPPayload (t.payload, t.timestamp);
              },
            },
            {key: 'processRTCP', value: function (e) {}},
            {
              key: '_processRTPPayload',
              value: function (e, t) {
                var r = (e[0] >> 7) & 1, n = (e[0], (e[0] >> 0) & 31);
                if (!(r > 0))
                  if (n >= 1 && n <= 23) this._dealWithNal (e, t);
                  else if (24 == n)
                    for (var i = 1; i + 2 < e.length - 1; ) {
                      var a = (e[i] << 8) + (e[i + 1] << 0);
                      (i += 2), this._dealWithNal (
                        e.slice (i, i + a),
                        t
                      ), (i += a);
                    }
                  else if (25 == n);
                  else if (26 == n);
                  else if (27 == n);
                  else if (28 == n) {
                    var s = (e[1] >> 7) & 1,
                      o = (e[1] >> 6) & 1,
                      u = (e[1], (e[1] >> 0) & 31);
                    if (1 == s && 0 == o) {
                      this._partialNal = [];
                      var c = (224 & e[0]) | u;
                      this._partialNal.push (
                        new Uint8Array ([c])
                      ), this._partialNal.push (e.subarray (2));
                    }
                    0 == s &&
                      0 == o &&
                      this._partialNal.push (e.subarray (2)), 0 == s &&
                      1 == o &&
                      (this._partialNal.push (
                        e.subarray (2)
                      ), this._dealWithNal (
                        Le.apply (void 0, N (this._partialNal)),
                        t
                      ));
                  }
              },
            },
          ]), n;
        }) (Z);
      !(function (e) {
        (e[(e.HEVC_NAL_TRAIL_N = 0)] = 'HEVC_NAL_TRAIL_N'), (e[
          (e.HEVC_NAL_TRAIL_R = 1)
        ] =
          'HEVC_NAL_TRAIL_R'), (e[(e.HEVC_NAL_TSA_N = 2)] =
          'HEVC_NAL_TSA_N'), (e[(e.HEVC_NAL_TSA_R = 3)] = 'HEVC_NAL_TSA_R'), (e[
          (e.HEVC_NAL_STSA_N = 4)
        ] =
          'HEVC_NAL_STSA_N'), (e[(e.HEVC_NAL_STSA_R = 5)] =
          'HEVC_NAL_STSA_R'), (e[(e.HEVC_NAL_RADL_N = 6)] =
          'HEVC_NAL_RADL_N'), (e[(e.HEVC_NAL_RADL_R = 7)] =
          'HEVC_NAL_RADL_R'), (e[(e.HEVC_NAL_RASL_N = 8)] =
          'HEVC_NAL_RASL_N'), (e[(e.HEVC_NAL_RASL_R = 9)] =
          'HEVC_NAL_RASL_R'), (e[(e.HEVC_NAL_VCL_N10 = 10)] =
          'HEVC_NAL_VCL_N10'), (e[(e.HEVC_NAL_VCL_R11 = 11)] =
          'HEVC_NAL_VCL_R11'), (e[(e.HEVC_NAL_VCL_N12 = 12)] =
          'HEVC_NAL_VCL_N12'), (e[(e.HEVC_NAL_VCL_R13 = 13)] =
          'HEVC_NAL_VCL_R13'), (e[(e.HEVC_NAL_VCL_N14 = 14)] =
          'HEVC_NAL_VCL_N14'), (e[(e.HEVC_NAL_VCL_R15 = 15)] =
          'HEVC_NAL_VCL_R15'), (e[(e.HEVC_NAL_BLA_W_LP = 16)] =
          'HEVC_NAL_BLA_W_LP'), (e[(e.HEVC_NAL_BLA_W_RADL = 17)] =
          'HEVC_NAL_BLA_W_RADL'), (e[(e.HEVC_NAL_BLA_N_LP = 18)] =
          'HEVC_NAL_BLA_N_LP'), (e[(e.HEVC_NAL_IDR_W_RADL = 19)] =
          'HEVC_NAL_IDR_W_RADL'), (e[(e.HEVC_NAL_IDR_N_LP = 20)] =
          'HEVC_NAL_IDR_N_LP'), (e[(e.HEVC_NAL_CRA_NUT = 21)] =
          'HEVC_NAL_CRA_NUT'), (e[(e.HEVC_NAL_RSV_IRAP_VCL22 = 22)] =
          'HEVC_NAL_RSV_IRAP_VCL22'), (e[(e.HEVC_NAL_RSV_IRAP_VCL23 = 23)] =
          'HEVC_NAL_RSV_IRAP_VCL23'), (e[(e.HEVC_NAL_RSV_VCL24 = 24)] =
          'HEVC_NAL_RSV_VCL24'), (e[(e.HEVC_NAL_RSV_VCL25 = 25)] =
          'HEVC_NAL_RSV_VCL25'), (e[(e.HEVC_NAL_RSV_VCL26 = 26)] =
          'HEVC_NAL_RSV_VCL26'), (e[(e.HEVC_NAL_RSV_VCL27 = 27)] =
          'HEVC_NAL_RSV_VCL27'), (e[(e.HEVC_NAL_RSV_VCL28 = 28)] =
          'HEVC_NAL_RSV_VCL28'), (e[(e.HEVC_NAL_RSV_VCL29 = 29)] =
          'HEVC_NAL_RSV_VCL29'), (e[(e.HEVC_NAL_RSV_VCL30 = 30)] =
          'HEVC_NAL_RSV_VCL30'), (e[(e.HEVC_NAL_RSV_VCL31 = 31)] =
          'HEVC_NAL_RSV_VCL31'), (e[(e.HEVC_NAL_VPS = 32)] =
          'HEVC_NAL_VPS'), (e[(e.HEVC_NAL_SPS = 33)] = 'HEVC_NAL_SPS'), (e[
          (e.HEVC_NAL_PPS = 34)
        ] =
          'HEVC_NAL_PPS'), (e[(e.HEVC_NAL_AUD = 35)] = 'HEVC_NAL_AUD'), (e[
          (e.HEVC_NAL_EOS_NUT = 36)
        ] =
          'HEVC_NAL_EOS_NUT'), (e[(e.HEVC_NAL_EOB_NUT = 37)] =
          'HEVC_NAL_EOB_NUT'), (e[(e.HEVC_NAL_FD_NUT = 38)] =
          'HEVC_NAL_FD_NUT'), (e[(e.HEVC_NAL_SEI_PREFIX = 39)] =
          'HEVC_NAL_SEI_PREFIX'), (e[(e.HEVC_NAL_SEI_SUFFIX = 40)] =
          'HEVC_NAL_SEI_SUFFIX'), (e[(e.HEVC_NAL_RSV_NVCL41 = 41)] =
          'HEVC_NAL_RSV_NVCL41'), (e[(e.HEVC_NAL_RSV_NVCL42 = 42)] =
          'HEVC_NAL_RSV_NVCL42'), (e[(e.HEVC_NAL_RSV_NVCL43 = 43)] =
          'HEVC_NAL_RSV_NVCL43'), (e[(e.HEVC_NAL_RSV_NVCL44 = 44)] =
          'HEVC_NAL_RSV_NVCL44'), (e[(e.HEVC_NAL_RSV_NVCL45 = 45)] =
          'HEVC_NAL_RSV_NVCL45'), (e[(e.HEVC_NAL_RSV_NVCL46 = 46)] =
          'HEVC_NAL_RSV_NVCL46'), (e[(e.HEVC_NAL_RSV_NVCL47 = 47)] =
          'HEVC_NAL_RSV_NVCL47'), (e[(e.HEVC_NAL_UNSPEC48 = 48)] =
          'HEVC_NAL_UNSPEC48'), (e[(e.HEVC_NAL_UNSPEC49 = 49)] =
          'HEVC_NAL_UNSPEC49'), (e[(e.HEVC_NAL_UNSPEC50 = 50)] =
          'HEVC_NAL_UNSPEC50'), (e[(e.HEVC_NAL_UNSPEC51 = 51)] =
          'HEVC_NAL_UNSPEC51'), (e[(e.HEVC_NAL_UNSPEC52 = 52)] =
          'HEVC_NAL_UNSPEC52'), (e[(e.HEVC_NAL_UNSPEC53 = 53)] =
          'HEVC_NAL_UNSPEC53'), (e[(e.HEVC_NAL_UNSPEC54 = 54)] =
          'HEVC_NAL_UNSPEC54'), (e[(e.HEVC_NAL_UNSPEC55 = 55)] =
          'HEVC_NAL_UNSPEC55'), (e[(e.HEVC_NAL_UNSPEC56 = 56)] =
          'HEVC_NAL_UNSPEC56'), (e[(e.HEVC_NAL_UNSPEC57 = 57)] =
          'HEVC_NAL_UNSPEC57'), (e[(e.HEVC_NAL_UNSPEC58 = 58)] =
          'HEVC_NAL_UNSPEC58'), (e[(e.HEVC_NAL_UNSPEC59 = 59)] =
          'HEVC_NAL_UNSPEC59'), (e[(e.HEVC_NAL_UNSPEC60 = 60)] =
          'HEVC_NAL_UNSPEC60'), (e[(e.HEVC_NAL_UNSPEC61 = 61)] =
          'HEVC_NAL_UNSPEC61'), (e[(e.HEVC_NAL_UNSPEC62 = 62)] =
          'HEVC_NAL_UNSPEC62'), (e[(e.HEVC_NAL_UNSPEC63 = 63)] =
          'HEVC_NAL_UNSPEC63');
      }) (Xe || (Xe = {}));
      var Ye = new Float64Array ([1, 2, 2, 1]),
        Ke = new Float64Array ([1, 2, 1, 1]);
      function Qe (e) {
        return (e[0] >> 1) & 63;
      }
      function $e (e) {
        return e >= 16 && e <= 23;
      }
      var Je = function t () {
        e (this, t), a (this, 'profileSpace', void 0), a (
          this,
          'tierFlag',
          void 0
        ), a (this, 'profileIdc', void 0), a (
          this,
          'profileCompatibilityFlags',
          void 0
        ), a (this, 'constraintIndicatorFlags', void 0), a (
          this,
          'levelIdc',
          void 0
        );
      },
        Ze = function t () {
          e (this, t), a (this, 'generalPTL', new Je ()), a (
            this,
            'subLayerPTL',
            void 0
          ), a (this, 'subLayerProfilePresentFlag', new Array (7)), a (
            this,
            'subLayerLevelPresentFlag',
            new Array (7)
          );
        };
      var et = function t () {
        e (this, t), a (this, 'numDeltaPocs', void 0);
      },
        tt = function t () {
          e (this, t), a (this, 'minSpatialSegmentationIdc', void 0);
        },
        rt = function t () {
          e (this, t), a (this, 'vpsID', void 0), a (
            this,
            'maxSubLayerMinus1',
            void 0
          ), a (this, 'temporalIdNestedFlag', void 0), a (
            this,
            'ptl',
            new Ze ()
          ), a (this, 'spsID', void 0), a (this, 'chromaFormatIdc', void 0), a (
            this,
            'seperateColourPlaneFlag',
            void 0
          ), a (this, 'widthInLumaSamples', void 0), a (
            this,
            'heightInLumaSamples',
            void 0
          ), a (this, 'confWinLeftOffset', void 0), a (
            this,
            'confWinRightOffset',
            void 0
          ), a (this, 'confWinTopOffset', void 0), a (
            this,
            'confWinBottomOffset',
            void 0
          ), a (this, 'bitDepthLumaMinus8', void 0), a (
            this,
            'bitDepthChromaMinus8',
            void 0
          ), a (this, 'log2MaxPicOrderCntLsbMinus4', void 0), a (
            this,
            'subLayerOrderingInfoPresentFlag',
            void 0
          ), a (this, 'numShortTermRefPicSets', void 0), a (
            this,
            'shortTermRefPicSets',
            void 0
          ), a (this, 'vui', new tt ()), a (this, 'width', void 0), a (
            this,
            'height',
            void 0
          );
        };
      function nt (e, t) {
        (t.profileSpace = e.readBits (2)), (t.tierFlag = e.readBits (
          1
        )), (t.profileIdc = e.readBits (
          5
        )), (t.profileCompatibilityFlags = e.readBits (
          32
        )), (t.constraintIndicatorFlags = e.readBits (48));
      }
      function it (e, t, r) {
        nt (e, t.generalPTL), (t.generalPTL.levelIdc = e.readBits (8));
        for (var n = 0; n < r; n++)
          (t.subLayerProfilePresentFlag[
            n
          ] = e.readBoolean ()), (t.subLayerLevelPresentFlag[
            n
          ] = e.readBoolean ());
        r > 0 && e.skipBits (2 * (8 - r)), (t.subLayerPTL = new Array (r + 1));
        for (var i = 0; i < r; i++)
          t.subLayerProfilePresentFlag[i] && nt (e, t.subLayerPTL[i]), t
            .subLayerLevelPresentFlag[i] &&
            (t.subLayerPTL[i].levelIdc = e.readBits (8));
      }
      function at (e) {
        var t = je (e), r = new Te (t);
        r.readBits (16);
        var n = new rt ();
        if (
          ((n.vpsID = r.readBits (4)), (n.maxSubLayerMinus1 = r.readBits (
            3
          )), (n.temporalIdNestedFlag = r.readBoolean ()), it (
            r,
            n.ptl,
            n.maxSubLayerMinus1
          ), (n.spsID = r.readUEG ()), (n.chromaFormatIdc = r.readUEG ()), n.chromaFormatIdc >
            3)
        )
          return console.error (
            'chroma_format_idc '.concat (n.chromaFormatIdc, ' is invalid')
          ), n;
        3 === n.chromaFormatIdc &&
          (n.seperateColourPlaneFlag = r.readBoolean ()), n.seperateColourPlaneFlag &&
          (n.chromaFormatIdc = 0), (n.widthInLumaSamples = r.readUEG ()), (n.heightInLumaSamples = r.readUEG ());
        var i = 0, a = 0, s = 0, o = 0;
        if (r.readBits (1) > 0) {
          (n.confWinLeftOffset = r.readUEG ()), (n.confWinRightOffset = r.readUEG ()), (n.confWinTopOffset = r.readUEG ()), (n.confWinBottomOffset = r.readUEG ());
          var u = Ye[n.chromaFormatIdc];
          (i = n.confWinLeftOffset * u), (a = n.confWinRightOffset * u);
          var c = Ke[n.chromaFormatIdc];
          (s = n.confWinTopOffset * c), (o = n.confWinBottomOffset * c);
        }
        (n.width = n.widthInLumaSamples - i - a), (n.height =
          n.heightInLumaSamples -
          s -
          o), (n.bitDepthLumaMinus8 = r.readUEG ()), (n.bitDepthChromaMinus8 = r.readUEG ()), (n.log2MaxPicOrderCntLsbMinus4 = r.readUEG ()), n.log2MaxPicOrderCntLsbMinus4 >
          12 &&
          console.error (
            'log2_max_pic_order_cnt_lsb_minus4 out range: '.concat (
              n.log2MaxPicOrderCntLsbMinus4
            )
          ), (n.subLayerOrderingInfoPresentFlag = r.readBoolean ());
        for (
          var l = n.subLayerOrderingInfoPresentFlag ? 0 : n.maxSubLayerMinus1;
          l <= n.maxSubLayerMinus1;
          l++
        )
          r.readUEG (), r.readUEG (), r.readUEG ();
        r.readUEG (), r.readUEG (), r.readUEG (), r.readUEG (), r.readUEG (), r.readUEG (), r.readBoolean () &&
          r.readBoolean () &&
          (function (e) {
            for (var t = 0; t < 4; t++)
              for (var r = 0; r < (3 == t ? 2 : 6); r++)
                if (e.readBoolean ()) {
                  var n = Math.min (64, 1 << (4 + (t << 1)));
                  t > 1 && e.readEG ();
                  for (var i = 0; i < n; i++)
                    e.readEG ();
                } else e.readUEG ();
          }) (r), r.readBit (), r.readBit (), r.readBoolean () &&
          (r.skipBits (4), r.skipBits (
            4
          ), r.readUEG (), r.readUEG (), r.readBit ()), (n.numShortTermRefPicSets = r.readUEG ()), (n.shortTermRefPicSets = new Array (
          n.numShortTermRefPicSets
        ));
        for (var h = 0; h < n.numShortTermRefPicSets; h++)
          (n.shortTermRefPicSets[h] = new et ()), ot (r, h, n);
        if (r.readBoolean ()) {
          var f = r.readUEG ();
          for (l = 0; l < f; l++) {
            var d = Math.min (n.log2MaxPicOrderCntLsbMinus4 + 4, 16);
            r.skipBits (d), r.readBit ();
          }
        }
        return r.readBit (), r.readBit (), r.readBoolean () &&
          (function (e, t) {
            e.readBoolean () && 255 == e.readBits (8) && e.skipBits (32);
            e.readBoolean () && e.readBit ();
            e.readBoolean () &&
              (e.skipBits (4), e.readBoolean () && e.skipBits (24));
            e.readBoolean () && (e.readUEG (), e.readUEG ());
            e.skipBits (3), e.readBoolean () &&
              (e.readUEG (), e.readUEG (), e.readUEG (), e.readUEG ());
            e.readBoolean () &&
              ((function (e) {
                e.skipBits (32), e.skipBits (32), e.readBoolean () &&
                  e.readUEG ();
              }) (e), e.readBoolean () &&
                (function (e, t, r) {
                  var n = 0, i = !1, a = !1, s = !1;
                  t &&
                    ((a = e.readBoolean ()), (s = e.readBoolean ()), (a || s) &&
                      ((i = e.readBoolean ()) && e.skipBits (19), e.skipBits (
                        8
                      ), i && e.skipBits (4), e.skipBits (15)));
                  for (n = 0; n <= r; n++) {
                    var o = 0, u = !1, c = !1;
                    e.readBoolean () || (c = e.readBoolean ()), c
                      ? e.readUEG ()
                      : (u = e.readBoolean ()), u || (o = e.readUEG ()), a &&
                      st (e, o, i), s && st (e, o, i);
                  }
                }) (e, !0, t.maxSubLayerMinus1));
            e.readBoolean () &&
              (e.skipBits (
                3
              ), (t.vui.minSpatialSegmentationIdc = e.readUEG ()), e.readUEG (), e.readUEG (), e.readUEG (), e.readUEG ());
          }) (r, n), n;
      }
      function st (e, t, r) {
        for (var n = 0; n <= t; n++)
          e.readUEG (), e.readUEG (), r &&
            (e.readUEG (), e.readUEG ()), e.readBit ();
      }
      function ot (e, t, r) {
        if (t && e.readBoolean ()) {
          e.readBit (), e.readUEG (), (r.shortTermRefPicSets[
            t
          ].numDeltaPocs = 0);
          for (var n = 0; n <= r.shortTermRefPicSets[t - 1].numDeltaPocs; n++) {
            var i = !1, a = e.readBoolean ();
            a || (i = e.readBoolean ()), (a || i) &&
              r.shortTermRefPicSets[t].numDeltaPocs++;
          }
        } else {
          var s = e.readUEG (), o = e.readUEG ();
          r.shortTermRefPicSets[t].numDeltaPocs = s + o;
          for (var u = 0; u < s; u++)
            e.readUEG (), e.readBit ();
          for (var c = 0; c < o; c++)
            e.readUEG (), e.readBit ();
        }
      }
      var ut = function t () {
        e (this, t), a (this, 'tilesEnableFlag', void 0), a (
          this,
          'entropyCodingSyncEnabledFlag',
          void 0
        );
      };
      function ct (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var lt,
        ht,
        ft = (function (t) {
          C (n, t);
          var r = ct (n);
          function n (t) {
            var i;
            e (this, n), a (
              A ((i = r.call (this, t))),
              '_usingDonlField',
              !1
            ), a (A (i), '_partialNal', []), a (
              A (i),
              '_timestampHandler',
              void 0
            ), a (A (i), '_timescale', void 0), a (
              A (i),
              '_rtpPayloadType',
              void 0
            ), a (A (i), '_idrFound', void 0), a (A (i), '_vps', void 0), a (
              A (i),
              '_sps',
              void 0
            ), a (A (i), '_pps', void 0), a (A (i), '_isProbeDone', void 0), a (
              A (i),
              '_isProcessorReady',
              void 0
            ), a (A (i), '_pktBuffer', void 0), i.setLogger ('RTPH265Protocol');
            var s = t.mediaDesc;
            return s.rtp && s.rtp.length > 0
              ? (i._timescale = s.rtp[0].rate)
              : (i._timescale = 9e4), (i._pktBuffer = new We.c ()), (i._rtpPayloadType =
              s.rtp[0].payload), (i._timestampHandler = new be ()), i.events.on (
              Q,
              function () {
                for (i._isProcessorReady = !0; !i._pktBuffer.isEmpty (); ) {
                  var e = i._pktBuffer.dequeue ();
                  i.events.emit (X, e);
                }
              }
            ), s.fmtp &&
              s.fmtp[0] &&
              s.fmtp[0].config &&
              i._extractFmtpConfig (s.fmtp[0].config), i;
          }
          return i (n, [
            {
              key: '_extractFmtpConfig',
              value: function (e) {
                var t = de.rz (e);
                'sprop-max-don-diff' in t &&
                  t['sprop-max-don-diff'] > 0 &&
                  (this._usingDonlField = !0), 'sprop-depack-buf-nalus' in t &&
                  t['sprop-depack-buf-nalus'] > 0 &&
                  (this._usingDonlField = !0), 'sprop-vps' in t &&
                  (this._vps = ke (t['sprop-vps'])), 'sprop-sps' in t &&
                  (this._sps = ke (t['sprop-sps'])), 'sprop-pps' in t &&
                  (this._pps = ke (t['sprop-pps'])), this._checkProbeData ();
              },
            },
            {
              key: '_checkProbeData',
              value: function () {
                if (!this._vps || !this._sps || !this._pps)
                  return this._isProbeDone;
                var e = at (this._sps),
                  t = (function (e) {
                    var t = 'hvc1.';
                    switch (e.ptl.generalPTL.profileSpace) {
                      case 0:
                        break;
                      case 1:
                        t += 'A';
                        break;
                      case 2:
                        t += 'B';
                        break;
                      case 3:
                        t += 'C';
                    }
                    t += ''.concat (e.ptl.generalPTL.profileIdc, '.');
                    for (
                      var r = e.ptl.generalPTL.profileCompatibilityFlags,
                        n = 0,
                        i = 0;
                      i < 31;
                      i++
                    )
                      (n |= 1 & r), (n <<= 1), (r >>>= 1);
                    if (
                      ((t += ''.concat ((n |= 1 & r).toString (16), '.')), e.ptl
                        .generalPTL.tierFlag
                        ? (t += 'H')
                        : (t += 'L'), (t += ''.concat (
                        e.ptl.generalPTL.levelIdc
                      )), e.ptl.generalPTL.constraintIndicatorFlags)
                    ) {
                      var a = new Ue (6);
                      a.write (e.ptl.generalPTL.constraintIndicatorFlags, 48);
                      for (
                        var s = new Pe (a.bytes ()), o = 0;
                        o < 48 &&
                        (s.seek (o), (t += '.'.concat (
                          s.read (8).toString (16)
                        )), 0 !== s.read (40 - o));
                        o += 8
                      );
                    } else t += '.0';
                    return t;
                  }) (e),
                  r = {
                    width: e.width,
                    height: e.height,
                    codec: 'hevc',
                    codecStr: t,
                  };
                return this.events.emit (
                  Y,
                  r
                ), (this._isProbeDone = !0), this._postNal (
                  this._vps,
                  0,
                  0
                ), this._postNal (this._sps, 0, 0), this._postNal (
                  this._pps,
                  0,
                  0
                ), this._isProbeDone;
              },
            },
            {
              key: '_extractCustomSEIPayload',
              value: function (e) {
                var t = null;
                if (Qe (e) == Xe.HEVC_NAL_SEI_PREFIX) {
                  var r = je (e.subarray (2)), n = new Te (r);
                  try {
                    if (5 === n.readFFLongUint ()) {
                      for (
                        var i = n.readFFLongUint (),
                          a = new Uint8Array (i),
                          s = 0;
                        s < i;
                        s++
                      )
                        a[s] = n.readUByte ();
                      t = a;
                    }
                  } catch (e) {
                    this.logger.debug ('invalid sei');
                  }
                }
                return t;
              },
            },
            {
              key: '_dealWithNal',
              value: function (e, t) {
                var r = Qe (e);
                if (
                  (this._isProbeDone ||
                    (r === Xe.HEVC_NAL_VPS
                      ? (this._vps = e)
                      : r === Xe.HEVC_NAL_SPS
                          ? (this._sps = e)
                          : r === Xe.HEVC_NAL_PPS &&
                              (this._pps = e), this._checkProbeData ())) &&
                  (this._idrFound || $e (r))
                ) {
                  this._idrFound = !0;
                  var n = this._extractCustomSEIPayload (e);
                  if (n) {
                    var i = this._timestampHandler.adjust (t) / this._timescale;
                    this.events.emit (B, {scaledPTS: i, payload: n});
                  } else {
                    this._timestampHandler.checkOverflow (t);
                    var a = this._timestampHandler.adjust (t) / this._timescale;
                    this._postNal (e, a, t);
                  }
                }
              },
            },
            {
              key: '_postNal',
              value: function (e, t, r) {
                var n = {data: e, pts: t, timestamp: r};
                this._isProcessorReady
                  ? this.events.emit (X, n)
                  : this._pktBuffer.enqueue (n);
              },
            },
            {
              key: 'processRTP',
              value: function (e) {
                var t = new Re (e);
                t.payloadType === this._rtpPayloadType &&
                  this._processRTPPayload (t.payload, t.timestamp);
              },
            },
            {key: 'processRTCP', value: function (e) {}},
            {
              key: '_processRTPPayload',
              value: function (e, t) {
                e[0];
                var r = (e[0] >> 1) & 63;
                e[0], e[1], e[1];
                switch (r) {
                  case 32:
                  case 33:
                  case 34:
                  case 39:
                  default:
                    this._handleSinglePacket (e, t);
                    break;
                  case 48:
                    this._handleAggregationPacket (e, t);
                    break;
                  case 49:
                    this._handleFragPacket (e, t);
                    break;
                  case 50:
                }
              },
            },
            {
              key: '_handleSinglePacket',
              value: function (e, t) {
                this._dealWithNal (e, t);
              },
            },
            {
              key: '_handleAggregationPacket',
              value: function (e, t) {
                var r = 2;
                this._usingDonlField && (r += 2);
                var n = this._usingDonlField ? 1 : 0;
                this._handleAggregationPacketNalus (e.subarray (r), t, n);
              },
            },
            {
              key: '_handleAggregationPacketNalus',
              value: function (e, t, r) {
                for (var n = 0; n + 2 < e.length - 1; ) {
                  var i = (e[n] << 8) + (e[n + 1] << 0);
                  (n += 2), this._dealWithNal (e.slice (n, n + i), t), (n =
                    n + i + r);
                }
              },
            },
            {
              key: '_handleFragPacket',
              value: function (e, t) {
                var r = 2,
                  n = (e[r] >> 7) & 1,
                  i = (e[r] >> 6) & 1,
                  a = 63 & e[r];
                if (
                  ((r += 1), this._usingDonlField && (r += 2), 1 == n && 0 == i)
                ) {
                  this._partialNal = [];
                  var s = new Uint8Array (2);
                  (s[0] = (129 & e[0]) | (a << 1)), (s[1] =
                    e[1]), this._partialNal.push (s), this._partialNal.push (
                    e.subarray (r)
                  );
                }
                0 == n && 0 == i && this._partialNal.push (e.subarray (r)), 0 ==
                  n &&
                  1 == i &&
                  (this._partialNal.push (e.subarray (r)), this._dealWithNal (
                    Le.apply (void 0, N (this._partialNal)),
                    t
                  ));
              },
            },
          ]), n;
        }) (Z),
        dt = (function () {
          function t () {
            e (this, t);
          }
          return i (t, null, [
            {
              key: 'isSupportedScore',
              value: function (e) {
                switch (e) {
                  case 'H264':
                    return 100;
                  case 'H265':
                    return 50;
                  case 'AAC':
                    return 100;
                  default:
                    return 0;
                }
              },
            },
            {
              key: 'getDynamicProtocol',
              value: function (e) {
                switch (e.codec) {
                  case 'H264':
                    return new qe (e);
                  case 'H265':
                    return new ft (e);
                  case 'AAC':
                    return new Ve (e);
                }
                return null;
              },
            },
          ]), t;
        }) ();
      !(function (e) {
        (e.AUDIO = 'audio'), (e.VIDEO = 'video');
      }) (lt || (lt = {})), (function (e) {
        (e.H264 = 'h264'), (e.H265 = 'hevc'), (e.AAC = 'aac');
      }) (ht || (ht = {}));
      var pt = function t () {
        e (this, t), a (this, 'codec', void 0);
      };
      function _t (e, t) {
        var r = Object.keys (e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols (e);
          t &&
            (n = n.filter (function (t) {
              return Object.getOwnPropertyDescriptor (e, t).enumerable;
            })), r.push.apply (r, n);
        }
        return r;
      }
      function vt (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? _t (Object (r), !0).forEach (function (t) {
                a (e, t, r[t]);
              })
            : Object.getOwnPropertyDescriptors
                ? Object.defineProperties (
                    e,
                    Object.getOwnPropertyDescriptors (r)
                  )
                : _t (Object (r)).forEach (function (t) {
                    Object.defineProperty (
                      e,
                      t,
                      Object.getOwnPropertyDescriptor (r, t)
                    );
                  });
        }
        return e;
      }
      function gt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      function yt (e) {
        var t = e.headers.transport;
        if (t) {
          var r = t.match (/interleaved=([0-9]+)-([0-9]+)/);
          if (r && r.length > 0) return parseInt (r[1]);
        }
        return 0;
      }
      var mt = (function (t) {
        C (o, t);
        var r, n, s = gt (o);
        function o (t) {
          var r;
          return e (this, o), a (
            A ((r = s.call (this, t))),
            '_client',
            void 0
          ), a (A (r), '_rtpSubStreams', {}), (r._client = new me ({
            events: t.events,
            metrics: t.metrics,
            url: t.url,
            socketurl: t.socketurl,
          })), r;
        }
        return i (o, [
          {
            key: '_setupStreams',
            value: ((n = ie (
              se ().mark (function e (t) {
                var r, n, i, a, s, o;
                return se ().wrap (
                  function (e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          if (0 != t.media.length) {
                            e.next = 2;
                            break;
                          }
                          throw new Error ('empty sdp media');
                        case 2:
                          if (
                            ((r = {}), t.media.forEach (function (e) {
                              var t;
                              e.control = e.control || '';
                              var n =
                                (null === (t = e.rtp[0]) || void 0 === t
                                  ? void 0
                                  : t.codec) || '';
                              'mpeg4-generic' == n.toLowerCase () &&
                                e.fmtp[0].config.includes ('AAC') &&
                                (n = 'AAC');
                              var i = dt.isSupportedScore (n);
                              0 != i &&
                                (!(e.type in r) || r[e.type].score < i) &&
                                (r[e.type] = vt (
                                  vt ({}, e),
                                  {},
                                  {score: i, codec: n}
                                ));
                            }), 'video' in r)
                          ) {
                            e.next = 7;
                            break;
                          }
                          return this.events.emit (Y), e.abrupt ('return');
                        case 7:
                          'audio' in r
                            ? (((n = new pt ()).codec =
                                'aac'), this.events.emit (K, n))
                            : (this.events.emit (
                                K,
                                new pt ()
                              ), this.events.emit (G)), this.options
                            .enableAudio || delete r.audio, (e.t0 = se ().keys (
                            r
                          ));
                        case 11:
                          if ((e.t1 = e.t0 ()).done) {
                            e.next = 21;
                            break;
                          }
                          return (i = e.t1.value), (a =
                            r[i]), (e.next = 16), this._client.sendSetup (
                            a.control
                          );
                        case 16:
                          (s = e.sent), (o = yt (s)), (this._rtpSubStreams[
                            o
                          ] = dt.getDynamicProtocol ({
                            events: this.options.events,
                            metrics: this.options.metrics,
                            codec: a.codec,
                            mediaDesc: a,
                          })), (e.next = 11);
                          break;
                        case 21:
                          return (e.next = 23), this._client.play ();
                        case 23:
                        case 'end':
                          return e.stop ();
                      }
                  },
                  e,
                  this
                );
              })
            )), function (e) {
              return n.apply (this, arguments);
            }),
          },
          {
            key: 'start',
            value: ((r = ie (
              se ().mark (function e () {
                var t = this;
                return se ().wrap (function (e) {
                  for (;;) switch ((e.prev = e.next)) {
                      case 0:
                        return e.abrupt (
                          'return',
                          new Promise (function (e, r) {
                            t._client.connect ().then (
                              (function () {
                                var r = ie (
                                  se ().mark (function r (n) {
                                    return se ().wrap (function (r) {
                                      for (;;) switch ((r.prev = r.next)) {
                                          case 0:
                                            return (r.next = 2), t._setupStreams (n);
                                          case 2:
                                            t._client.startKeepAlive (), e (null);
                                          case 4:
                                          case 'end':
                                            return r.stop ();
                                        }
                                    }, r);
                                  })
                                );
                                return function (e) {
                                  return r.apply (this, arguments);
                                };
                              }) ()
                            ), t._client.on (z, function (e, r) {
                              e % 2 == 0
                                ? e in t._rtpSubStreams &&
                                    t._rtpSubStreams[e].processRTP (r)
                                : --e in t._rtpSubStreams &&
                                    t._rtpSubStreams[e].processRTCP (r);
                            });
                          })
                        );
                      case 1:
                      case 'end':
                        return e.stop ();
                    }
                }, e);
              })
            )), function () {
              return r.apply (this, arguments);
            }),
          },
          {
            key: 'destroy',
            value: function () {
              this._client.destroy ();
            },
          },
        ]), o;
      }) (Z);
      function bt (e, t) {
        var r;
        if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
          if (
            Array.isArray (e) ||
            (r = (function (e, t) {
              if (!e) return;
              if ('string' == typeof e) return Et (e, t);
              var r = Object.prototype.toString.call (e).slice (8, -1);
              'Object' === r && e.constructor && (r = e.constructor.name);
              if ('Map' === r || 'Set' === r) return Array.from (e);
              if (
                'Arguments' === r ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test (r)
              )
                return Et (e, t);
            }) (e)) ||
            (t && e && 'number' == typeof e.length)
          ) {
            r && (e = r);
            var n = 0, i = function () {};
            return {
              s: i,
              n: function () {
                return n >= e.length ? {done: !0} : {done: !1, value: e[n++]};
              },
              e: (function (e) {
                function t (t) {
                  return e.apply (this, arguments);
                }
                return (t.toString = function () {
                  return e.toString ();
                }), t;
              }) (function (e) {
                throw e;
              }),
              f: i,
            };
          }
          throw new TypeError (
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        }
        var a, s = !0, o = !1;
        return {
          s: function () {
            r = e[Symbol.iterator] ();
          },
          n: function () {
            var e = r.next ();
            return (s = e.done), e;
          },
          e: (function (e) {
            function t (t) {
              return e.apply (this, arguments);
            }
            return (t.toString = function () {
              return e.toString ();
            }), t;
          }) (function (e) {
            (o = !0), (a = e);
          }),
          f: function () {
            try {
              s || null == r.return || r.return ();
            } finally {
              if (o) throw a;
            }
          },
        };
      }
      function Et (e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array (t); r < t; r++)
          n[r] = e[r];
        return n;
      }
      var xt = (function () {
        function t (r, n, i, s) {
          e (this, t), a (this, 'target', void 0), a (this, 'type', void 0), a (
            this,
            'listener',
            void 0
          ), a (
            this,
            'options',
            void 0
          ), (this.target = r), (this.type = n), (this.listener = i), (this.options = t.convertOptions_ (
            r,
            s
          )), this.target.addEventListener (n, i, this.options);
        }
        return i (
          t,
          [
            {
              key: 'unlisten',
              value: function () {
                this.target.removeEventListener (
                  this.type,
                  this.listener,
                  this.options
                ), (this.target = null), (this.listener = null), (this.options = !1);
              },
            },
          ],
          [
            {
              key: 'convertOptions_',
              value: function (e, r) {
                if (null == r) return !1;
                if ('boolean' == typeof r) return r;
                var n = new Set (['passive', 'capture']);
                Object.keys (r).filter (function (e) {
                  return !n.has (e);
                });
                return t.doesSupportObject_ (e) ? r : r.capture || !1;
              },
            },
            {
              key: 'doesSupportObject_',
              value: function (e) {
                var r = t.supportsObject_;
                if (null == r) {
                  r = !1;
                  try {
                    var n = {},
                      i = {
                        get: function () {
                          return (r = !0), !1;
                        },
                      };
                    Object.defineProperty (
                      n,
                      'passive',
                      i
                    ), Object.defineProperty (n, 'capture', i);
                    var a = function () {};
                    e.addEventListener ('test', a, n), e.removeEventListener (
                      'test',
                      a,
                      n
                    );
                  } catch (e) {
                    r = !1;
                  }
                  t.supportsObject_ = r;
                }
                return r || !1;
              },
            },
          ]
        ), t;
      }) ();
      a (xt, 'supportsObject_', void 0);
      var wt = (function () {
        function t () {
          e (this, t), a (
            this,
            'bindingMap_',
            void 0
          ), (this.bindingMap_ = new U ());
        }
        return i (t, [
          {
            key: 'release',
            value: function () {
              this.removeAll (), (this.bindingMap_ = null);
            },
          },
          {
            key: 'listen',
            value: function (e, t, r, n) {
              if (this.bindingMap_) {
                var i = new xt (e, t, r, n);
                this.bindingMap_.push (t, i);
              }
            },
          },
          {
            key: 'listenOnce',
            value: function (e, t, r, n) {
              var i = this;
              this.listen (
                e,
                t,
                function n (a) {
                  i.unlisten (e, t, n), r (a);
                },
                n
              );
            },
          },
          {
            key: 'unlisten',
            value: function (e, t, r) {
              if (this.bindingMap_) {
                var n, i = bt (this.bindingMap_.get (t) || []);
                try {
                  for (i.s (); !(n = i.n ()).done; ) {
                    var a = n.value;
                    a.target == e &&
                      ((r != a.listener && r) ||
                        (a.unlisten (), this.bindingMap_.remove (t, a)));
                  }
                } catch (e) {
                  i.e (e);
                } finally {
                  i.f ();
                }
              }
            },
          },
          {
            key: 'removeAll',
            value: function () {
              if (this.bindingMap_) {
                var e, t = bt (this.bindingMap_.getAll ());
                try {
                  for (t.s (); !(e = t.n ()).done; ) {
                    e.value.unlisten ();
                  }
                } catch (e) {
                  t.e (e);
                } finally {
                  t.f ();
                }
                this.bindingMap_.clear ();
              }
            },
          },
        ]), t;
      }) ();
      function St (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var At = (function (t) {
        C (n, t);
        var r = St (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            '_destroyed',
            !1
          ), a (A (i), '_queue', []), a (A (i), '_sourceBuffer', void 0), a (
            A (i),
            '_video',
            void 0
          ), a (A (i), '_eventManager', void 0), a (
            A (i),
            '_fastForwardBeginDuration',
            void 0
          ), a (A (i), '_fastForwardEndDuration', void 0), a (
            A (i),
            '_liveBufferDuration',
            void 0
          ), a (A (i), '_isLive', void 0), a (
            A (i),
            '_lastClearEnd',
            0
          ), i.setLogger (
            'MSEBuffer'
          ), (i._eventManager = new wt ()), (i._video = t.video), (i._isLive =
            t.isLive), (i._fastForwardBeginDuration =
            t.fastForwardBeginDuration || 6), (i._fastForwardEndDuration =
            t.fastForwardEndDuration || 3), (i._liveBufferDuration =
            t.liveBufferDuration || 60), i._initBuffer (), i;
        }
        return i (n, [
          {
            key: '_initBuffer',
            value: function () {
              var e = this;
              this._enqueueOperations (function () {
                var t = function () {
                  var t = e.options;
                  (e._sourceBuffer = t.mediaSource.addSourceBuffer (
                    t.codec
                  )), e._eventManager.listen (
                    e._sourceBuffer,
                    'error',
                    e._onError.bind (e)
                  ), e._eventManager.listen (
                    e._sourceBuffer,
                    'updateend',
                    e._onUpdateEnd.bind (e)
                  ), e._onUpdateEnd ();
                },
                  r = e.options;
                'open' === r.mediaSource.readyState
                  ? t ()
                  : e._eventManager.listenOnce (r.mediaSource, 'sourceopen', t);
              });
            },
          },
          {
            key: '_onError',
            value: function (e) {
              this.logger.error (e), this.logger.debug (
                '<<<'
                  .concat (this._video.error.code, ' ')
                  .concat (this._video.error.message)
              );
            },
          },
          {
            key: 'appendBuffer',
            value: function (e) {
              var t = this;
              return this._enqueueOperations (function () {
                t._opAppend (e);
              });
            },
          },
          {
            key: '_enqueueOperations',
            value: function (e) {
              if (this._destroyed) return Promise.reject ();
              var t = {start: e, p: new le ()};
              if ((this._queue.push (t), 1 == this._queue.length))
                try {
                  t.start ();
                } catch (e) {
                  t.p.reject (e), this._popFromQueue ();
                }
            },
          },
          {
            key: '_opAppend',
            value: function (e) {
              this._adjustPlaySpeed ();
              try {
                this._sourceBuffer.appendBuffer (e);
              } catch (e) {
                this.logger.error ('_opAppend aapendbuffere error ', e);
              }
              this._clearLiveBuffer ();
            },
          },
          {
            key: '_clearLiveBuffer',
            value: function () {
              if (this._isLive) {
                var e = this._sourceBuffer.buffered;
                if (0 != e.length) {
                  var t = e.start (0), r = e.end (0);
                  if (this._video.currentTime < t) this._video.currentTime = t;
                  else if (this._video.currentTime > r)
                    this._video.currentTime = Math.max (t, r - 0.1);
                  else {
                    var n = this._video.currentTime - this._liveBufferDuration;
                    r - t < this._liveBufferDuration ||
                      t >= n ||
                      n - this._lastClearEnd < this._liveBufferDuration ||
                      ((this._lastClearEnd = n), this.remove (t, n));
                  }
                }
              }
            },
          },
          {
            key: 'remove',
            value: function (e, t) {
              return this._enqueueOperations (this._opRemove.bind (this, e, t));
            },
          },
          {
            key: '_popFromQueue',
            value: function () {
              if (!this._destroyed) {
                this._queue.shift ();
                var e = this._queue[0];
                if (e)
                  try {
                    e.start ();
                  } catch (t) {
                    this.logger.error ('pop op: ', t), e.p.reject (
                      t
                    ), this._popFromQueue ();
                  }
              }
            },
          },
          {
            key: '_adjustPlaySpeed',
            value: function () {
              if (0 != this._sourceBuffer.buffered.length) {
                var e = this._video,
                  t = this._sourceBuffer.buffered.end (0),
                  r = e.currentTime;
                1 == e.playbackRate
                  ? r < t - this._fastForwardBeginDuration &&
                      ((e.playbackRate = 1.5), this.logger.debug (
                        'begin fast forward readyState: ',
                        e.readyState,
                        'currentTime: ',
                        r,
                        'buffer end',
                        t
                      ))
                  : e.playbackRate > 1 &&
                      r >= t - this._fastForwardEndDuration &&
                      ((e.playbackRate = 1), this.logger.debug (
                        'end fast forward readyState: ',
                        e.readyState,
                        'currentTime: ',
                        r,
                        'buffer end',
                        t
                      ));
              }
            },
          },
          {
            key: '_opRemove',
            value: function (e, t) {
              t <= e
                ? this._onUpdateEnd ()
                : (this.logger.debug (
                    'cleaing streaming buffer: ',
                    e,
                    t
                  ), this._sourceBuffer.remove (e, t));
            },
          },
          {
            key: '_onUpdateEnd',
            value: function () {
              var e = this._queue[0];
              e
                ? this._sourceBuffer.updating
                    ? this.logger.debug (
                        'SourceBuffer should not be updating on updateend!'
                      )
                    : (e.p.resolve (), this._popFromQueue ())
                : this.logger.debug ('Spurious updateend event!');
            },
          },
          {
            key: 'destroy',
            value: function () {
              this._destroyed = !0;
              var e = this.options;
              this._sourceBuffer &&
                (e.mediaSource.removeSourceBuffer (
                  this._sourceBuffer
                ), (this._sourceBuffer = null)), this._eventManager &&
                (this._eventManager.release (), (this._eventManager = null));
            },
          },
        ]), n;
      }) (Z);
      function Pt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var Ct = (function (t) {
        C (n, t);
        var r = Pt (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            '_video',
            void 0
          ), a (A (i), '_mediaSource', void 0), a (A (i), '_buffers', []), a (
            A (i),
            '_url',
            void 0
          ), a (A (i), '_eventManager', void 0), a (
            A (i),
            '_mediaReady',
            void 0
          ), i.setLogger (
            'MediaSourceEngine'
          ), (i._eventManager = new wt ()), (i._video = t.video), i._init (), i;
        }
        return i (
          n,
          [
            {
              key: '_init',
              value: function () {
                (this._mediaSource = this._createMediaSource ()), (this._mediaReady = new le ()), this.bindEvents ();
              },
            },
            {
              key: 'bindEvents',
              value: function () {
                var e = this;
                [
                  'canplay',
                  'play',
                  'timeupdate',
                  'waiting',
                  'error',
                ].forEach (function (t) {
                  e._eventManager.listen (e._video, t, function (r) {
                    return e.events.emit (t, r);
                  });
                }), this._eventManager.listen (
                  this._video,
                  'canplay',
                  function () {
                    e.events.emit (j, e);
                  }
                );
              },
            },
            {
              key: '_createMediaSource',
              value: function () {
                var e = this, t = new MediaSource ();
                return this._eventManager.listenOnce (
                  t,
                  'sourceopen',
                  function () {
                    return e._onSourceOpen ();
                  }
                ), (this._url = URL.createObjectURL (
                  t
                )), (this._video.src = this._url), t;
              },
            },
            {
              key: '_onSourceOpen',
              value: function () {
                URL.revokeObjectURL (this._url), this._mediaReady.resolve ();
              },
            },
            {
              key: 'addTrack',
              value: function (e, t) {
                var r = this.options;
                this._buffers[e] = new At ({
                  events: r.events,
                  metrics: r.metrics,
                  video: r.video,
                  mediaSource: this._mediaSource,
                  codec: t,
                  isLive: r.isLive,
                });
              },
            },
            {
              key: 'appendBuffer',
              value: function (e, t) {
                this._buffers[e] && this._buffers[e].appendBuffer (t);
              },
            },
            {
              key: 'destroy',
              value: function () {
                this._buffers.forEach (function (e) {
                  e.destroy ();
                }), this._eventManager &&
                  (this._eventManager.release (), (this._eventManager = null)), this
                  ._video &&
                  (this._video.removeAttribute (
                    'src'
                  ), this._video.load (), (this._video = null)), (this._mediaSource = null), (this._buffers = null), (this._url = null), this.events.removeAll ();
              },
            },
          ],
          [
            {
              key: 'isSupported',
              value: function (e) {
                return (
                  window.MediaSource &&
                  window.MediaSource.isTypeSupported (
                    'video/mp4; codecs="'.concat (e.join (','), '"')
                  )
                );
              },
            },
          ]
        ), n;
      }) (Z),
        Lt = (function () {
          function t () {
            e (this, t), a (this, '_metrics', {});
          }
          return i (t, [
            {
              key: 'log',
              value: function (e, t) {
                this._metrics[e] = t;
              },
            },
            {
              key: 'getAll',
              value: function () {
                return JSON.parse (JSON.stringify (this._metrics));
              },
            },
          ]), t;
        }) ();
      function kt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      a (Lt, 'PresentedFrames', 'presentedFrames');
      var Tt = (function (t) {
        C (n, t);
        var r = kt (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            '_video',
            void 0
          ), a (A (i), '_engine', void 0), a (A (i), 'container', void 0), a (
            A (i),
            '_snapshotCanvas',
            void 0
          ), a (A (i), '_eventManager', void 0), a (
            A (i),
            '_initSeg',
            void 0
          ), a (A (i), '_keySeg', void 0), a (
            A (i),
            '_isPausing',
            !0
          ), i.setLogger ('MSEPlayer'), (i.container =
            t.container), (i._eventManager = new wt ()), i._initVideoElement (), i._bindEvents (), i;
        }
        return i (n, [
          {
            key: '_onVideoData',
            value: function (e) {
              e.isInit
                ? (this._initSeg = e.data)
                : (e.isKeyFrame && (this._keySeg = e), this._initEngine (), this
                    ._engine
                    ? this._engine.appendBuffer (lt.VIDEO, e.data)
                    : this.logger.debug ('mse: no append'));
            },
          },
          {
            key: '_initEngine',
            value: function () {
              if (!this._engine)
                if (this._initSeg && this._keySeg) {
                  var e, t, r, n = this.options;
                  (this._engine = new Ct ({
                    events: this.options.events,
                    metrics: this.options.metrics,
                    isLive: !0,
                    video: this._video,
                  })), this._engine.addTrack (
                    lt.VIDEO,
                    ((e = 'video/mp4'), (t = n.codecStr), (r = e), t &&
                      (r += '; codecs="' + t + '"'), r)
                  ), this._engine.appendBuffer (
                    lt.VIDEO,
                    this._initSeg
                  ), this._engine.appendBuffer (lt.VIDEO, this._keySeg.data);
                } else this.logger.debug ('keyframe', this._keySeg);
            },
          },
          {
            key: '_resetEngine',
            value: function () {
              this._engine &&
                (this._engine.destroy (), (this._engine = null)), (this._keySeg = null);
            },
          },
          {
            key: '_onVideoError',
            value: function (e) {
              this.logger.error (e), this.logger.error (
                '<<<'
                  .concat (this._video.error.code, ' ')
                  .concat (this._video.error.message)
              ), this._resetEngine ();
            },
          },
          {
            key: '_initVideoElement',
            value: function () {
              var e = this, t = document.createElement ('video');
              if (
                ((t.muted = !0), (t.style.width = '100%'), (t.style.height =
                  '100%'), (t.style.objectFit =
                  'contain'), this.container.appendChild (
                  t
                ), (this._video = t), this._eventManager.listen (
                  this._video,
                  'error',
                  this._onVideoError.bind (this)
                ), 'requestVideoFrameCallback' in HTMLVideoElement.prototype)
              ) {
                var r = this._video;
                r.requestVideoFrameCallback (function t (n, i) {
                  e._video &&
                    (e.metrics.log (Lt.PresentedFrames, {
                      value: i.presentedFrames,
                      time: n,
                    }), r.requestVideoFrameCallback (t));
                });
              }
            },
          },
          {
            key: '_bindEvents',
            value: function () {
              this.events.on (V, this._onVideoData.bind (this));
            },
          },
          {
            key: 'play',
            value: function () {
              this._isPausing &&
                ((this._isPausing = !1), this._video.play (), this._checkPlay ());
            },
          },
          {
            key: '_checkPlay',
            value: function () {
              var e = this;
              this._isPausing ||
                (this._video &&
                  this._video.paused &&
                  this._video.play (), setTimeout (function () {
                  e._checkPlay ();
                }, 1e3));
            },
          },
          {
            key: 'pause',
            value: function () {
              (this._isPausing = !0), this._video.pause ();
            },
          },
          {
            key: 'currentTime',
            get: function () {
              return this._video.currentTime;
            },
            set: function (e) {
              this._video.currentTime = e;
            },
          },
          {
            key: 'destroy',
            value: function () {
              this._eventManager &&
                (this._eventManager.release (), (this._eventManager = null)), this._resetEngine (), this.container.removeChild (
                this._video
              ), (this._video = null), (this._snapshotCanvas = null);
            },
          },
          {
            key: 'captureToBlob',
            value: function (e, t, r) {
              var n = this._snapshotCanvas;
              if (!n) {
                var i = this.options;
                ((n = document.createElement ('canvas')).width =
                  i.width), (n.height = i.height), (this._snapshotCanvas = n);
              }
              this._snapshotCanvas
                .getContext ('2d')
                .drawImage (this._video, 0, 0, n.width, n.height), n.toBlob (
                e,
                t,
                r
              );
            },
          },
        ]), n;
      }) (Z),
        Rt = r (731),
        Nt = r.n (Rt),
        Ut = r (662),
        Ht = r.n (Ut);
      function Dt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var It = (function (t) {
        C (n, t);
        var r = Dt (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            'canvas',
            void 0
          ), a (A (i), 'render', void 0), i.setLogger ('Screen'), (i.canvas =
            t.canvas), (i.render = Nt ().attach (i.canvas, null)), i;
        }
        return i (n, [
          {
            key: 'clear',
            value: function () {
              this.render.clear ();
            },
          },
          {
            key: 'drawFrame',
            value: function (e) {
              var t = Date.now (),
                r = e.width,
                n = e.height,
                i = e.data,
                a = r,
                s = r / 2,
                o = s,
                u = r * n,
                c = r * n / 4,
                l = c,
                h = {bytes: i.subarray (0, u), stride: a},
                f = {bytes: i.subarray (u, u + c), stride: s},
                d = {bytes: i.subarray (u + c, u + c + l), stride: o},
                p = Ht ().format ({
                  width: r,
                  height: n,
                  chromaWidth: r / 2,
                  chromaHeight: n / 2,
                  cropLeft: 0,
                  cropTop: 0,
                  cropWidth: 0,
                  cropHeight: 0,
                  displayWidth: 0,
                  displayHeight: 0,
                }),
                _ = Ht ().frame (p, h, f, d);
              this.render.drawFrame (_);
              var v = Date.now ();
              v - t > 10 &&
                this.logger.warn ('drawFrame', 'reandertime:', v - t);
            },
          },
        ]), n;
      }) (Z),
        Bt = r (436);
      function Vt (e, t) {
        var r = Object.keys (e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols (e);
          t &&
            (n = n.filter (function (t) {
              return Object.getOwnPropertyDescriptor (e, t).enumerable;
            })), r.push.apply (r, n);
        }
        return r;
      }
      function Ot (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Vt (Object (r), !0).forEach (function (t) {
                a (e, t, r[t]);
              })
            : Object.getOwnPropertyDescriptors
                ? Object.defineProperties (
                    e,
                    Object.getOwnPropertyDescriptors (r)
                  )
                : Vt (Object (r)).forEach (function (t) {
                    Object.defineProperty (
                      e,
                      t,
                      Object.getOwnPropertyDescriptor (r, t)
                    );
                  });
        }
        return e;
      }
      var Ft = (function () {
        function t (r) {
          e (this, t), a (this, '_options', void 0), a (
            this,
            '_ptsRing',
            void 0
          ), a (this, '_frameBuffer', void 0), a (
            this,
            '_eofReceived',
            void 0
          ), (this._options = r), (this._ptsRing = new Bt.H2 ()), (this._frameBuffer = new We.c ());
        }
        return i (t, [
          {
            key: 'markEOF',
            value: function () {
              this._eofReceived = !0;
            },
          },
          {
            key: 'push',
            value: function (e) {
              var t = this._frameBuffer.back ();
              if (t && t.pts === e.pts)
                return (t.data = Le (t.data, e.data)), void (t.isKeyFrame =
                  t.isKeyFrame || e.isKeyFrame);
              this._frameBuffer.enqueue (e), this._ptsRing.insert (e.pts);
            },
          },
          {
            key: 'pop',
            value: function () {
              if (
                this._frameBuffer.size () < this._options.maxReorderFrame &&
                !this._eofReceived
              )
                return null;
              var e = this._ptsRing.extractRoot (),
                t = this._frameBuffer.dequeue (),
                r = 0.04;
              return this._ptsRing.size () > 0 &&
                (r = this._ptsRing.root () - e), Ot (
                Ot ({}, t),
                {},
                {dts: e, duration: r}
              );
            },
          },
        ]), t;
      }) ();
      function Mt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var Gt = new Uint8Array ([0, 0, 0, 1]),
        jt = (function (t) {
          C (n, t);
          var r = Mt (n);
          function n (t) {
            var i;
            return e (this, n), a (
              A ((i = r.call (this, t))),
              '_frameBuffer',
              void 0
            ), a (A (i), '_packetQueue', void 0), a (
              A (i),
              '_tsQueue',
              void 0
            ), a (A (i), '_decodeWorker', void 0), (i._frameBuffer = new Ft ({
              maxReorderFrame: 16,
            })), (i._packetQueue = new We.c ()), (i._tsQueue = new We.c ()), i.events.on (
              X,
              i._onNalu.bind (A (i))
            ), i._setupDecodeWorker (), i;
          }
          return i (n, [
            {
              key: '_onNalu',
              value: function (e) {
                var t = new Uint8Array (4 + e.data.length);
                t.set (Gt, 0), t.set (e.data, 4);
                var r = Qe (e.data);
                this._frameBuffer.push ({
                  data: t,
                  pts: e.pts,
                  isKeyFrame: $e (r),
                }), this._checkEmitFragment ();
              },
            },
            {
              key: '_checkEmitFragment',
              value: function () {
                for (;;) {
                  var e = this._frameBuffer.pop ();
                  if (!e) break;
                  this._packetQueue.enqueue (e), this._packetQueue.back ().dts -
                    this._packetQueue.front ().dts >
                    30 &&
                    e.isKeyFrame &&
                    (this._packetQueue.clear (), this._packetQueue.enqueue (e));
                }
              },
            },
            {
              key: '_setupDecodeWorker',
              value: function () {
                (this._decodeWorker = new Worker (
                  globalThis.H5SensePlayer.scriptPath + '/decoder.js'
                )), (this._decodeWorker.onmessage = this._onWorkerMessage.bind (
                  this
                )), this._decodeData (), this._decodeWorker.postMessage ({
                  func: 'openDecoder',
                });
              },
            },
            {
              key: '_onWorkerMessage',
              value: function (e) {
                var t = this, r = e.data;
                switch (r.type) {
                  case 'decodeReturn':
                    setTimeout (function () {
                      t._decodeData ();
                    }, 0);
                    break;
                  case 'frameReturn':
                    this._onFrameReturn (r.data.data);
                }
              },
            },
            {
              key: '_decodeData',
              value: function () {
                var e = this;
                if (this._decodeWorker) {
                  var t = this._packetQueue.dequeue ();
                  t
                    ? (this._tsQueue.enqueue ({
                        pts: t.dts,
                        duration: t.duration,
                      }), this._decodeWorker.postMessage (
                        {func: 'decodeData', args: {data: t.data}},
                        [t.data.buffer]
                      ))
                    : setTimeout (function () {
                        e._decodeData ();
                      }, 100);
                }
              },
            },
            {
              key: '_onFrameReturn',
              value: function (e) {
                var t = this._tsQueue.dequeue ();
                this.events.emit (I, {
                  data: e,
                  pts: t.pts,
                  duration: t.duration,
                });
              },
            },
            {
              key: 'destroy',
              value: function () {
                this._decodeWorker &&
                  ((this._decodeWorker.onmessage = null), this._decodeWorker.terminate (), (this._decodeWorker = null));
              },
            },
          ]), n;
        }) (Z);
      function Wt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var zt,
        Xt = (function (t) {
          C (n, t);
          var r = Wt (n);
          function n (t) {
            var i;
            return e (this, n), a (
              A ((i = r.call (this, t))),
              '_status',
              void 0
            ), a (A (i), '_frames', void 0), a (
              A (i),
              '_currentTime',
              void 0
            ), a (A (i), '_lastNotifyUpdateTimeMS', void 0), a (
              A (i),
              '_screen',
              void 0
            ), a (A (i), '_container', void 0), a (
              A (i),
              '_canvas',
              void 0
            ), a (A (i), '_presentedFrames', 0), a (
              A (i),
              '_decoder',
              void 0
            ), i.setLogger ('CanvasPlayer'), (i._container =
              t.container), i._initCanvas (), (i._status = 0), (i._frames = new We.c ()), (i._currentTime = 0), (i._lastNotifyUpdateTimeMS = performance.now ()), i.events.on (
              I,
              function (e) {
                0 == i._status &&
                  ((i._status = 1), i.events.emit (j), i.events.emit (
                    'canplay'
                  )), (4 === i._status && i._frames.size () > 25) ||
                  i._frames.enqueue (e);
              }
            ), (i._decoder = new jt ({
              events: t.events,
              metrics: t.metrics,
            })), i;
          }
          return i (n, [
            {
              key: '_initCanvas',
              value: function () {
                var e = document.createElement ('canvas');
                (e.style.width = '100%'), (e.style.height =
                  '100%'), this._container.appendChild (
                  e
                ), (this._canvas = e), (this._screen = new It ({
                  events: this.options.events,
                  metrics: this.options.metrics,
                  canvas: e,
                }));
              },
            },
            {
              key: '_onTickHandler',
              value: function () {
                if (2 === this._status) {
                  var e = this._frames.dequeue ();
                  if (e) {
                    this._currentTime = e.pts;
                    var t = this.options;
                    this._screen.drawFrame ({
                      width: t.width,
                      height: t.height,
                      data: e.data,
                    }), this
                      ._presentedFrames++, this.metrics.log (
                      Lt.PresentedFrames,
                      {value: this._presentedFrames, time: performance.now ()}
                    ), performance.now () - this._lastNotifyUpdateTimeMS >
                      1e3 &&
                      (this.events.emit (
                        'timeupdate'
                      ), (this._lastNotifyUpdateTimeMS = performance.now ()));
                    var r = e.duration > 0 ? e.duration : 0.1;
                    this._nextTick (r);
                  } else this._nextTick (0.04);
                }
              },
            },
            {
              key: '_nextTick',
              value: function (e) {
                var t = this;
                setTimeout (function () {
                  t._onTickHandler ();
                }, 1e3 * e);
              },
            },
            {
              key: 'play',
              value: function () {
                2 !== this._status &&
                  ((this._status = 2), this._nextTick (0), this.events.emit (
                    'play'
                  ));
              },
            },
            {
              key: 'pause',
              value: function () {
                this._status = 4;
              },
            },
            {
              key: 'destroy',
              value: function () {
                this._decoder &&
                  (this._decoder.destroy (), (this._decoder = null)), this._container.removeChild (
                  this._canvas
                );
              },
            },
            {
              key: 'currentTime',
              get: function () {
                return this._currentTime;
              },
              set: function (e) {
                this._currentTime = e;
              },
            },
            {
              key: 'captureToBlob',
              value: function (e, t, r) {
                this._canvas.toBlob (e, t, r);
              },
            },
          ]), n;
        }) (Z);
      function qt (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      !(function (e) {
        (e.BLOCKED = 'blocked'), (e.RUNNING = 'running'), (e.PAUSE =
          'paused'), (e.DESTORY = 'destroy');
      }) (zt || (zt = {}));
      var Yt = (function (t) {
        C (n, t);
        var r = qt (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            '_context',
            void 0
          ), a (A (i), '_gainNode', void 0), a (A (i), '_vol', void 0), a (
            A (i),
            '_muted',
            void 0
          ), a (A (i), '_flushTime', void 0), a (A (i), '_canplay', void 0), a (
            A (i),
            '_duration',
            0
          ), a (A (i), '_state', zt.BLOCKED), a (
            A (i),
            '_blockedCurrTime',
            0
          ), a (A (i), '_audioSrcNodes', []), a (
            A (i),
            '_playStartedAt',
            void 0
          ), a (A (i), '_totalTimeScheduled', void 0), a (
            A (i),
            '_audioBuffer',
            new ArrayBuffer (0)
          ), a (A (i), '_intervalHandle', void 0), (i._vol =
            t.volume || 1), (i._muted = t.muted), (i._flushTime =
            t.flushTime ||
            400), (i._context = new AudioContext ()), (i._gainNode = i._context.createGain ()), (i._gainNode.gain.value = i._muted
            ? 0
            : i._vol), i._gainNode.connect (
            i._context.destination
          ), i.events.on (
            q,
            i._onData.bind (A (i))
          ), (i._intervalHandle = setInterval (
            i._consumeADTSData.bind (A (i)),
            i._flushTime
          )), i;
        }
        return i (n, [
          {
            key: '_appendByteArray',
            value: function (e, t) {
              var r = new Uint8Array ((0 | e.byteLength) + (0 | t.byteLength));
              return r.set (new Uint8Array (e), 0), r.set (
                new Uint8Array (t),
                0 | e.byteLength
              ), r.buffer;
            },
          },
          {
            key: '_onData',
            value: function (e, t) {
              this._audioBuffer = this._appendByteArray (this._audioBuffer, e);
            },
          },
          {
            key: '_consumeADTSData',
            value: function () {
              var e = this;
              this._audioBuffer &&
                this._audioBuffer.byteLength > 0 &&
                (this._context.decodeAudioData (
                  this._audioBuffer,
                  function (t) {
                    e._onDecodeSuccess (t);
                  },
                  function (t) {
                    e._onDecodeError (t);
                  }
                ), (this._audioBuffer = new ArrayBuffer (0)));
            },
          },
          {
            key: '_setBlockedCurrTime',
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : 0;
              this._blockedCurrTime = e;
              for (var t = 0; t < this._audioSrcNodes.length; t++) {
                var r = this._audioSrcNodes[t].startTime;
                if (e <= 1e3 * r) {
                  var n = this._audioSrcNodes.splice (0, t ? t - 1 : 0);
                  n.forEach (function (e) {
                    var t = e.source;
                    (t.onended = null), t.disconnect ();
                  });
                  break;
                }
              }
            },
          },
          {
            key: '_unblock',
            value: function (e) {
              if (this._state == zt.BLOCKED) {
                (this._state =
                  zt.RUNNING), this.resume (), this._setBlockedCurrTime (
                  e
                ), (this._playStartedAt = 0), (this._totalTimeScheduled = 0);
                for (var t = 0; t < this._audioSrcNodes.length; t++) {
                  var r = this._audioSrcNodes[t],
                    n = r.source,
                    i = r.startTime,
                    a = r.duration;
                  (n.onended = null), n.disconnect ();
                  var s = this._context.createBufferSource ();
                  if (
                    ((s.onended = this._onAudioBufferEnded.bind (this)), !this
                      ._playStartedAt)
                  ) {
                    var o = this._context,
                      u = o.currentTime,
                      c = o.baseLatency,
                      l = o.sampleRate,
                      h = a + (c || 128 / l);
                    this._playStartedAt = u + h;
                  }
                  s.buffer = n.buffer;
                  try {
                    s.connect (this._gainNode), s.start (
                      this._totalTimeScheduled + this._playStartedAt,
                      t ? 0 : e / 1e3 - i
                    );
                  } catch (e) {}
                  (this._audioSrcNodes[t].source = s), (this._audioSrcNodes[
                    t
                  ].startTime = this._totalTimeScheduled), (this._totalTimeScheduled += a);
                }
              }
            },
          },
          {
            key: 'play',
            value: function () {
              this._unblock (0);
            },
          },
          {
            key: 'pause',
            value: function () {
              if (this._state != zt.PAUSE)
                return (this._state = zt.PAUSE), this._context
                  ? this._context.suspend ()
                  : Promise.resolve ();
            },
          },
          {
            key: 'resume',
            value: function () {
              if (this._state != zt.RUNNING)
                return (this._state = zt.RUNNING), this._context
                  ? this._context.resume ()
                  : Promise.resolve ();
            },
          },
          {
            key: 'currentTime',
            get: function () {
              return this._context
                ? this._state == zt.BLOCKED
                    ? this._blockedCurrTime
                    : this._context.currentTime - this._playStartedAt
                : 0;
            },
          },
          {
            key: 'getAvaiableDuration',
            value: function () {
              return this._duration;
            },
          },
          {
            key: '_onDecodeSuccess',
            value: function (e) {
              this._canplay ||
                ((this._canplay = !0), this.events.emit (G, this));
              var t = this._context.createBufferSource ();
              if (
                ((t.onended = this._onAudioBufferEnded.bind (this)), !this
                  ._playStartedAt)
              ) {
                var r = e.duration,
                  n = this._context,
                  i = n.currentTime,
                  a = n.baseLatency,
                  s = n.sampleRate,
                  o = r + (a || 128 / s);
                this._playStartedAt = i + o;
              }
              if (((t.buffer = e), this._state == zt.RUNNING))
                try {
                  t.connect (this._gainNode), t.start (
                    this._totalTimeScheduled + this._playStartedAt
                  );
                } catch (e) {}
              this._audioSrcNodes.push ({
                source: t,
                duration: e.duration,
                startTime: this._totalTimeScheduled,
              }), (this._totalTimeScheduled += e.duration), (this._duration +=
                e.duration);
            },
          },
          {
            key: '_onDecodeError',
            value: function (e) {
              this.events.emit (W, e);
            },
          },
          {
            key: '_onAudioBufferEnded',
            value: function () {
              this._audioSrcNodes.shift ().source.disconnect ();
            },
          },
          {
            key: 'buffered',
            value: function () {
              var e = 0;
              this._audioSrcNodes.length > 0 &&
                (e = this._audioSrcNodes[0].startTime);
              return {start: 1e3 * e, end: 1e3 * this._totalTimeScheduled};
            },
          },
          {
            key: 'destroy',
            value: function () {
              this._intervalHandle &&
                (clearInterval (
                  this._intervalHandle
                ), (this._intervalHandle = null));
            },
          },
        ]), n;
      }) (Z);
      function Kt (e) {
        for (var t = new Uint8Array (e.length), r = 0; r < e.length; r++)
          t[r] = e.charCodeAt (r);
        return t;
      }
      var Qt = {
        ftyp: Kt ('ftyp'),
        moov: Kt ('moov'),
        mvhd: Kt ('mvhd'),
        trak: Kt ('trak'),
        tkhd: Kt ('tkhd'),
        mdia: Kt ('mdia'),
        mdhd: Kt ('mdhd'),
        hdlr: Kt ('hdlr'),
        minf: Kt ('minf'),
        vmhd: Kt ('vmhd'),
        smhd: Kt ('smhd'),
        dinf: Kt ('dinf'),
        dref: Kt ('dref'),
        url: Kt ('url '),
        stbl: Kt ('stbl'),
        stsd: Kt ('stsd'),
        avc1: Kt ('avc1'),
        avcC: Kt ('avcC'),
        hvc1: Kt ('hvc1'),
        hvcC: Kt ('hvcC'),
        btrt: Kt ('btrt'),
        stts: Kt ('stts'),
        stsc: Kt ('stsc'),
        stsz: Kt ('stsz'),
        stco: Kt ('stco'),
        mvex: Kt ('mvex'),
        trex: Kt ('trex'),
        moof: Kt ('moof'),
        mfhd: Kt ('mfhd'),
        traf: Kt ('traf'),
        tfhd: Kt ('tfhd'),
        tfdt: Kt ('tfdt'),
        trun: Kt ('trun'),
        sdtp: Kt ('sdtp'),
        mdat: Kt ('mdat'),
      },
        $t = new Uint8Array ([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          118,
          105,
          100,
          101,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          86,
          105,
          100,
          101,
          111,
          72,
          97,
          110,
          100,
          108,
          101,
          114,
          0,
        ]),
        Jt = new Uint8Array ([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          115,
          111,
          117,
          110,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          83,
          111,
          117,
          110,
          100,
          72,
          97,
          110,
          100,
          108,
          101,
          114,
          0,
        ]),
        Zt = {};
      function er (e, t) {
        var r =
          !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          n = Zt[e];
        return n || ((n = t ()), (Zt[e] = n)), r ? new Uint8Array (n) : n;
      }
      function tr (e) {
        for (
          var t = arguments.length, r = new Array (t > 1 ? t - 1 : 0), n = 1;
          n < t;
          n++
        )
          r[n - 1] = arguments[n];
        for (var i = 8, a = r.length, s = a; a--; )
          i += r[a].byteLength;
        var o = new Uint8Array (i);
        for (
          (o[0] = (i >> 24) & 255), (o[1] = (i >> 16) & 255), (o[2] =
            (i >> 8) & 255), (o[3] = 255 & i), o.set (e, 4), (a = 0), (i = 8);
          a < s;
          ++a
        )
          o.set (r[a], i), (i += r[a].byteLength);
        return o;
      }
      function rr (e) {
        var t = Kt ('isom'), r = new Uint8Array ([0, 0, 0, 1]), n = [t];
        return e ? n.push (Kt ('avc1')) : n.push (Kt ('hvc1')), tr.apply (
          void 0,
          [Qt.ftyp, t, r].concat (n)
        );
      }
      function nr (e) {
        return tr (
          Qt.moov,
          (function (e, t) {
            t = 0;
            var r = er ('mvhd', function () {
              return new Uint8Array ([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                0,
                255,
                255,
                255,
                255,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                64,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                255,
                255,
                255,
                255,
              ]);
            }),
              n = new DataView (r.buffer, r.byteOffset, r.byteLength);
            return n.setUint32 (12, e), n.setUint32 (16, t), tr (Qt.mvhd, r);
          }) (e.timescale, e.duration),
          (function (e) {
            return (e.duration = e.duration || 4294967295), tr (
              Qt.trak,
              (function (e) {
                var t = er ('tkhd', function () {
                  return new Uint8Array ([
                    0,
                    0,
                    0,
                    7,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                  ]);
                }),
                  r = new DataView (t.buffer, t.byteOffset, t.byteLength);
                r.setUint32 (12, 1), r.setUint32 (20, e.duration), e.type ===
                  lt.AUDIO && r.setUint8 (36, 1);
                e.type === lt.VIDEO &&
                  (r.setUint16 (76, e.width), r.setUint16 (80, e.height));
                return tr (Qt.tkhd, t);
              }) (e),
              (function (e) {
                return tr (
                  Qt.mdia,
                  ((n = e.timescale), (i =
                    e.duration), (a = er ('mdhd', function () {
                    return new Uint8Array ([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      2,
                      0,
                      0,
                      0,
                      3,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      85,
                      196,
                      0,
                      0,
                    ]);
                  })), (s = new DataView (
                    a.buffer,
                    a.byteOffset,
                    a.byteLength
                  )), s.setUint32 (12, n), s.setUint32 (16, i), tr (
                    Qt.mdhd,
                    a
                  )),
                  ((t = e.type), (r = t === lt.VIDEO ? $t : Jt), tr (
                    Qt.hdlr,
                    r
                  )),
                  (function (e) {
                    if (e.type === lt.VIDEO)
                      return tr (
                        Qt.minf,
                        er (
                          'vmhd',
                          function () {
                            var e = new Uint8Array ([
                              0,
                              0,
                              0,
                              1,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                            ]);
                            return tr (Qt.vmhd, e);
                          },
                          !1
                        ),
                        or (),
                        ir (e)
                      );
                    if (e.type === lt.AUDIO)
                      return tr (
                        Qt.minf,
                        er (
                          'smhd',
                          function () {
                            var e = new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
                            return tr (Qt.smhd, e);
                          },
                          !1
                        ),
                        or (),
                        ir (e)
                      );
                    return null;
                  }) (e)
                );
                var t, r;
                var n, i, a, s;
              }) (e)
            );
          }) (e),
          (function (e) {
            return tr (
              Qt.mvex,
              (function (e) {
                var t = er ('trex', function () {
                  return new Uint8Array ([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                  ]);
                });
                return new DataView (t.buffer).setUint32 (4, e), tr (
                  Qt.trex,
                  t
                );
              }) (e)
            );
          }) (1)
        );
      }
      function ir (e) {
        return tr (
          Qt.stbl,
          (function (e) {
            var t = er (
              'stsd',
              function () {
                return new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 1]);
              },
              !1
            ),
              r = null;
            switch (e.codec) {
              case ht.H264:
                r = (function (e) {
                  return tr (
                    Qt.avc1,
                    sr (e.width, e.height),
                    (function (e, t) {
                      var r = 0, n = 0;
                      e.forEach (function (e) {
                        r += 2 + e.length;
                      }), t.forEach (function (e) {
                        n += 2 + e.length;
                      });
                      var i = new Uint8Array (7 + r + n);
                      (i[0] = 1), (i[1] = e[0][1]), (i[2] = e[0][2]), (i[3] =
                        e[0][3]), (i[4] = 255), (i[5] = 224 | e.length);
                      var a = 6;
                      return e.forEach (function (e) {
                        (i[a] =
                          (e.length >>> 8) &
                          255), (i[a + 1] = 255 & e.length), i.set (e, a + 2), (a += 2 + e.length);
                      }), (i[a] = t.length), (a += 1), t.forEach (function (e) {
                        (i[a] =
                          (e.length >>> 8) &
                          255), (i[a + 1] = 255 & e.length), i.set (e, a + 2), (a += 2 + e.length);
                      }), tr (Qt.avcC, i);
                    }) (e.spsList, e.ppsList),
                    er (
                      'btrt',
                      function () {
                        var e = new Uint8Array ([
                          0,
                          28,
                          156,
                          128,
                          0,
                          45,
                          198,
                          192,
                          0,
                          45,
                          198,
                          192,
                        ]);
                        return tr (Qt.btrt, e);
                      },
                      !1
                    )
                  );
                }) (e);
                break;
              case ht.H265:
                r = (function (e) {
                  return tr (
                    Qt.hvc1,
                    sr (e.width, e.height),
                    (function (e, t, r) {
                      var n = at (t[0]),
                        i = (function (e) {
                          var t = je (e), r = new Te (t);
                          r.readBits (16);
                          var n = new ut ();
                          return r.readUEG (), r.readUEG (), r.skipBits (
                            7
                          ), r.readUEG (), r.readUEG (), r.readEG (), r.skipBits (
                            2
                          ), r.readBoolean () &&
                            r.readUEG (), r.readEG (), r.readEG (), r.skipBits (
                            4
                          ), (n.tilesEnableFlag = r.readBoolean ()), (n.entropyCodingSyncEnabledFlag = r.readBoolean ()), n;
                        }) (r[0]),
                        a = new Ue ();
                      a.write (1, 8), a.write (
                        n.ptl.generalPTL.profileSpace,
                        2
                      ), a.write (n.ptl.generalPTL.tierFlag, 1), a.write (
                        n.ptl.generalPTL.profileIdc,
                        5
                      ), a.write (
                        n.ptl.generalPTL.profileCompatibilityFlags,
                        32
                      ), a.write (
                        n.ptl.generalPTL.constraintIndicatorFlags,
                        48
                      ), a.write (n.ptl.generalPTL.levelIdc, 8), a.write (
                        61440 | n.vui.minSpatialSegmentationIdc,
                        16
                      );
                      var s = 0;
                      n.vui.minSpatialSegmentationIdc &&
                        (s = i.entropyCodingSyncEnabledFlag && i.tilesEnableFlag
                          ? 0
                          : i.entropyCodingSyncEnabledFlag
                              ? 3
                              : i.tilesEnableFlag ? 2 : 1);
                      return a.write (252 | s, 8), a.write (
                        252 | n.chromaFormatIdc,
                        8
                      ), a.write (248 | n.bitDepthLumaMinus8, 8), a.write (
                        248 | n.bitDepthChromaMinus8,
                        8
                      ), a.write (0, 16), a.write (0, 2), a.write (
                        n.maxSubLayerMinus1 + 1,
                        3
                      ), a.write (n.temporalIdNestedFlag ? 1 : 0, 1), a.write (
                        3,
                        2
                      ), a.write (3, 8), a.writeBit (1), a.writeBit (
                        0
                      ), a.write (Xe.HEVC_NAL_VPS, 6), a.write (
                        e.length,
                        16
                      ), e.forEach (function (e) {
                        a.write (e.length, 16), e.forEach (function (e) {
                          a.write (e, 8);
                        });
                      }), a.writeBit (1), a.writeBit (0), a.write (
                        Xe.HEVC_NAL_SPS,
                        6
                      ), a.write (t.length, 16), t.forEach (function (e) {
                        a.write (e.length, 16), e.forEach (function (e) {
                          a.write (e, 8);
                        });
                      }), a.writeBit (1), a.writeBit (0), a.write (
                        Xe.HEVC_NAL_PPS,
                        6
                      ), a.write (r.length, 16), r.forEach (function (e) {
                        a.write (e.length, 16), e.forEach (function (e) {
                          a.write (e, 8);
                        });
                      }), tr (Qt.hvcC, a.bytes ());
                    }) (e.vpsList, e.spsList, e.ppsList)
                  );
                }) (e);
                break;
              case ht.AAC:
                r = null;
            }
            return tr (Qt.stsd, t, r);
          }) (e),
          er (
            'stts',
            function () {
              var e = new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
              return tr (Qt.stts, e);
            },
            !1
          ),
          er (
            'stsc',
            function () {
              var e = new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
              return tr (Qt.stsc, e);
            },
            !1
          ),
          er (
            'stsz',
            function () {
              var e = new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
              return tr (Qt.stsz, e);
            },
            !1
          ),
          er (
            'stco',
            function () {
              var e = new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
              return tr (Qt.stco, e);
            },
            !1
          )
        );
      }
      function ar () {
        return er (
          'SampleEntry',
          function () {
            return new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 1]);
          },
          !1
        );
      }
      function sr (e, t) {
        var r = er ('VisualSampleEntry', function () {
          return new Uint8Array ([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            72,
            0,
            0,
            0,
            72,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            18,
            98,
            105,
            110,
            101,
            108,
            112,
            114,
            111,
            46,
            114,
            117,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            24,
            17,
            17,
          ]);
        }),
          n = new DataView (r.buffer);
        return n.setUint16 (16, e), n.setUint16 (18, t), Le (ar (), r);
      }
      function or () {
        return er (
          'dinf',
          function () {
            return tr (
              Qt.dinf,
              er (
                'dref',
                function () {
                  var e = new Uint8Array ([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    12,
                    117,
                    114,
                    108,
                    32,
                    0,
                    0,
                    0,
                    1,
                  ]);
                  return tr (Qt.dref, e);
                },
                !1
              )
            );
          },
          !1
        );
      }
      function ur (e, t, r) {
        return tr (
          Qt.moof,
          (function (e) {
            var t = er ('mfhd', function () {
              return new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
            });
            return new DataView (t.buffer).setUint32 (4, e), tr (Qt.mfhd, t);
          }) (e),
          (function (e, t, r) {
            var n = (function (e) {
              for (
                var t = new Uint8Array (4 + e.length), r = 0;
                r < e.length;
                r++
              ) {
                var n = e[r];
                t[r + 4] =
                  (n.isLeading << 6) |
                  (n.dependsOn << 4) |
                  (n.isDependedOn << 2) |
                  n.hasRedundancy;
              }
              return tr (Qt.sdtp, t);
            }) (t),
              i = (function (e) {
                var t = er ('tfhd', function () {
                  return new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
                });
                return new DataView (t.buffer).setUint32 (4, e), tr (
                  Qt.tfhd,
                  t
                );
              }) (e),
              a = (function (e) {
                var t = er ('tfdt', function () {
                  return new Uint8Array ([0, 0, 0, 0, 0, 0, 0, 0]);
                });
                return new DataView (t.buffer).setUint32 (4, e), tr (
                  Qt.tfdt,
                  t
                );
              }) (r),
              s = (function (e, t) {
                var r = e.length,
                  n = 12 + 16 * r,
                  i = new Uint8Array (n),
                  a = t + 8 + n;
                i.set (
                  [
                    0,
                    0,
                    15,
                    1,
                    (r >>> 24) & 255,
                    (r >>> 16) & 255,
                    (r >>> 8) & 255,
                    255 & r,
                    (a >>> 24) & 255,
                    (a >>> 16) & 255,
                    (a >>> 8) & 255,
                    255 & a,
                  ],
                  0
                );
                for (var s = 0; s < r; s++) {
                  var o = e[s], u = o.duration, c = o.size, l = o, h = o.cts;
                  i.set (
                    [
                      (u >>> 24) & 255,
                      (u >>> 16) & 255,
                      (u >>> 8) & 255,
                      255 & u,
                      (c >>> 24) & 255,
                      (c >>> 16) & 255,
                      (c >>> 8) & 255,
                      255 & c,
                      (l.isLeading << 2) | l.dependsOn,
                      (l.isDependedOn << 6) |
                        (l.hasRedundancy << 4) |
                        l.isNonSync,
                      0,
                      0,
                      (h >>> 24) & 255,
                      (h >>> 16) & 255,
                      (h >>> 8) & 255,
                      255 & h,
                    ],
                    12 + 16 * s
                  );
                }
                return tr (Qt.trun, i);
              }) (t, 32 + i.length + a.length + n.length + 8);
            return tr (Qt.traf, i, a, s, n);
          }) (1, r, t)
        );
      }
      function cr (e) {
        return tr (Qt.mdat, e);
      }
      function lr (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var hr = (function (t) {
        C (n, t);
        var r = lr (n);
        function n (t) {
          var i;
          e (this, n), a (A ((i = r.call (this, t))), '_sps', void 0), a (
            A (i),
            '_pps',
            void 0
          ), a (A (i), '_sn', 0), a (A (i), '_timescale', 1e3), a (
            A (i),
            '_frameBuffer',
            void 0
          ), (i._frameBuffer = new Ft ({maxReorderFrame: 16}));
          var s = function (e) {
            i._onRBSP (e.data, e.pts);
          };
          return i.events.on (X, function e (r) {
            var n = Oe (r.data);
            switch (n) {
              case Be.H264_NAL_SPS:
                i._sps = r.data;
                break;
              case Be.H264_NAL_PPS:
                i._pps = r.data;
            }
            if (Fe (n) && i._sps && i._pps) {
              var a = {
                data: Le (
                  rr (!0),
                  nr ({
                    type: lt.VIDEO,
                    codec: ht.H264,
                    duration: 0,
                    timescale: i._timescale,
                    width: t.width,
                    height: t.height,
                    spsList: [i._sps],
                    ppsList: [i._pps],
                  })
                ),
                isInit: !0,
              };
              i.events.emit (V, a), i._onRBSP (r.data, r.pts), i.events.off (
                X,
                e
              ), i.events.on (X, s);
            }
          }), i;
        }
        return i (n, [
          {
            key: '_onRBSP',
            value: function (e, t) {
              var r = new Uint8Array (4 + e.length);
              new DataView (r.buffer).setUint32 (0, e.length), r.set (e, 4);
              var n = Oe (e);
              this._frameBuffer.push ({
                data: r,
                pts: t,
                isKeyFrame: Fe (n),
              }), this._chekEmitFragments ();
            },
          },
          {
            key: '_chekEmitFragments',
            value: function () {
              for (;;) {
                var e = this._frameBuffer.pop ();
                if (!e) break;
                var t = {
                  isLeading: 0,
                  dependsOn: 0,
                  isDependedOn: 0,
                  isNonSync: 0,
                  hasRedundancy: 0,
                  duration: e.duration * this._timescale,
                  size: e.data.length,
                  cts: (e.pts - e.dts) * this._timescale,
                };
                e.isKeyFrame
                  ? ((t.dependsOn = 2), (t.isNonSync = 0))
                  : ((t.dependsOn = 1), (t.isNonSync = 1));
                var r = {
                  data: Le (
                    ur (++this._sn, e.dts * this._timescale, [t]),
                    cr (e.data)
                  ),
                  isKeyFrame: e.isKeyFrame,
                };
                this.events.emit (V, r);
              }
            },
          },
          {key: 'destroy', value: function () {}},
        ]), n;
      }) (Z);
      function fr (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      var dr,
        pr = (function (t) {
          C (n, t);
          var r = fr (n);
          function n (t) {
            var i;
            e (this, n), a (A ((i = r.call (this, t))), '_vps', void 0), a (
              A (i),
              '_sps',
              void 0
            ), a (A (i), '_pps', void 0), a (A (i), '_sn', 0), a (
              A (i),
              '_timescale',
              1e3
            ), a (A (i), '_frameBuffer', void 0), (i._frameBuffer = new Ft ({
              maxReorderFrame: 16,
            }));
            var s = function (e) {
              i._onRBSP (e.data, e.pts);
            };
            return i.events.on (X, function e (r) {
              var n = Qe (r.data);
              switch (n) {
                case Xe.HEVC_NAL_VPS:
                  i._vps = r.data;
                  break;
                case Xe.HEVC_NAL_SPS:
                  i._sps = r.data;
                  break;
                case Xe.HEVC_NAL_PPS:
                  i._pps = r.data;
              }
              if ($e (n) && i._sps && i._pps && i._vps) {
                var a = {
                  data: Le (
                    rr (!0),
                    nr ({
                      type: lt.VIDEO,
                      codec: ht.H265,
                      duration: 0,
                      timescale: i._timescale,
                      width: t.width,
                      height: t.height,
                      vpsList: [i._vps],
                      spsList: [i._sps],
                      ppsList: [i._pps],
                    })
                  ),
                  isInit: !0,
                };
                i.events.emit (V, a), i._onRBSP (r.data, r.pts), i.events.off (
                  X,
                  e
                ), i.events.on (X, s);
              }
            }), i;
          }
          return i (n, [
            {
              key: '_onRBSP',
              value: function (e, t) {
                var r = new Uint8Array (4 + e.length);
                new DataView (r.buffer).setUint32 (0, e.length), r.set (e, 4);
                var n = Qe (e);
                this._frameBuffer.push ({
                  data: r,
                  pts: t,
                  isKeyFrame: $e (n),
                }), this._chekEmitFragments ();
              },
            },
            {
              key: '_chekEmitFragments',
              value: function () {
                for (;;) {
                  var e = this._frameBuffer.pop ();
                  if (!e) break;
                  var t = {
                    isLeading: 0,
                    dependsOn: 0,
                    isDependedOn: 0,
                    isNonSync: 0,
                    hasRedundancy: 0,
                    duration: e.duration * this._timescale,
                    size: e.data.length,
                    cts: (e.pts - e.dts) * this._timescale,
                  };
                  e.isKeyFrame
                    ? ((t.dependsOn = 2), (t.isNonSync = 0))
                    : ((t.dependsOn = 1), (t.isNonSync = 1));
                  var r = {
                    data: Le (
                      ur (++this._sn, e.dts * this._timescale, [t]),
                      cr (e.data)
                    ),
                    isKeyFrame: e.isKeyFrame,
                  };
                  this.events.emit (V, r);
                }
              },
            },
            {key: 'destroy', value: function () {}},
          ]), n;
        }) (Z);
      function _r (e) {
        var t = (function () {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call (
              Reflect.construct (Boolean, [], function () {})
            ), !0;
          } catch (e) {
            return !1;
          }
        }) ();
        return function () {
          var r, n = k (e);
          if (t) {
            var i = k (this).constructor;
            r = Reflect.construct (n, arguments, i);
          } else r = n.apply (this, arguments);
          return L (this, r);
        };
      }
      !(function (e) {
        (e.INIT = 'init'), (e.PLAYING = 'playing'), (e.PAUSE =
          'pause'), (e.END = 'end');
      }) (dr || (dr = {}));
      var vr = (function (t) {
        C (n, t);
        var r = _r (n);
        function n (t) {
          var i;
          return e (this, n), a (
            A ((i = r.call (this, t))),
            'status',
            dr.INIT
          ), a (A (i), '_demuxer', void 0), a (A (i), '_oobPuller', void 0), a (
            A (i),
            '_videoPlayer',
            void 0
          ), a (A (i), '_audioPlayer', void 0), a (A (i), '_muxer', void 0), a (
            A (i),
            '_width',
            void 0
          ), a (A (i), '_height', void 0), a (
            A (i),
            '_videoProbeMeta',
            void 0
          ), a (A (i), '_audioProbeMeta', void 0), a (
            A (i),
            '_videoCanPlay',
            void 0
          ), a (A (i), '_audioCanPlay', void 0), i.setLogger (
            'PlayerControl'
          ), (i._demuxer = new mt ({
            events: t.events,
            metrics: t.metrics,
            url: t.url,
            socketurl: t.socketurl,
            enableAudio: t.enableAudio,
          })), (i._oobPuller = new re ({
            events: t.events,
            metrics: t.metrics,
          })), t.enableAudio ||
            ((i._audioProbeMeta = new pt ()), (i._audioCanPlay = !0)), i._registerEvents (), i._demuxer.start (), i;
        }
        return i (n, [
          {
            key: '_registerEvents',
            value: function () {
              var e = this;
              this.options;
              this.events.on (Y, function (t) {
                e._onVideoProbeDone (t);
              }), this.events.on (K, function (t) {
                e._onAudioProbeDone (t);
              }), this.events.on (G, function () {
                (e._audioCanPlay = !0), e._checkplay ();
              });
            },
          },
          {
            key: '_onAudioProbeDone',
            value: function (e) {
              if (
                ((this._audioProbeMeta = e), this._checkEmitMediaInfo (), e.codec)
              ) {
                var t = this.options;
                this._audioPlayer = new Yt ({
                  events: t.events,
                  metrics: t.metrics,
                  volume: t.volume,
                  muted: t.muted,
                });
              }
            },
          },
          {
            key: '_checkEmitMediaInfo',
            value: function () {
              if (this._audioProbeMeta && this._videoProbeMeta) {
                var e = {
                  video: {
                    width: this._videoProbeMeta.width,
                    height: this._videoProbeMeta.height,
                    codec: this._videoProbeMeta.codec,
                  },
                  audio: this._audioProbeMeta,
                };
                this.events.emit (O, e);
              }
            },
          },
          {
            key: '_checkplay',
            value: function () {
              this._audioCanPlay &&
                this._videoCanPlay &&
                (this._audioPlayer &&
                  this._audioPlayer.play (), this._videoPlayer.play ());
            },
          },
          {
            key: '_onVideoProbeDone',
            value: function (e) {
              var t = this;
              (this._videoProbeMeta = e), this._checkEmitMediaInfo ();
              var r = this.options;
              (this._width = e.width), (this._height =
                e.height), Ct.isSupported ([e.codecStr])
                ? ((this._videoPlayer = new Tt ({
                    events: r.events,
                    metrics: r.metrics,
                    container: r.container,
                    width: e.width,
                    height: e.height,
                    codecStr: e.codecStr,
                  })), 'h264' === e.codec
                    ? (this._muxer = new hr ({
                        events: r.events,
                        metrics: r.metrics,
                        width: e.width,
                        height: e.height,
                      }))
                    : 'hevc' === e.codec
                        ? (this._muxer = new pr ({
                            events: r.events,
                            metrics: r.metrics,
                            width: e.width,
                            height: e.height,
                          }))
                        : this.logger.error ('unsupported codec'))
                : (this._videoPlayer = new Xt ({
                    events: r.events,
                    metrics: r.metrics,
                    container: r.container,
                    width: e.width,
                    height: e.height,
                    codec: e.codec,
                  })), this._videoPlayer.on (j, function () {
                (t._videoCanPlay = !0), t._checkplay ();
              }), this.events.emit (Q);
            },
          },
          {
            key: 'pullOOBData',
            value: function (e) {
              return this.status != dr.PLAYING
                ? null
                : this._oobPuller.pullOOBData (e);
            },
          },
          {
            key: 'play',
            value: function () {
              this.status != dr.PLAYING &&
                (this.events.emit (F, this), (this.status = dr.PLAYING), this
                  ._audioPlayer && this._audioPlayer.play (), this
                  ._videoPlayer && this._videoPlayer.play ());
            },
          },
          {
            key: 'pause',
            value: function () {
              this.status != dr.PAUSE &&
                (this.events.emit (M, this), (this.status = dr.PAUSE), this
                  ._audioPlayer && this._audioPlayer.pause (), this
                  ._videoPlayer && this._videoPlayer.pause ());
            },
          },
          {
            key: 'currentTime',
            get: function () {
              return this._videoPlayer ? this._videoPlayer.currentTime : 0;
            },
          },
          {
            key: 'getStatus',
            value: function () {
              return this.status;
            },
          },
          {
            key: 'videoWidth',
            get: function () {
              return this._width;
            },
          },
          {
            key: 'videoHeight',
            get: function () {
              return this._height;
            },
          },
          {
            key: 'snapshot',
            value: function (e, t, r) {
              this._videoPlayer && this._videoPlayer.captureToBlob (e, t, r);
            },
          },
          {
            key: 'getMetrics',
            value: function () {
              return this.metrics.getAll ();
            },
          },
          {
            key: 'destroy',
            value: function () {
              this._demuxer &&
                (this._demuxer.destroy (), (this._demuxer = null)), this
                ._videoPlayer &&
                (this._videoPlayer.destroy (), (this._videoPlayer = null)), this
                ._audioPlayer &&
                (this._audioPlayer.destroy (), (this._audioPlayer = null)), this
                ._muxer && (this._muxer.destroy (), (this._muxer = null));
            },
          },
        ]), n;
      }) (Z),
        gr = r (729),
        yr = r.n (gr);
      function mr (e, t) {
        var r = Object.keys (e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols (e);
          t &&
            (n = n.filter (function (t) {
              return Object.getOwnPropertyDescriptor (e, t).enumerable;
            })), r.push.apply (r, n);
        }
        return r;
      }
      var br = (function () {
        function t (r) {
          e (this, t), a (this, '_control', void 0), a (
            this,
            '_globalEvents',
            void 0
          ), (S.wasmDebugMode = r.wasmDebugMode);
          try {
            console.info (
              '%cPlayer: '
                .concat ('@sensetime/h5_sense_player', '@')
                .concat ('0.3.1'),
              'color: #3ba776'
            );
          } catch (e) {}
          (this._globalEvents = new (yr ()) ()), (this._control = new vr (
            (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? mr (Object (r), !0).forEach (function (t) {
                      a (e, t, r[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties (
                          e,
                          Object.getOwnPropertyDescriptors (r)
                        )
                      : mr (Object (r)).forEach (function (t) {
                          Object.defineProperty (
                            e,
                            t,
                            Object.getOwnPropertyDescriptor (r, t)
                          );
                        });
              }
              return e;
            }) ({events: this._globalEvents, metrics: new Lt ()}, r)
          ));
        }
        return i (
          t,
          [
            {
              key: 'pullOOBData',
              value: function (e) {
                return this._control.pullOOBData (e);
              },
            },
            {
              key: 'play',
              value: function () {
                this._control.play ();
              },
            },
            {
              key: 'pause',
              value: function () {
                this._control.pause ();
              },
            },
            {
              key: 'status',
              get: function () {
                return this._control.getStatus ();
              },
            },
            {
              key: 'currentTime',
              get: function () {
                return this._control.currentTime;
              },
            },
            {
              key: 'duration',
              get: function () {
                return 1 / 0;
              },
            },
            {
              key: 'stop',
              value: function () {
                this._control.destroy (), this._globalEvents.removeAllListeners ();
              },
            },
            {
              key: 'videoWidth',
              get: function () {
                return this._control.videoWidth;
              },
            },
            {
              key: 'videoHeight',
              get: function () {
                return this._control.videoHeight;
              },
            },
            {
              key: 'snapshot',
              value: function (e, t, r) {
                this._control.snapshot (e, t, r);
              },
            },
            {
              key: 'getMetrics',
              value: function () {
                return this._control.getMetrics ();
              },
            },
            {
              key: 'once',
              value: function (e, t) {
                return this._control.once (e, t), this;
              },
            },
            {
              key: 'on',
              value: function (e, t) {
                return this._control.on (e, t), this;
              },
            },
            {
              key: 'off',
              value: function (e, t) {
                return this._control.off (e, t), this;
              },
            },
          ],
          [
            {
              key: 'overlayRenderer',
              get: function () {
                return x;
              },
            },
          ]
        ), t;
      }) ();
      (globalThis.H5SensePlayer = br), Object.defineProperty (
        globalThis.H5SensePlayer,
        'scriptPath',
        {
          value: document.currentScript.src
            .split ('/')
            .slice (0, -1)
            .join ('/'),
          writable: !1,
          enumerable: !1,
        }
      );
      const Er = br;
    }) (), n;
  }) ();
});
